(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6885],{

/***/ 96141:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X$": function() { return /* binding */ fetchArticlesByTags; },
/* harmony export */   "dY": function() { return /* binding */ fetchEntriesByTags; },
/* harmony export */   "u_": function() { return /* binding */ createContentfulClient; },
/* harmony export */   "x5": function() { return /* binding */ fetchEntriesById; },
/* harmony export */   "yR": function() { return /* binding */ fetchEntryById; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97582);
/* harmony import */ var contentful__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91307);
/* harmony import */ var components_globals__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35480);
/* provided dependency */ var process = __webpack_require__(34155);






// guards against an unset DEPLOY_ENV variable or a mistakenly
// named DEPLOY_ENV variable (oopsproduction)
// We'll fallback to standard environment if we're not explicitly
// in a non-production environment
// Later this function can take the request context if we want to
// do cookie-based previews
var checkIfPreview = function() {
    return components_globals__WEBPACK_IMPORTED_MODULE_1__/* .DEPLOY_ENV */ .Zp && [
        "staging",
        "development",
        "qa",
        "test"
    ].includes(components_globals__WEBPACK_IMPORTED_MODULE_1__/* .DEPLOY_ENV */ .Zp);
};
var createContentfulClient = function() {
    var isPreview = checkIfPreview();
    var contentfulClientOpts = null;
    if (isPreview) {
        contentfulClientOpts = {
            accessToken: process.env.CONTENTFUL_DELIVERY_PREVIEW_ACCESS_TOKEN,
            host: "preview.contentful.com",
            space: process.env.CONTENTFUL_SPACE_ID,
            environment: process.env.CONTENTFUL_ENVIRONMENT
        };
    } else {
        contentfulClientOpts = {
            accessToken: process.env.CONTENTFUL_DELIVERY_ACCESS_TOKEN,
            space: process.env.CONTENTFUL_SPACE_ID
        };
    }
    return contentful__WEBPACK_IMPORTED_MODULE_0__/* .createClient */ .e(contentfulClientOpts);
};
function fetchEntriesByTags(contentType, tags) {
    return _fetchEntriesByTags.apply(this, arguments);
}
function _fetchEntriesByTags() {
    _fetchEntriesByTags = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(contentType, tags) {
        var options, limit, select, skip, order, _include, include, client, response, safeEntry;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    options = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : {};
                    if (tags === undefined) {
                        return [
                            2,
                            {
                                total: 0,
                                items: []
                            }
                        ];
                    }
                    limit = options.limit, select = options.select, skip = options.skip, order = options.order, _include = options.include, include = _include === void 0 ? 2 : _include;
                    client = createContentfulClient();
                    return [
                        4,
                        client.getEntries((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
                            content_type: contentType,
                            include: include,
                            "metadata.tags.sys.id[in]": tags.join(",")
                        }, order && {
                            order: order
                        }, select && {
                            select: select
                        }, limit && {
                            limit: limit
                        }, skip && {
                            skip: skip
                        }))
                    ];
                case 1:
                    response = _state.sent();
                    if (response.total === 0) {
                        return [
                            2,
                            {
                                total: 0,
                                items: []
                            }
                        ];
                    }
                    safeEntry = JSON.parse(response.stringifySafe());
                    return [
                        2,
                        {
                            total: safeEntry.total,
                            items: safeEntry.items
                        }
                    ];
            }
        });
    });
    return _fetchEntriesByTags.apply(this, arguments);
}
function fetchArticlesByTags(tags) {
    return _fetchArticlesByTags.apply(this, arguments);
}
function _fetchArticlesByTags() {
    _fetchArticlesByTags = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(tags) {
        var options;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            options = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
            return [
                2,
                fetchEntriesByTags("article", tags, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, options), {
                    order: "-fields.publishDate"
                }))
            ];
        });
    });
    return _fetchArticlesByTags.apply(this, arguments);
}
function fetchEntryById(content_type, id) {
    return _fetchEntryById.apply(this, arguments);
}
function _fetchEntryById() {
    _fetchEntryById = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(content_type, id) {
        var options, select, include, client, response, safeEntry, entry;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    options = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : {};
                    select = options.select, include = options.include;
                    client = createContentfulClient();
                    return [
                        4,
                        client.getEntries((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
                            content_type: content_type
                        }, select && {
                            select: select
                        }, include && {
                            include: include
                        }), {
                            "sys.id[in]": "".concat(id)
                        }))
                    ];
                case 1:
                    response = _state.sent();
                    if (response.items.length === 0) {
                        return [
                            2,
                            undefined
                        ];
                    }
                    safeEntry = JSON.parse(response.stringifySafe());
                    entry = safeEntry.items[0];
                    return [
                        2,
                        entry
                    ];
            }
        });
    });
    return _fetchEntryById.apply(this, arguments);
}
function fetchEntriesById(contentType, ids) {
    return _fetchEntriesById.apply(this, arguments);
}
function _fetchEntriesById() {
    _fetchEntriesById = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(contentType, ids) {
        var options, select, include, client, response, safeEntry;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    options = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : {};
                    select = options.select, include = options.include;
                    client = createContentfulClient();
                    return [
                        4,
                        client.getEntries((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
                            content_type: contentType
                        }, select && {
                            select: select
                        }, include && {
                            include: include
                        }), {
                            "sys.id[in]": ids.join(",")
                        }))
                    ];
                case 1:
                    response = _state.sent();
                    if (response.items.length === 0) {
                        return [
                            2,
                            []
                        ];
                    }
                    safeEntry = JSON.parse(response.stringifySafe());
                    // contentful de-duplicates if you have multiple of the same entry id
                    // callers expect the same response shape as the input
                    // so if we call with ['id1', 'id2', 'id1']
                    // we need to include dupe entries
                    return [
                        2,
                        ids.map(function(id) {
                            return safeEntry.items.find(function(x) {
                                return x.sys.id === id;
                            });
                        })
                    ];
            }
        });
    });
    return _fetchEntriesById.apply(this, arguments);
}


/***/ }),

/***/ 93746:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ articleV2; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Box/Box.js
var Box = __webpack_require__(46523);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Accordion/Accordion.js + 3 modules
var Accordion = __webpack_require__(88111);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Box/Col.js
var Col = __webpack_require__(37122);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Text/index.js
var Text = __webpack_require__(76614);
// EXTERNAL MODULE: ./src/components/articles-v2/renderer.tsx
var renderer = __webpack_require__(818);
// EXTERNAL MODULE: ./src/components/landing-pages-v2/shared/Container.tsx
var Container = __webpack_require__(93524);
// EXTERNAL MODULE: ./src/components/landing-pages-v2/shared/styles/ComponentTheme.ts
var ComponentTheme = __webpack_require__(12090);
// EXTERNAL MODULE: ./src/components/landing-pages-v2/shared/Typography.tsx
var Typography = __webpack_require__(78837);
// EXTERNAL MODULE: ./src/components/shared/CardCarouselV2.tsx
var CardCarouselV2 = __webpack_require__(3776);
// EXTERNAL MODULE: ./src/components/shared/Multicard/MulticardCard.tsx
var MulticardCard = __webpack_require__(63933);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.min.css
var swiper_min = __webpack_require__(53481);
// EXTERNAL MODULE: ./node_modules/swiper/modules/pagination/pagination.min.css
var pagination_min = __webpack_require__(9320);
;// CONCATENATED MODULE: ./src/components/articles-v2/Multicard.tsx















var columns = {
    Two: 2,
    Three: 3,
    Four: 4
};
var ArchBox = /*#__PURE__*/ react.forwardRef(function(_param, ref) /*#__PURE__*/ {
    var isArched = _param.isArched, props = (0,_object_without_properties/* default */.Z)(_param, [
        "isArched"
    ]);
    return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        ref: ref
    }, props), {
        "$platform-web": (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props["$platform-web"]), {
            borderRadius: isArched ? "99em 99em 8em 8em" : "24px"
        })
    }));
});
ArchBox.displayName = "ArchBox";
var AccordionCardDetails = function(param) {
    var card = param.card, isArched = param.isArched, idToDataLoader = param.idToDataLoader;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
    /*#__PURE__*/ return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            ((ref = card.fields.image) === null || ref === void 0 ? void 0 : (ref1 = ref.fields) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.file) === null || ref2 === void 0 ? void 0 : ref2.url) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MulticardCard/* CardImage */.xu, {
                isArched: isArched,
                src: (ref3 = card.fields.image) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.fields) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.file) === null || ref5 === void 0 ? void 0 : ref5.url,
                alt: ((ref6 = card.fields.image) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.fields) === null || ref7 === void 0 ? void 0 : ref7.description) || ((ref8 = card.fields.image) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.fields) === null || ref9 === void 0 ? void 0 : ref9.title)
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Accordion/* Accordion */.U, {
                variant: "regular",
                size: "medium",
                isFullWidth: true,
                analyticsName: "cosmos-articles-multicard-accordion",
                items: [
                    {
                        title: card.fields.title || "",
                        eyebrowText: card.fields.eyebrow,
                        description: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Col/* Col */.J, {
                            gap: "$2",
                            children: [
                                card.fields.subhead && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                    tag: "p",
                                    typography: "$bodyMedium",
                                    fontWeight: "$medium",
                                    color: "$contentPrimary",
                                    children: card.fields.subhead
                                }),
                                card.fields.description ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(renderer/* default.Component */.Z.Component, {
                                    body: card.fields.description,
                                    idToLoaderData: idToDataLoader,
                                    entryLookup: articleV2
                                }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                                    display: "block"
                                })
                            ]
                        })
                    }, 
                ]
            })
        ]
    });
};
var CardSectionHeader = function(param) {
    var entry = param.entry;
    var fields = entry.fields;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Col/* Col */.J, {
        gap: "$2",
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Col/* Col */.J, {
            children: [
                fields.title && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Typography/* TitleWithAccent */.aI, {
                    title: fields.title,
                    titleAccent: fields.titleAccent,
                    titleSize: fields.titleSize === "Large" ? [
                        "64px",
                        null,
                        "88px"
                    ] : [
                        "64px"
                    ]
                }),
                (fields.subhead || fields.desc) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Col/* Col */.J, {
                    gap: "$4",
                    maxWidth: "$96",
                    children: [
                        fields.subhead && (fields.titleSize === "Large" ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Typography/* Subhead */.vF, {
                            children: fields.subhead
                        }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Typography/* SubheadSmall */.Jm, {
                            children: fields.subhead
                        })),
                        fields.desc && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Typography/* Desc */.Xe, {
                            $largerThanLG: {
                                fontSize: 24
                            },
                            children: fields.desc
                        })
                    ]
                })
            ]
        })
    });
};
var RenderMulticard = function(entry, _, context) {
    var fields = entry.fields;
    var idToDataLoader = context === null || context === void 0 ? void 0 : context.idToLoaderData;
    var columnNumber = fields.columns ? columns[fields.columns] : 3;
    var componentTheme = fields.cardBackgroundColor ? (0,ComponentTheme/* getComponentThemeColors */._Y)(fields.cardBackgroundColor) : (0,ComponentTheme/* getComponentThemeColors */._Y)("White 0");
    var isArched = fields.cardStyle === "Arch";
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
        className: "embedded-entry-wrapper",
        overflow: "hidden",
        "$platform-web": {
            gridColumn: "1 / -1"
        },
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Col/* Col */.J, {
            gap: "$6",
            children: [
                fields.title && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Container/* default */.ZP, {
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardSectionHeader, {
                        entry: entry
                    })
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardCarouselV2/* default */.Z, {
                    id: entry.sys.id,
                    cards: fields.cards,
                    componentTheme: componentTheme,
                    columnNumber: columnNumber,
                    isArched: isArched,
                    renderCard: function(card) {
                        var ref, ref1, ref2, ref3, ref4, ref5;
                        /*#__PURE__*/ return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ArchBox, {
                            pt: ((ref = card.fields.image) === null || ref === void 0 ? void 0 : (ref1 = ref.fields) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.file) === null || ref2 === void 0 ? void 0 : ref2.url) ? "$2" : "$22",
                            pb: ((ref3 = card.fields.image) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.fields) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.file) === null || ref5 === void 0 ? void 0 : ref5.url) ? "$2" : "$6",
                            px: "$6",
                            height: "min-content",
                            isArched: isArched,
                            backgroundColor: "$backgroundTertiary",
                            maxWidth: "90vw",
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AccordionCardDetails, {
                                card: card,
                                componentTheme: componentTheme,
                                isArched: isArched,
                                idToDataLoader: idToDataLoader
                            })
                        });
                    }
                })
            ]
        })
    });
};
// https://app.contentful.com/spaces/bjlp9d7o6h1o/content_types/componentMulticard/fields
var Multicard = {
    render: RenderMulticard
};
/* harmony default export */ var articles_v2_Multicard = (Multicard);

// EXTERNAL MODULE: ./src/components/shared/Articles.tsx
var Articles = __webpack_require__(68153);
;// CONCATENATED MODULE: ./src/components/articles-v2/AccordionList.tsx


var renderAccordionList = function(entry) {
    var items = (entry.fields.items || []).filter(Boolean).map(function(param) {
        var fields = param.fields;
        return {
            title: (fields === null || fields === void 0 ? void 0 : fields.title) || "",
            description: (fields === null || fields === void 0 ? void 0 : fields.body) || ""
        };
    });
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
        className: "embedded-entry-wrapper",
        "$platform-web": {
            gridColumn: "5 / -2"
        },
        width: "100%",
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Accordion/* Accordion */.U, {
            variant: "medium",
            size: "medium",
            isFullWidth: true,
            items: items,
            showDivider: true,
            analyticsName: "cosmos-articles-accordion-list"
        })
    });
};
var AccordionList = {
    render: renderAccordionList
};
/* harmony default export */ var articles_v2_AccordionList = (AccordionList);

// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Link/Link.js
var Link = __webpack_require__(22470);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Box/Row.js
var Row = __webpack_require__(6967);
// EXTERNAL MODULE: ./node_modules/@tabler/icons-react/dist/esm/icons/IconArrowDown.mjs
var IconArrowDown = __webpack_require__(88346);
// EXTERNAL MODULE: ./node_modules/@tabler/icons-react/dist/esm/icons/IconArrowUp.mjs
var IconArrowUp = __webpack_require__(99599);
;// CONCATENATED MODULE: ./src/components/articles-v2/BasicMetric.tsx



var formatMetric = function(metricValue, metricFormat) {
    switch(metricFormat){
        case "currency":
            // just take whatever is inputted if it's less than 1000
            if (metricValue < 1000) {
                return "$".concat(metricValue);
            }
            return "$".concat(Math.round(metricValue / 1000).toFixed(0), "k");
        case "decimal":
            return metricValue.toLocaleString();
        case "number":
            return metricValue.toLocaleString();
        case "percent":
            return metricValue.toLocaleString("en-US", {
                style: "percent",
                maximumFractionDigits: 3
            });
        default:
            return "".concat(metricValue);
    }
};
var formatSource = function(source) {
    if (!source) {
        return "Opendoor";
    }
    try {
        var url = new URL(source);
        if (!url.protocol.startsWith("http")) {
            return source;
        }
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Link/* Link */.r, {
            typography: "$bodySmall",
            href: source,
            analyticsName: "cosmos-articles-basic-metric-source",
            "aria-label": "",
            children: url.host
        });
    } catch (e) {
        return source;
    }
};
var renderBasicMetric = function(entry) {
    var fields = entry.fields;
    if (fields.value === undefined) {
        return null;
    }
    var relativeChange = null;
    if (fields.comparisonValue) {
        var x1 = fields.comparisonValue;
        var x2 = fields.value;
        relativeChange = (x2 - x1) / x1;
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
        className: "embedded-entry-wrapper",
        "$platform-web": {
            gridColumn: "5 / -2"
        },
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Row/* Row */.X, {
                alignItems: "center",
                gap: "$1",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                        tag: "span",
                        typography: "$subheaderLarge",
                        $largerThanMD: {
                            typography: "$headerMedium"
                        },
                        color: "$contentAccentBrand",
                        children: formatMetric(fields.value, fields.format)
                    }),
                    relativeChange !== null && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Col/* Col */.J, {
                        justifyContent: "center",
                        alignItems: "center",
                        children: [
                            relativeChange < 0 ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconArrowDown/* default */.Z, {
                                size: 14
                            }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconArrowUp/* default */.Z, {
                                size: 14
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Text/* Text */.x, {
                                tag: "span",
                                typography: "$bodyXsmall",
                                $largerThanMD: {
                                    typography: "$bodySmall"
                                },
                                children: [
                                    Math.round(relativeChange * 100).toFixed(0),
                                    "%"
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                tag: "span",
                typography: "$bodyMedium",
                children: fields.metricName
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Col/* Col */.J, {
                gap: "$1",
                mt: "$2",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Text/* Text */.x, {
                        tag: "span",
                        typography: "$bodySmall",
                        color: "$contentSecondary",
                        children: [
                            "Metric: ",
                            fields.metricDescription
                        ]
                    }),
                    relativeChange !== null && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Text/* Text */.x, {
                        tag: "span",
                        typography: "$bodySmall",
                        color: "$contentSecondary",
                        children: [
                            "Comparison: ",
                            fields.comparisonDescription
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Text/* Text */.x, {
                        tag: "span",
                        typography: "$bodySmall",
                        color: "$contentSecondary",
                        children: [
                            "Source: ",
                            formatSource(fields.metricSource)
                        ]
                    })
                ]
            })
        ]
    }, fields.metricId || fields.metricName);
};
var BasicMetric = {
    render: renderBasicMetric
};
/* harmony default export */ var articles_v2_BasicMetric = (BasicMetric);

// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
;// CONCATENATED MODULE: ./src/components/articles-v2/EmailInput.tsx



var DynamicEmailInput = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(5565), __webpack_require__.e(869), __webpack_require__.e(1416)]).then(__webpack_require__.bind(__webpack_require__, 51416)).then(function(mod) {
        return mod.EmailInput;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(51416)
            ];
        }
    },
    ssr: false
});
var renderEmailEntry = function(entry) {
    var fields = entry.fields;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
        className: "embedded-entry-wrapper",
        "$platform-web": {
            gridColumn: "5 / -2"
        },
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
            borderRadius: "$8x",
            marginBottom: "$9x",
            marginTop: "$9x",
            paddingVertical: "$10x",
            paddingHorizontal: "$10x",
            width: "100%",
            $largerThanSM: {
                marginBottom: "$10x",
                marginTop: "$10x",
                paddingVertical: "$16x",
                paddingHorizontal: "$16x",
                marginRight: -10
            },
            backgroundColor: "$backgroundAccentBrand",
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                alignItems: "stretch",
                display: "inline-flex",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                        tag: "h2",
                        typography: "$subheaderSmall",
                        $largerThanSM: {
                            typography: "$subheaderLarge"
                        },
                        color: "$borderStateInactivePrimary",
                        marginBottom: "$10x",
                        children: fields.largeTitle
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                        tag: "p",
                        typography: "$bodyMedium",
                        marginBottom: "$10x",
                        color: "$borderStateInactivePrimary",
                        children: fields.bodyText
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DynamicEmailInput, {
                        campaignName: "articles",
                        ctaText: fields.buttonText
                    })
                ]
            })
        })
    });
};
var EmailInputComponent = {
    render: renderEmailEntry
};
/* harmony default export */ var EmailInput = (EmailInputComponent);

// EXTERNAL MODULE: ./src/cms/renderer/index.tsx
var cms_renderer = __webpack_require__(32239);
// EXTERNAL MODULE: ./src/cms/renderer/assets.tsx
var assets = __webpack_require__(23609);
;// CONCATENATED MODULE: ./src/components/articles-v2/HighlightBox.tsx





var variantStyles = {
    default: {},
    leftBorder: {
        borderLeft: "3px solid #ddd"
    },
    dropShadow: {
        boxShadow: "0px 10px 22px rgba(29, 71, 123, 0.08), 0px 2px 12px rgba(29, 71, 123, 0.08)"
    }
};
var variantBgColor = {
    default: "$backgroundTertiary",
    leftBorder: "$backgroundTertiary",
    dropShadow: "$backgroundPrimary"
};
var renderHighlightBox = function(entry) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10;
    var fields = entry.fields;
    var _variant, _variant1, ref11, ref12, ref13;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
        className: "embedded-entry-wrapper",
        "$platform-web": {
            gridColumn: "5 / -2"
        },
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Row/* Row */.X, {
            backgroundColor: (_variant = variantBgColor[fields.variant]) !== null && _variant !== void 0 ? _variant : variantBgColor.default,
            borderRadius: "$8x",
            my: "$20x",
            p: "$12x",
            flexWrap: "wrap",
            gap: "$10x",
            $largerThanXS: {
                p: "$24x"
            },
            "$platform-web": (_variant1 = variantStyles[fields.variant]) !== null && _variant1 !== void 0 ? _variant1 : variantStyles.default,
            children: [
                fields.image && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Col/* Col */.J, {
                    width: (ref11 = (ref = fields.image.fields.file) === null || ref === void 0 ? void 0 : (ref1 = ref.details) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.image) === null || ref2 === void 0 ? void 0 : ref2.width) !== null && ref11 !== void 0 ? ref11 : 200,
                    maxWidth: "100%",
                    alignSelf: "center",
                    $largerThanXS: {
                        maxWidth: "50%"
                    },
                    "$platform-web": {
                        height: "auto"
                    },
                    children: (0,assets/* default */.Z)({
                        src: (ref3 = fields.image.fields.file) === null || ref3 === void 0 ? void 0 : ref3.url,
                        contentType: ((ref4 = fields.image.fields.file) === null || ref4 === void 0 ? void 0 : ref4.contentType) || "image/png",
                        width: (ref12 = (ref5 = fields.image.fields.file) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.details) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.image) === null || ref7 === void 0 ? void 0 : ref7.width) !== null && ref12 !== void 0 ? ref12 : 200,
                        height: (ref13 = (ref8 = fields.image.fields.file) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.details) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.image) === null || ref10 === void 0 ? void 0 : ref10.height) !== null && ref13 !== void 0 ? ref13 : 200
                    })
                }),
                fields.content && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Col/* Col */.J, {
                    alignItems: "flex-start",
                    flex: 1,
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(cms_renderer/* default.Component */.Z.Component, {
                        body: fields.content,
                        idToLoaderData: {},
                        entryLookup: articleV2
                    })
                })
            ]
        })
    });
};
var HighlightBox = {
    render: renderHighlightBox
};
/* harmony default export */ var articles_v2_HighlightBox = (HighlightBox);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@contentful/rich-text-react-renderer/dist/rich-text-react-renderer.es5.js
var rich_text_react_renderer_es5 = __webpack_require__(74129);
// EXTERNAL MODULE: ./node_modules/@contentful/rich-text-types/dist/index.js
var dist = __webpack_require__(86437);
;// CONCATENATED MODULE: ./src/components/articles-v2/IconText.tsx






var pictureIconSize = 42;
var renderIconText = function(entry) {
    var ref, ref1, ref2, ref3;
    var fields = entry.fields;
    var _obj;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Row/* Row */.X, {
        gap: "$half",
        p: "$half",
        children: [
            fields.textIcon ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                tag: "p",
                typography: "$headerSmall",
                children: fields.textIcon
            }) : fields.pictureIcon && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                height: pictureIconSize,
                width: pictureIconSize,
                children: (0,assets/* default */.Z)({
                    src: (ref = fields.pictureIcon.fields) === null || ref === void 0 ? void 0 : (ref1 = ref.file) === null || ref1 === void 0 ? void 0 : ref1.url,
                    contentType: ((ref2 = fields.pictureIcon.fields) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.file) === null || ref3 === void 0 ? void 0 : ref3.contentType) || "image/png",
                    width: pictureIconSize,
                    height: pictureIconSize
                })
            }),
            fields.labelText && (0,rich_text_react_renderer_es5/* documentToReactComponents */.h)(fields.labelText, {
                renderNode: (_obj = {}, (0,_define_property/* default */.Z)(_obj, dist.BLOCKS.PARAGRAPH, function(_, children) {
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                        tag: "p",
                        typography: "$bodyLarge",
                        my: "auto",
                        children: children
                    });
                }), (0,_define_property/* default */.Z)(_obj, dist.INLINES.HYPERLINK, function(node, children) {
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Link/* Link */.r, {
                        ml: "$3",
                        href: node.data.uri,
                        target: "_blank",
                        analyticsName: "cosmos-articles-icon-text",
                        "aria-label": "",
                        children: children
                    });
                }), _obj)
            })
        ]
    });
};
var IconText = {
    render: renderIconText
};
/* harmony default export */ var articles_v2_IconText = (IconText);

// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js
var emotion_styled_browser_esm = __webpack_require__(37337);
;// CONCATENATED MODULE: ./src/components/articles-v2/Iframe.tsx



var IFrame = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("iframe", {
    target: "em7cj9e0"
})("position:absolute;top:0;left:0;width:100%;height:100%;border:0;");
var renderIframe = function(entry) {
    var fields = entry.fields;
    var aspectRatio = fields.ratio ? Math.round(100 / fields.ratio) + "%" : "100%";
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
        className: "embedded-entry-wrapper",
        "$platform-web": {
            gridColumn: "5 / -2"
        },
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
            position: "relative",
            // align in the center on small screens to reduce excess spacing
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
            // @ts-expect-error, aspect ratio not supported
            paddingBottom: aspectRatio,
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IFrame, {
                title: "contenful-iframe-component",
                src: fields.url,
                allow: "autoplay; fullscreen",
                allowFullScreen: true
            })
        })
    });
};
var IframeComponent = {
    render: renderIframe
};
/* harmony default export */ var Iframe = (IframeComponent);

;// CONCATENATED MODULE: ./src/components/articles-v2/ImageAsset.tsx




var GifComponent = function(fields) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23;
    var ref24, ref25;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
        marginVertical: "$10x",
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
            overflow: "hidden",
            width: (ref = fields.asset) === null || ref === void 0 ? void 0 : (ref1 = ref.fields) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.file) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.details) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.image) === null || ref4 === void 0 ? void 0 : ref4.width,
            height: "100%",
            maxWidth: "100%",
            position: "relative",
            children: (0,assets/* default */.Z)({
                src: (ref5 = fields.asset) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.fields) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.file) === null || ref7 === void 0 ? void 0 : ref7.url,
                contentType: ((ref8 = fields.asset) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.fields) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.file) === null || ref10 === void 0 ? void 0 : ref10.contentType) || "image/gif",
                description: fields.description,
                width: (ref24 = (ref11 = fields.asset) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.fields) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.file) === null || ref13 === void 0 ? void 0 : (ref14 = ref13.details) === null || ref14 === void 0 ? void 0 : (ref15 = ref14.image) === null || ref15 === void 0 ? void 0 : ref15.width) !== null && ref24 !== void 0 ? ref24 : 100,
                height: (ref25 = (ref16 = fields.asset) === null || ref16 === void 0 ? void 0 : (ref17 = ref16.fields) === null || ref17 === void 0 ? void 0 : (ref18 = ref17.file) === null || ref18 === void 0 ? void 0 : (ref19 = ref18.details) === null || ref19 === void 0 ? void 0 : (ref20 = ref19.image) === null || ref20 === void 0 ? void 0 : ref20.height) !== null && ref25 !== void 0 ? ref25 : 200
            })
        })
    }, ((ref21 = fields.asset) === null || ref21 === void 0 ? void 0 : (ref22 = ref21.fields) === null || ref22 === void 0 ? void 0 : (ref23 = ref22.file) === null || ref23 === void 0 ? void 0 : ref23.url) || "backup-id");
};
var IconComponent = function(fields) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23, ref24, ref25, ref26, ref27, ref28;
    var ref29, ref30;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
        display: "inline-flex",
        marginVertical: 5,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
            overflow: "hidden",
            width: (ref = fields.asset) === null || ref === void 0 ? void 0 : (ref1 = ref.fields) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.file) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.details) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.image) === null || ref4 === void 0 ? void 0 : ref4.width,
            height: (ref5 = fields.asset) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.fields) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.file) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.details) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.image) === null || ref9 === void 0 ? void 0 : ref9.height,
            position: "relative",
            children: (0,assets/* default */.Z)({
                src: (ref10 = fields.asset) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.fields) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.file) === null || ref12 === void 0 ? void 0 : ref12.url,
                contentType: ((ref13 = fields.asset) === null || ref13 === void 0 ? void 0 : (ref14 = ref13.fields) === null || ref14 === void 0 ? void 0 : (ref15 = ref14.file) === null || ref15 === void 0 ? void 0 : ref15.contentType) || "image/png",
                description: fields.description,
                width: (ref29 = (ref16 = fields.asset) === null || ref16 === void 0 ? void 0 : (ref17 = ref16.fields) === null || ref17 === void 0 ? void 0 : (ref18 = ref17.file) === null || ref18 === void 0 ? void 0 : (ref19 = ref18.details) === null || ref19 === void 0 ? void 0 : (ref20 = ref19.image) === null || ref20 === void 0 ? void 0 : ref20.width) !== null && ref29 !== void 0 ? ref29 : 100,
                height: (ref30 = (ref21 = fields.asset) === null || ref21 === void 0 ? void 0 : (ref22 = ref21.fields) === null || ref22 === void 0 ? void 0 : (ref23 = ref22.file) === null || ref23 === void 0 ? void 0 : (ref24 = ref23.details) === null || ref24 === void 0 ? void 0 : (ref25 = ref24.image) === null || ref25 === void 0 ? void 0 : ref25.height) !== null && ref30 !== void 0 ? ref30 : 200
            })
        })
    }, ((ref26 = fields.asset) === null || ref26 === void 0 ? void 0 : (ref27 = ref26.fields) === null || ref27 === void 0 ? void 0 : (ref28 = ref27.file) === null || ref28 === void 0 ? void 0 : ref28.url) || "backup-id");
};
var ImageComponent = function(fields) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22;
    var noTitleAndSource = !((ref = fields.title) === null || ref === void 0 ? void 0 : ref.trim()) && !((ref1 = fields.source) === null || ref1 === void 0 ? void 0 : ref1.trim());
    var ref23, ref24;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
        width: "100%",
        justifyContent: "center",
        marginVertical: "$6x",
        $largerThanSM: {
            marginVertical: "$16x"
        },
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
            backgroundColor: "$backgroundPrimary",
            minWidth: "100%",
            borderRadius: "$10x",
            shadow: "$default",
            flexDirection: "column",
            alignItems: "center",
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                    borderTopLeftRadius: "$10x",
                    borderTopRightRadius: "$10x",
                    borderBottomLeftRadius: noTitleAndSource ? "$10x" : undefined,
                    borderBottomRightRadius: noTitleAndSource ? "$10x" : undefined,
                    overflow: "hidden",
                    width: "100%",
                    children: (0,assets/* default */.Z)({
                        src: fields === null || fields === void 0 ? void 0 : (ref2 = fields.asset) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.fields) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.file) === null || ref4 === void 0 ? void 0 : ref4.url,
                        contentType: (fields === null || fields === void 0 ? void 0 : (ref5 = fields.asset) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.fields) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.file) === null || ref7 === void 0 ? void 0 : ref7.contentType) || "image/png",
                        description: fields === null || fields === void 0 ? void 0 : fields.description,
                        width: (ref23 = fields === null || fields === void 0 ? void 0 : (ref8 = fields.asset) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.fields) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.file) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.details) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.image) === null || ref12 === void 0 ? void 0 : ref12.width) !== null && ref23 !== void 0 ? ref23 : 100,
                        height: (ref24 = fields === null || fields === void 0 ? void 0 : (ref13 = fields.asset) === null || ref13 === void 0 ? void 0 : (ref14 = ref13.fields) === null || ref14 === void 0 ? void 0 : (ref15 = ref14.file) === null || ref15 === void 0 ? void 0 : (ref16 = ref15.details) === null || ref16 === void 0 ? void 0 : (ref17 = ref16.image) === null || ref17 === void 0 ? void 0 : ref17.height) !== null && ref24 !== void 0 ? ref24 : 200
                    })
                }),
                !noTitleAndSource && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                    alignItems: "center",
                    padding: "$6x",
                    children: [
                        ((ref18 = fields.title) === null || ref18 === void 0 ? void 0 : ref18.trim()) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                            tag: "p",
                            typography: "$bodyMedium",
                            marginBottom: 0,
                            children: fields.title
                        }),
                        ((ref19 = fields.source) === null || ref19 === void 0 ? void 0 : ref19.trim()) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Text/* Text */.x, {
                            tag: "p",
                            typography: "$bodyMedium",
                            marginTop: 0,
                            children: [
                                "Source: ",
                                fields.source
                            ]
                        })
                    ]
                })
            ]
        }, (fields === null || fields === void 0 ? void 0 : (ref20 = fields.asset) === null || ref20 === void 0 ? void 0 : (ref21 = ref20.fields) === null || ref21 === void 0 ? void 0 : (ref22 = ref21.file) === null || ref22 === void 0 ? void 0 : ref22.url) || "backup-id")
    });
};
var components = {
    gif: GifComponent,
    icon: IconComponent,
    image: ImageComponent
};
var renderImageAsset = function(entry) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12;
    var fields = entry.fields;
    var width = fields === null || fields === void 0 ? void 0 : (ref = fields.asset) === null || ref === void 0 ? void 0 : (ref1 = ref.fields) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.file) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.details) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.image) === null || ref4 === void 0 ? void 0 : ref4.width;
    var height = fields === null || fields === void 0 ? void 0 : (ref5 = fields.asset) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.fields) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.file) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.details) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.image) === null || ref9 === void 0 ? void 0 : ref9.height;
    var imageType = (fields === null || fields === void 0 ? void 0 : (ref10 = fields.asset) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.fields) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.file) === null || ref12 === void 0 ? void 0 : ref12.contentType) === "image/gif" && "gif" || width && height && width <= 128 && height <= 128 && "icon" || "image";
    var Component = components[imageType];
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
        minWidth: 200,
        className: "embedded-entry-wrapper",
        "$platform-web": {
            gridColumn: "5 / -2"
        },
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Component, (0,_object_spread/* default */.Z)({}, fields))
    });
};
var ImageAsset = {
    render: renderImageAsset
};
/* harmony default export */ var articles_v2_ImageAsset = (ImageAsset);

;// CONCATENATED MODULE: ./src/components/articles-v2/ImageAssetLink.tsx



var getSafeHref = function(uri) {
    if (!uri) {
        return null;
    }
    try {
        var url = new URL(uri);
        return url.protocol === "http:" || url.protocol === "https:" ? uri : null;
    } catch (e) {
        return null;
    }
};
var renderImageLink = function(entry) {
    var ref;
    var href = getSafeHref(entry === null || entry === void 0 ? void 0 : (ref = entry.fields) === null || ref === void 0 ? void 0 : ref.uri);
    var image = articles_v2_ImageAsset.render(entry.fields.image);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
        className: "embedded-entry-wrapper",
        "$platform-web": {
            gridColumn: "5 / -2"
        },
        children: href ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Link/* Link */.r, {
            href: href,
            target: "_blank",
            rel: "noopener noreferrer",
            analyticsName: "cosmos-articles-image",
            children: image
        }) : image
    });
};
var ImageAssetLink = {
    render: renderImageLink
};
/* harmony default export */ var articles_v2_ImageAssetLink = (ImageAssetLink);

// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
// EXTERNAL MODULE: ./node_modules/next/script.js
var script = __webpack_require__(4298);
var script_default = /*#__PURE__*/__webpack_require__.n(script);
;// CONCATENATED MODULE: ./src/components/articles-v2/InstagramImage.tsx





// Parameterized instagram embed code, in the future, will use the
// instagram_oembed endpoint from the facebook API.
// You have to ask for permission to use that API by showing the intended
// usage (which we can demonstrate with this embed logic).
// Note: do not edit the styling here (beyond the parameterized url + account)
// this is copied from clicking the "embed" link on a public instagram picture
var getInstaEmbed = function(instagramUrl, account) {
    return '<blockquote class="instagram-media" data-instgrm-permalink="'.concat(instagramUrl, '?utm_source=ig_embed&amp;utm_campaign=loading" data-instgrm-version="14" style=" background:#FFF; border:0; border-radius:3px; box-shadow:0 0 1px 0 rgba(0,0,0,0.5),0 1px 10px 0 rgba(0,0,0,0.15); margin: 1px; max-width:540px; min-width:326px; padding:0; width:99.375%; width:-webkit-calc(100% - 2px); width:calc(100% - 2px);"><div style="padding:16px;"> <a href="').concat(instagramUrl, '?utm_source=ig_embed&amp;utm_campaign=loading" style=" background:#FFFFFF; line-height:0; padding:0 0; text-align:center; text-decoration:none; width:100%;" target="_blank"> <div style=" display: flex; flex-direction: row; align-items: center;"> <div style="background-color: #F4F4F4; border-radius: 50%; flex-grow: 0; height: 40px; margin-right: 14px; width: 40px;"></div> <div style="display: flex; flex-direction: column; flex-grow: 1; justify-content: center;"> <div style=" background-color: #F4F4F4; border-radius: 4px; flex-grow: 0; height: 14px; margin-bottom: 6px; width: 100px;"></div> <div style=" background-color: #F4F4F4; border-radius: 4px; flex-grow: 0; height: 14px; width: 60px;"></div></div></div><div style="padding: 19% 0;"></div> <div style="display:block; height:50px; margin:0 auto 12px; width:50px;"><svg width="50px" height="50px" viewBox="0 0 60 60" version="1.1" xmlns="https://www.w3.org/2000/svg" xmlns:xlink="https://www.w3.org/1999/xlink"><g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g transform="translate(-511.000000, -20.000000)" fill="#000000"><g><path d="M556.869,30.41 C554.814,30.41 553.148,32.076 553.148,34.131 C553.148,36.186 554.814,37.852 556.869,37.852 C558.924,37.852 560.59,36.186 560.59,34.131 C560.59,32.076 558.924,30.41 556.869,30.41 M541,60.657 C535.114,60.657 530.342,55.887 530.342,50 C530.342,44.114 535.114,39.342 541,39.342 C546.887,39.342 551.658,44.114 551.658,50 C551.658,55.887 546.887,60.657 541,60.657 M541,33.886 C532.1,33.886 524.886,41.1 524.886,50 C524.886,58.899 532.1,66.113 541,66.113 C549.9,66.113 557.115,58.899 557.115,50 C557.115,41.1 549.9,33.886 541,33.886 M565.378,62.101 C565.244,65.022 564.756,66.606 564.346,67.663 C563.803,69.06 563.154,70.057 562.106,71.106 C561.058,72.155 560.06,72.803 558.662,73.347 C557.607,73.757 556.021,74.244 553.102,74.378 C549.944,74.521 548.997,74.552 541,74.552 C533.003,74.552 532.056,74.521 528.898,74.378 C525.979,74.244 524.393,73.757 523.338,73.347 C521.94,72.803 520.942,72.155 519.894,71.106 C518.846,70.057 518.197,69.06 517.654,67.663 C517.244,66.606 516.755,65.022 516.623,62.101 C516.479,58.943 516.448,57.996 516.448,50 C516.448,42.003 516.479,41.056 516.623,37.899 C516.755,34.978 517.244,33.391 517.654,32.338 C518.197,30.938 518.846,29.942 519.894,28.894 C520.942,27.846 521.94,27.196 523.338,26.654 C524.393,26.244 525.979,25.756 528.898,25.623 C532.057,25.479 533.004,25.448 541,25.448 C548.997,25.448 549.943,25.479 553.102,25.623 C556.021,25.756 557.607,26.244 558.662,26.654 C560.06,27.196 561.058,27.846 562.106,28.894 C563.154,29.942 563.803,30.938 564.346,32.338 C564.756,33.391 565.244,34.978 565.378,37.899 C565.522,41.056 565.552,42.003 565.552,50 C565.552,57.996 565.522,58.943 565.378,62.101 M570.82,37.631 C570.674,34.438 570.167,32.258 569.425,30.349 C568.659,28.377 567.633,26.702 565.965,25.035 C564.297,23.368 562.623,22.342 560.652,21.575 C558.743,20.834 556.562,20.326 553.369,20.18 C550.169,20.033 549.148,20 541,20 C532.853,20 531.831,20.033 528.631,20.18 C525.438,20.326 523.257,20.834 521.349,21.575 C519.376,22.342 517.703,23.368 516.035,25.035 C514.368,26.702 513.342,28.377 512.574,30.349 C511.834,32.258 511.326,34.438 511.181,37.631 C511.035,40.831 511,41.851 511,50 C511,58.147 511.035,59.17 511.181,62.369 C511.326,65.562 511.834,67.743 512.574,69.651 C513.342,71.625 514.368,73.296 516.035,74.965 C517.703,76.634 519.376,77.658 521.349,78.425 C523.257,79.167 525.438,79.673 528.631,79.82 C531.831,79.965 532.853,80.001 541,80.001 C549.148,80.001 550.169,79.965 553.369,79.82 C556.562,79.673 558.743,79.167 560.652,78.425 C562.623,77.658 564.297,76.634 565.965,74.965 C567.633,73.296 568.659,71.625 569.425,69.651 C570.167,67.743 570.674,65.562 570.82,62.369 C570.966,59.17 571,58.147 571,50 C571,41.851 570.966,40.831 570.82,37.631"></path></g></g></g></svg></div><div style="padding-top: 8px;"> <div style=" color:#3897f0; font-family:Arial,sans-serif; font-size:14px; font-style:normal; font-weight:550; line-height:18px;">View this post on Instagram</div></div><div style="padding: 12.5% 0;"></div> <div style="display: flex; flex-direction: row; margin-bottom: 14px; align-items: center;"><div> <div style="background-color: #F4F4F4; border-radius: 50%; height: 12.5px; width: 12.5px; transform: translateX(0px) translateY(7px);"></div> <div style="background-color: #F4F4F4; height: 12.5px; transform: rotate(-45deg) translateX(3px) translateY(1px); width: 12.5px; flex-grow: 0; margin-right: 14px; margin-left: 2px;"></div> <div style="background-color: #F4F4F4; border-radius: 50%; height: 12.5px; width: 12.5px; transform: translateX(9px) translateY(-18px);"></div></div><div style="margin-left: 8px;"> <div style=" background-color: #F4F4F4; border-radius: 50%; flex-grow: 0; height: 20px; width: 20px;"></div> <div style=" width: 0; height: 0; border-top: 2px solid transparent; border-left: 6px solid #f4f4f4; border-bottom: 2px solid transparent; transform: translateX(16px) translateY(-4px) rotate(30deg)"></div></div><div style="margin-left: auto;"> <div style=" width: 0px; border-top: 8px solid #F4F4F4; border-right: 8px solid transparent; transform: translateY(16px);"></div> <div style=" background-color: #F4F4F4; flex-grow: 0; height: 12px; width: 16px; transform: translateY(-4px);"></div> <div style=" width: 0; height: 0; border-top: 8px solid #F4F4F4; border-left: 8px solid transparent; transform: translateY(-4px) translateX(8px);"></div></div></div> <div style="display: flex; flex-direction: column; flex-grow: 1; justify-content: center; margin-bottom: 24px;"> <div style=" background-color: #F4F4F4; border-radius: 4px; flex-grow: 0; height: 14px; margin-bottom: 6px; width: 224px;"></div> <div style=" background-color: #F4F4F4; border-radius: 4px; flex-grow: 0; height: 14px; width: 144px;"></div></div></a><p style=" color:#c9c8cd; font-family:Arial,sans-serif; font-size:14px; line-height:17px; margin-bottom:0; margin-top:8px; overflow:hidden; padding:8px 0 7px; text-align:center; text-overflow:ellipsis; white-space:nowrap;"><a href="').concat(instagramUrl, '?utm_source=ig_embed&amp;utm_campaign=loading" style=" color:#c9c8cd; font-family:Arial,sans-serif; font-size:14px; font-style:normal; font-weight:normal; line-height:17px; text-decoration:none;" target="_blank">A post shared by ').concat(account, "</a></p></div></blockquote>");
};
var renderInstagramImage = function(entry) {
    var fields = entry.fields;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
        className: "embedded-entry-wrapper",
        "$platform-web": {
            gridColumn: "5 / -2"
        },
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(react.Fragment, {
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                    dangerouslySetInnerHTML: {
                        __html: getInstaEmbed(fields.sourceUrl, fields.sourceAccount || "@unkown")
                    },
                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)(".instagram-media{margin-left:auto !important;margin-right:auto !important;}")
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((script_default()), {
                    strategy: "lazyOnload",
                    src: "//www.instagram.com/embed.js"
                }, "instagram-embed")
            ]
        }, fields.sourceUrl)
    });
};
var InstagramImage = {
    render: renderInstagramImage
};
/* harmony default export */ var articles_v2_InstagramImage = (InstagramImage);

;// CONCATENATED MODULE: ./src/components/articles-v2/ImageCarousel.tsx




var renderImageCarousel = function(entry) {
    var ref;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
        className: "embedded-entry-wrapper",
        "$platform-web": {
            gridColumn: "2 / -2"
        },
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
            overflow: "scroll",
            flexDirection: "row",
            gap: "$10x",
            position: "relative",
            // align in the center on small screens to reduce excess spacing
            alignItems: "center",
            paddingBottom: "$6x",
            paddingRight: "$6x",
            width: "100%",
            $largerThanMD: {
                marginRight: "-10%"
            },
            hoverStyle: {
                shadow: "$default"
            },
            children: (ref = entry.fields.images) === null || ref === void 0 ? void 0 : ref.map(function(x) {
                if (x.sys.contentType.sys.id === "instagramImageAsset") {
                    return articles_v2_InstagramImage.render(x);
                }
                if (x.sys.contentType.sys.id === "imageAsset") {
                    return articles_v2_ImageAsset.render(x);
                }
                return null;
            })
        })
    });
};
var ImageCarouselComponent = {
    render: renderImageCarousel
};
/* harmony default export */ var ImageCarousel = (ImageCarouselComponent);

;// CONCATENATED MODULE: ./src/components/articles-v2/MetricsCard.tsx




var renderMetricsCard = function(entry) {
    var ref;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
        className: "embedded-entry-wrapper",
        "$platform-web": {
            gridColumn: "5 / -2"
        },
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
            gap: "$5",
            py: "$3",
            width: "100%",
            flexWrap: "nowrap",
            flexDirection: "column",
            $largerThanSM: {
                flexWrap: "wrap",
                flexDirection: "row"
            },
            children: (ref = entry.fields.metrics) === null || ref === void 0 ? void 0 : ref.map(function(x) {
                if (x.sys.contentType.sys.id === "metricBasic") {
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react.Fragment, {
                        children: articles_v2_BasicMetric.render(x)
                    }, x.sys.id);
                }
                return null;
            })
        })
    });
};
var MetricsCard = {
    render: renderMetricsCard
};
/* harmony default export */ var articles_v2_MetricsCard = (MetricsCard);

;// CONCATENATED MODULE: ./src/components/articles-v2/Quote.tsx



var Blockquote = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("blockquote", {
    target: "e1fvqkdc0"
})("margin:0;position:relative;p::before{content:'“';display:inline-block;position:absolute;right:calc(100% + 16px);}");
var renderQuote = function(entry) {
    var fields = entry.fields;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
        p: "$16x",
        "$platform-web": {
            gridColumn: "5 / -2"
        },
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Blockquote, {
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                tag: "p",
                typography: "$headerMedium",
                children: fields.content
            })
        })
    });
};
var Quote = {
    render: renderQuote
};
/* harmony default export */ var articles_v2_Quote = (Quote);

// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Button/Button.js
var Button = __webpack_require__(25923);
// EXTERNAL MODULE: ./src/components/shared/NewSellerFlowAddressInput.tsx
var NewSellerFlowAddressInput = __webpack_require__(4618);
// EXTERNAL MODULE: ./src/components/articles-v2/StickyAddressContext.tsx
var StickyAddressContext = __webpack_require__(17965);
;// CONCATENATED MODULE: ./src/components/articles-v2/SimpleCTA.tsx






var renderSimpleCTA = function(entry) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SimpleCTAInner, {
        entry: entry
    });
};
var SimpleCTAInner = function(param) {
    var entry = param.entry;
    var ref, ref1, ref2, ref3;
    var fields = entry.fields;
    var stickyAddress = (0,StickyAddressContext/* useStickyAddress */.v)();
    var ref4, ref5;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
        className: "embedded-entry-wrapper",
        "$platform-web": {
            gridColumn: "5 / -2"
        },
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            padding: stickyAddress ? "$12x" : "$10x",
            alignItems: stickyAddress ? "stretch" : "center",
            backgroundColor: "$backgroundTertiary",
            borderRadius: "$16x",
            flexDirection: "column",
            shadowOffset: stickyAddress ? {
                width: 0,
                height: 4
            } : undefined,
            shadowRadius: stickyAddress ? 24 : undefined
        }, stickyAddress ? {
            $largerThanMD: {
                display: "none"
            }
        } : {}), {
            children: [
                fields.headline && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                    tag: "h5",
                    typography: "$subheaderMedium",
                    textAlign: stickyAddress ? "left" : "center",
                    color: "$contentPrimary",
                    marginBottom: stickyAddress ? "$4x" : undefined,
                    children: fields.headline
                }),
                fields.description && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                    tag: "p",
                    textAlign: stickyAddress ? "left" : "center",
                    marginVertical: stickyAddress ? undefined : "$5x",
                    marginBottom: stickyAddress ? "$8x" : undefined,
                    typography: "$bodyMedium",
                    $largerThanXS: stickyAddress ? undefined : {
                        typography: "$bodyLarge"
                    },
                    color: "$contentTertiary",
                    children: fields.description
                }),
                stickyAddress ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                    width: "100%",
                    maxWidth: 480,
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NewSellerFlowAddressInput/* default */.Z, {
                        inputLocation: "article-sticky-address",
                        trackingTaxonomy: "article_sticky_address",
                        analyticsPrefix: (ref4 = (ref = fields.headline) === null || ref === void 0 ? void 0 : ref.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "")) !== null && ref4 !== void 0 ? ref4 : "article-inline-cta",
                        placeholder: (ref5 = (ref1 = stickyAddress.fields) === null || ref1 === void 0 ? void 0 : ref1.addressInputPlaceholderText) !== null && ref5 !== void 0 ? ref5 : "Enter your home address",
                        hideLabel: true,
                        trackingKeywords: (ref2 = stickyAddress.fields) === null || ref2 === void 0 ? void 0 : ref2.trackingKeyword,
                        channel: (ref3 = stickyAddress.fields) === null || ref3 === void 0 ? void 0 : ref3.channel,
                        size: "small"
                    })
                }) : fields.ctaLink && fields.ctaText && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* Button */.z, {
                    onPress: function() {
                        window.open(fields.ctaLink, "_blank");
                    },
                    analyticsName: "simple-cta-get-offer-button",
                    variant: "primary",
                    size: "small",
                    label: "Get a cash offer"
                })
            ]
        }))
    });
};
var SimpleCTA = {
    render: renderSimpleCTA
};
/* harmony default export */ var articles_v2_SimpleCTA = (SimpleCTA);

;// CONCATENATED MODULE: ./src/components/articles-v2/TwitterTweet.tsx




var TweetAnchor = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("a", {
    target: "e1unfm6n0"
})("color:transparent;");
//https://platform.twitter.com/widgets.js
var RenderTwitterTweet = function(entry) {
    var fields = entry.fields;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((script_default()), {
                src: "https://platform.twitter.com/widgets.js",
                strategy: "lazyOnload"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                className: "embedded-entry-wrapper",
                display: "flex",
                justifyContent: "center",
                "$platform-web": {
                    gridColumn: "5 / -2"
                },
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("blockquote", {
                    className: "twitter-tweet",
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TweetAnchor, {
                        href: "https://twitter.com/x/status/" + fields.tweetId,
                        children: "Tweet Link"
                    })
                })
            })
        ]
    });
};
var TwitterTweet = {
    render: RenderTwitterTweet
};
/* harmony default export */ var articles_v2_TwitterTweet = (TwitterTweet);

// EXTERNAL MODULE: ./src/components/landing-pages-v2/FAQsDisplay.tsx
var FAQsDisplay = __webpack_require__(11375);
;// CONCATENATED MODULE: ./src/cms/entries/articleV2.ts

















var articleV2EntryLookup = {
    block: {
        componentMetricsCard: articles_v2_MetricsCard,
        componentIconText: articles_v2_IconText,
        componentRelatedArticles: Articles/* default */.ZP,
        metricBasic: articles_v2_BasicMetric,
        ctaEmailCapture: EmailInput,
        componentImageCarousel: ImageCarousel,
        instagramImageAsset: articles_v2_InstagramImage,
        imageAsset: articles_v2_ImageAsset,
        componentAccordionList: articles_v2_AccordionList,
        componentImageAssetLink: articles_v2_ImageAssetLink,
        componentIframe: Iframe,
        componentQuotes: articles_v2_Quote,
        componentSimpleCta: articles_v2_SimpleCTA,
        componentTwitter: articles_v2_TwitterTweet,
        componentHighlightBox: articles_v2_HighlightBox,
        componentMulticard: articles_v2_Multicard,
        lpComponentFaqDisplay: FAQsDisplay["default"]
    },
    inline: {
        ctaEmailCapture: EmailInput
    }
};
/* harmony default export */ var articleV2 = (articleV2EntryLookup);


/***/ }),

/***/ 85733:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ dynamicEntry; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97582);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);




var dynamicEntry = function(importFn) {
    var DynamicComponent = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
        return importFn().then(function(mod) {
            // eslint-disable-next-line react/display-name
            var Component = function(props) {
                var inputProps = props.inputProps, loaderProps = props.loaderProps, context = props.context;
                return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, mod.default.render(inputProps, loaderProps, context));
            };
            return Component;
        });
    }, {
        ssr: false
    });
    // Loader wrapper that dynamically imports the module and calls its loader
    // This ensures server-side data fetching works even with dynamic components
    var loaderWrapper = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(inputProps, root, pageProps) {
            var mod;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            importFn()
                        ];
                    case 1:
                        mod = _state.sent();
                        if (mod.default.loader) {
                            return [
                                2,
                                mod.default.loader(inputProps, root, pageProps)
                            ];
                        }
                        return [
                            2,
                            null
                        ];
                }
            });
        });
        return function loaderWrapper(inputProps, root, pageProps) {
            return _ref.apply(this, arguments);
        };
    }();
    var Component = {
        render: function(inputProps, loaderProps, context) {
            return react__WEBPACK_IMPORTED_MODULE_0__.createElement(DynamicComponent, {
                inputProps: inputProps,
                loaderProps: loaderProps,
                context: context
            });
        },
        loader: loaderWrapper
    };
    return Component;
};


/***/ }),

/***/ 43862:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ landingPageV2; }
});

// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Box/Box.js
var Box = __webpack_require__(46523);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Box/Col.js
var Col = __webpack_require__(37122);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Text/index.js
var Text = __webpack_require__(76614);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Box/Row.js
var Row = __webpack_require__(6967);
// EXTERNAL MODULE: ./node_modules/@tamagui/core/dist/cjs/index.js
var cjs = __webpack_require__(86872);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Image/Image.js + 1 modules
var Image = __webpack_require__(97009);
// EXTERNAL MODULE: ./node_modules/@tabler/icons-react/dist/esm/icons/IconCircleCheckFilled.mjs
var IconCircleCheckFilled = __webpack_require__(77969);
// EXTERNAL MODULE: ./src/components/shared/NewSellerFlowAddressInput.tsx
var NewSellerFlowAddressInput = __webpack_require__(4618);
;// CONCATENATED MODULE: ./src/components/landing-pages-v2/CompareHero.tsx




var RenderCompareHero = function(entry) {
    var ref, ref1, ref2;
    var fields = entry.fields;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
        py: "$40x",
        $smallerThanMD: {
            py: "$24x"
        },
        $smallerThanLG: {
            py: "$20x"
        },
        backgroundColor: "$backgroundPrimary",
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
            display: "block",
            maxWidth: 1120,
            px: "$12x",
            width: "100%",
            mx: "auto",
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                flexDirection: "column",
                gap: "$16x",
                alignItems: "center",
                $largerThanSM: {
                    flexDirection: "row"
                },
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Col/* Col */.J, {
                        flex: 1.1,
                        gap: "$10x",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                tag: "span",
                                typography: "$labelSmall",
                                color: "$contentAccentBrand",
                                children: fields.eyebrow
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Col/* Col */.J, {
                                gap: "$10x",
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Text/* Text */.x, {
                                        tag: "h1",
                                        typography: "$headerLarge",
                                        color: "$contentPrimary",
                                        $smallerThanMD: {
                                            typography: "$headerSmall"
                                        },
                                        $smallerThanLG: {
                                            typography: "$headerMedium"
                                        },
                                        children: [
                                            fields.title,
                                            " ",
                                            fields.titleAccent && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                                tag: "span",
                                                color: "$contentAccentBrand",
                                                typography: "$headerLarge",
                                                $smallerThanMD: {
                                                    typography: "$headerSmall"
                                                },
                                                $smallerThanLG: {
                                                    typography: "$headerMedium"
                                                },
                                                children: fields.titleAccent
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                        tag: "p",
                                        typography: "$bodyLarge",
                                        color: "$contentSecondary",
                                        maxWidth: "$616x",
                                        "$platform-web": {
                                            lineHeight: "1.6"
                                        },
                                        children: fields.description
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Col/* Col */.J, {
                                gap: "$10x",
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                                        maxWidth: "$516x",
                                        width: "100%",
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NewSellerFlowAddressInput/* default */.Z, {
                                            hideLabel: true,
                                            inputLocation: fields.addressInputLocation || "hero-cta",
                                            analyticsPrefix: fields.addressInputAnalyticsPrefix || "compare-hero",
                                            trackingTaxonomy: "new_homepage",
                                            placeholder: fields.addressInputPlaceholder || "Enter your home address",
                                            channel: "DEFAULT",
                                            size: "medium"
                                        })
                                    }),
                                    fields.trustBadges && fields.trustBadges.length > 0 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Row/* Row */.X, {
                                        gap: "$12x",
                                        flexWrap: "wrap",
                                        children: fields.trustBadges.map(function(item) {
                                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Row/* Row */.X, {
                                                gap: "$4x",
                                                alignItems: "center",
                                                children: [
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconCircleCheckFilled/* default */.Z, {
                                                        size: 18,
                                                        color: (0,cjs.getToken)("$contentStateSuccessDefault", "color")
                                                    }),
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                                        tag: "span",
                                                        typography: "$bodySmall",
                                                        color: "$contentSecondary",
                                                        children: item
                                                    })
                                                ]
                                            }, item);
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    fields.heroImage && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                        flex: 0.9,
                        alignItems: "center",
                        justifyContent: "center",
                        $smallerThanLG: {
                            display: "none"
                        },
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image/* Image */.E, {
                            source: {
                                uri: (ref = fields.heroImage) === null || ref === void 0 ? void 0 : (ref1 = ref.fields) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.file) === null || ref2 === void 0 ? void 0 : ref2.url
                            },
                            alt: fields.heroImageAlt || "",
                            width: "100%",
                            maxWidth: 480,
                            height: 480,
                            borderRadius: "$8x",
                            "$platform-web": {
                                aspectRatio: "1",
                                objectFit: "cover"
                            }
                        })
                    })
                ]
            })
        })
    });
};
var CompareHero = {
    render: RenderCompareHero
};
/* harmony default export */ var landing_pages_v2_CompareHero = (CompareHero);

// EXTERNAL MODULE: ./src/components/landing-pages-v2/HeroV2.tsx + 3 modules
var HeroV2 = __webpack_require__(32296);
// EXTERNAL MODULE: ./src/components/landing-pages-v2/HeroV2WithMarkers.tsx + 2 modules
var HeroV2WithMarkers = __webpack_require__(50069);
// EXTERNAL MODULE: ./src/cms/entries/dynamicEntry.ts
var dynamicEntry = __webpack_require__(85733);
;// CONCATENATED MODULE: ./src/cms/entries/landingPageV2.ts
// Static imports (critical LCP)




// Dynamic imports
var ExternalLinks = (0,dynamicEntry/* dynamicEntry */.f)(function() {
    return __webpack_require__.e(/* import() */ 3813).then(__webpack_require__.bind(__webpack_require__, 63813));
});
var BasicPageHeader = (0,dynamicEntry/* dynamicEntry */.f)(function() {
    return __webpack_require__.e(/* import() */ 8190).then(__webpack_require__.bind(__webpack_require__, 28190));
});
var Calculator = (0,dynamicEntry/* dynamicEntry */.f)(function() {
    return Promise.all(/* import() */[__webpack_require__.e(5565), __webpack_require__.e(869), __webpack_require__.e(1057), __webpack_require__.e(5776)]).then(__webpack_require__.bind(__webpack_require__, 25776));
});
var CarouselCards = (0,dynamicEntry/* dynamicEntry */.f)(function() {
    return __webpack_require__.e(/* import() */ 6737).then(__webpack_require__.bind(__webpack_require__, 66737));
});
var CompareFees = (0,dynamicEntry/* dynamicEntry */.f)(function() {
    return __webpack_require__.e(/* import() */ 2972).then(__webpack_require__.bind(__webpack_require__, 52972));
});
var CompareFinalCta = (0,dynamicEntry/* dynamicEntry */.f)(function() {
    return __webpack_require__.e(/* import() */ 1254).then(__webpack_require__.bind(__webpack_require__, 51254));
});
var ComparePhotoTestimonials = (0,dynamicEntry/* dynamicEntry */.f)(function() {
    return __webpack_require__.e(/* import() */ 238).then(__webpack_require__.bind(__webpack_require__, 40238));
});
var CompareReviews = (0,dynamicEntry/* dynamicEntry */.f)(function() {
    return __webpack_require__.e(/* import() */ 4188).then(__webpack_require__.bind(__webpack_require__, 4188));
});
var CompareTable = (0,dynamicEntry/* dynamicEntry */.f)(function() {
    return __webpack_require__.e(/* import() */ 4067).then(__webpack_require__.bind(__webpack_require__, 24067));
});
var CompareVideoTestimonial = (0,dynamicEntry/* dynamicEntry */.f)(function() {
    return __webpack_require__.e(/* import() */ 2302).then(__webpack_require__.bind(__webpack_require__, 92302));
});
var ComparisonTable = (0,dynamicEntry/* dynamicEntry */.f)(function() {
    return __webpack_require__.e(/* import() */ 753).then(__webpack_require__.bind(__webpack_require__, 70753));
});
var ContactSection = (0,dynamicEntry/* dynamicEntry */.f)(function() {
    return __webpack_require__.e(/* import() */ 7712).then(__webpack_require__.bind(__webpack_require__, 7712));
});
// import CountdownTimer from 'components/landing-pages-v2/CountdownTimer';
var CTAStandalone = (0,dynamicEntry/* dynamicEntry */.f)(function() {
    return __webpack_require__.e(/* import() */ 7083).then(__webpack_require__.bind(__webpack_require__, 77083));
});
var FAQsDisplay = (0,dynamicEntry/* dynamicEntry */.f)(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 11375));
});
var Feature5050 = (0,dynamicEntry/* dynamicEntry */.f)(function() {
    return __webpack_require__.e(/* import() */ 6536).then(__webpack_require__.bind(__webpack_require__, 46536));
});
var HeaderStandalone = (0,dynamicEntry/* dynamicEntry */.f)(function() {
    return __webpack_require__.e(/* import() */ 747).then(__webpack_require__.bind(__webpack_require__, 50747));
});
var HeroCTA = (0,dynamicEntry/* dynamicEntry */.f)(function() {
    return __webpack_require__.e(/* import() */ 8204).then(__webpack_require__.bind(__webpack_require__, 78204));
});
var ImageCard = (0,dynamicEntry/* dynamicEntry */.f)(function() {
    return __webpack_require__.e(/* import() */ 9658).then(__webpack_require__.bind(__webpack_require__, 59658));
});
var LinkList = (0,dynamicEntry/* dynamicEntry */.f)(function() {
    return __webpack_require__.e(/* import() */ 808).then(__webpack_require__.bind(__webpack_require__, 10808));
});
var List = (0,dynamicEntry/* dynamicEntry */.f)(function() {
    return __webpack_require__.e(/* import() */ 687).then(__webpack_require__.bind(__webpack_require__, 60687));
});
var LWCHeroCard = (0,dynamicEntry/* dynamicEntry */.f)(function() {
    return __webpack_require__.e(/* import() */ 9918).then(__webpack_require__.bind(__webpack_require__, 29918));
});
var LWCImageCard = (0,dynamicEntry/* dynamicEntry */.f)(function() {
    return __webpack_require__.e(/* import() */ 536).then(__webpack_require__.bind(__webpack_require__, 10536));
});
var LWCTextSection = (0,dynamicEntry/* dynamicEntry */.f)(function() {
    return __webpack_require__.e(/* import() */ 1344).then(__webpack_require__.bind(__webpack_require__, 11344));
});
var MapBackgroundHero = (0,dynamicEntry/* dynamicEntry */.f)(function() {
    return __webpack_require__.e(/* import() */ 5715).then(__webpack_require__.bind(__webpack_require__, 55715));
});
var MarketStats = (0,dynamicEntry/* dynamicEntry */.f)(function() {
    return __webpack_require__.e(/* import() */ 7072).then(__webpack_require__.bind(__webpack_require__, 27072));
});
var Multicard = (0,dynamicEntry/* dynamicEntry */.f)(function() {
    return __webpack_require__.e(/* import() */ 6766).then(__webpack_require__.bind(__webpack_require__, 26766));
});
var OpenPositions = (0,dynamicEntry/* dynamicEntry */.f)(function() {
    return __webpack_require__.e(/* import() */ 7380).then(__webpack_require__.bind(__webpack_require__, 37380));
});
var OptionsComparison = (0,dynamicEntry/* dynamicEntry */.f)(function() {
    return __webpack_require__.e(/* import() */ 9555).then(__webpack_require__.bind(__webpack_require__, 79555));
});
var Quotation = (0,dynamicEntry/* dynamicEntry */.f)(function() {
    return __webpack_require__.e(/* import() */ 3504).then(__webpack_require__.bind(__webpack_require__, 43504));
});
var Reviews = (0,dynamicEntry/* dynamicEntry */.f)(function() {
    return __webpack_require__.e(/* import() */ 5079).then(__webpack_require__.bind(__webpack_require__, 75079));
});
var Spacer = (0,dynamicEntry/* dynamicEntry */.f)(function() {
    return __webpack_require__.e(/* import() */ 5739).then(__webpack_require__.bind(__webpack_require__, 95739));
});
var StandaloneText = (0,dynamicEntry/* dynamicEntry */.f)(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 51831));
});
var SuperIframe = (0,dynamicEntry/* dynamicEntry */.f)(function() {
    return __webpack_require__.e(/* import() */ 6018).then(__webpack_require__.bind(__webpack_require__, 56018));
});
var TimeSavingsCalculator = (0,dynamicEntry/* dynamicEntry */.f)(function() {
    return Promise.all(/* import() */[__webpack_require__.e(5252), __webpack_require__.e(303)]).then(__webpack_require__.bind(__webpack_require__, 303));
});
var VideoPlayer = (0,dynamicEntry/* dynamicEntry */.f)(function() {
    return __webpack_require__.e(/* import() */ 7881).then(__webpack_require__.bind(__webpack_require__, 47881));
});
var TrustpilotWidget = (0,dynamicEntry/* dynamicEntry */.f)(function() {
    return __webpack_require__.e(/* import() */ 4314).then(__webpack_require__.bind(__webpack_require__, 14314));
});
var FCHero = (0,dynamicEntry/* dynamicEntry */.f)(function() {
    return __webpack_require__.e(/* import() */ 9925).then(__webpack_require__.bind(__webpack_require__, 29925));
});
var FCTrustBanner = (0,dynamicEntry/* dynamicEntry */.f)(function() {
    return __webpack_require__.e(/* import() */ 6193).then(__webpack_require__.bind(__webpack_require__, 6193));
});
var FCValueTracker = (0,dynamicEntry/* dynamicEntry */.f)(function() {
    return __webpack_require__.e(/* import() */ 9046).then(__webpack_require__.bind(__webpack_require__, 39046));
});
var FCThreeSteps = (0,dynamicEntry/* dynamicEntry */.f)(function() {
    return __webpack_require__.e(/* import() */ 2141).then(__webpack_require__.bind(__webpack_require__, 72141));
});
var FCProductOptions = (0,dynamicEntry/* dynamicEntry */.f)(function() {
    return __webpack_require__.e(/* import() */ 5410).then(__webpack_require__.bind(__webpack_require__, 85410));
});
var FCTestimonialCarousel = (0,dynamicEntry/* dynamicEntry */.f)(function() {
    return __webpack_require__.e(/* import() */ 2815).then(__webpack_require__.bind(__webpack_require__, 62815));
});
var FCMap = (0,dynamicEntry/* dynamicEntry */.f)(function() {
    return __webpack_require__.e(/* import() */ 1792).then(__webpack_require__.bind(__webpack_require__, 61792));
});
var FCMissionStatement = (0,dynamicEntry/* dynamicEntry */.f)(function() {
    return __webpack_require__.e(/* import() */ 4543).then(__webpack_require__.bind(__webpack_require__, 84543));
});
var FCContactUs = (0,dynamicEntry/* dynamicEntry */.f)(function() {
    return __webpack_require__.e(/* import() */ 2483).then(__webpack_require__.bind(__webpack_require__, 72483));
});
var TextBanner = (0,dynamicEntry/* dynamicEntry */.f)(function() {
    return __webpack_require__.e(/* import() */ 7924).then(__webpack_require__.bind(__webpack_require__, 77924));
});
var CustomBlock = (0,dynamicEntry/* dynamicEntry */.f)(function() {
    return __webpack_require__.e(/* import() */ 8270).then(__webpack_require__.bind(__webpack_require__, 38270));
});
var PhotoTestimonials = (0,dynamicEntry/* dynamicEntry */.f)(function() {
    return __webpack_require__.e(/* import() */ 7195).then(__webpack_require__.bind(__webpack_require__, 27195));
});
var landingPageV2EntryLookup = {
    block: {
        compareHero: landing_pages_v2_CompareHero,
        compareTable: CompareTable,
        compareFees: CompareFees,
        compareReviews: CompareReviews,
        compareVideoTestimonial: CompareVideoTestimonial,
        comparePhotoTestimonials: ComparePhotoTestimonials,
        compareFinalCta: CompareFinalCta,
        lpComponentMapBackgroundHero: MapBackgroundHero,
        lpComponentCarouselCards: CarouselCards,
        lpComponentImageCard: ImageCard,
        lpComponentFaqDisplay: FAQsDisplay,
        lpComponentHeroV2: HeroV2/* default */.Z,
        lpComponentContactSection: ContactSection,
        lpComponentLwcTextSection: LWCTextSection,
        lpComponentLwcHeroCard: LWCHeroCard,
        lpComponentLwcImageCard: LWCImageCard,
        lpComponentHeroV2WithMarkers: HeroV2WithMarkers/* default */.Z,
        lpComponentCTAStandalone: CTAStandalone,
        lpComponentComparisonTable: ComparisonTable,
        lpComponentFeature5050: Feature5050,
        lpComponentHeaderStandalone: HeaderStandalone,
        lpComponentHeroCta: HeroCTA,
        lpComponentList: List,
        lpComponentStandaloneText: StandaloneText,
        lpComponentMulticard: Multicard,
        lpComponentBasicPageHeader: BasicPageHeader,
        lpComponentLinkList: LinkList,
        lpComponentQuotation: Quotation,
        lpComponentSpacer: Spacer,
        lpComponentOpenPositions: OpenPositions,
        lpComponentOptionsComparison: OptionsComparison,
        lpComponentOpendoorReviews: Reviews,
        lpComponentCalculator: Calculator,
        lpComponentTimeSavingsCalculator: TimeSavingsCalculator,
        // lpComponentCountdownTimer: CountdownTimer,
        lpComponentVideoPlayer: VideoPlayer,
        lpComponentMarketStats: MarketStats,
        trustpilotWidget: TrustpilotWidget,
        componentRelatedExternalLinks: ExternalLinks,
        fcHero: FCHero,
        fcTrustBanner: FCTrustBanner,
        fcValueTracker: FCValueTracker,
        fcThreeSteps: FCThreeSteps,
        fcProductOptions: FCProductOptions,
        fcTestimonialCarousel: FCTestimonialCarousel,
        fcMap: FCMap,
        fcMissionStatement: FCMissionStatement,
        fcContactUs: FCContactUs,
        lpComponentTextBanner: TextBanner,
        lpComponentCustomBlock: CustomBlock,
        lpComponentPhotoTestimonials: PhotoTestimonials,
        componentSuperIframe: SuperIframe
    },
    inline: {}
};
/* harmony default export */ var landingPageV2 = (landingPageV2EntryLookup);


/***/ }),

/***/ 96887:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "AL": function() { return /* binding */ fetchLandingPageV2BySlug; },
  "Mq": function() { return /* binding */ getCashOfferModal; },
  "$C": function() { return /* binding */ transformHeaderNavToMegaNav; }
});

// UNUSED EXPORTS: fetchArticleBySlug, fetchMainSiteFooter, fetchMainSiteHeader, fetchMainSiteHeaderAndFooter, getHeaderFooterStaticProps

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var src_async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var src_object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var src_object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var src_sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/@contentful/rich-text-plain-text-renderer/dist/rich-text-plain-text-renderer.es5.js
var rich_text_plain_text_renderer_es5 = __webpack_require__(32924);
// EXTERNAL MODULE: ./node_modules/@opendoor/observability/dist/observability-slim.mjs
var observability_slim = __webpack_require__(74593);
// EXTERNAL MODULE: ./src/cms/api.ts
var api = __webpack_require__(96141);
// EXTERNAL MODULE: ./src/cms/entries/articleV2.ts + 15 modules
var articleV2 = __webpack_require__(93746);
// EXTERNAL MODULE: ./src/cms/entries/landingPageV2.ts + 1 modules
var landingPageV2 = __webpack_require__(43862);
;// CONCATENATED MODULE: ./src/cms/loaders.ts



function loaders_hydrateEntries(options) {
    var includes = options.includes, entryLookup = options.entryLookup, root = options.root, pageContext = options.pageContext;
    // The rest of the function implementation remains the same
    var loaderPromises = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        var _loop = function() {
            var x = _step.value;
            var contentType = x.sys.contentType.sys.id;
            var entryId = x.sys.id;
            if (!contentType) {
                return "continue";
            }
            var entryComponent = entryLookup.block[contentType];
            if (!(entryComponent === null || entryComponent === void 0 ? void 0 : entryComponent.loader)) {
                return "continue";
            }
            var loader = entryComponent === null || entryComponent === void 0 ? void 0 : entryComponent.loader;
            var safeLoader = function() {
                var _ref = (0,src_async_to_generator/* default */.Z)(function() {
                    var results, e, _obj, ref;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    loader(x, root, {
                                        paginationIndex: (pageContext === null || pageContext === void 0 ? void 0 : pageContext.pageNum) || 1,
                                        url: pageContext.url
                                    })
                                ];
                            case 1:
                                results = _state.sent();
                                return [
                                    2,
                                    [
                                        entryId,
                                        results
                                    ]
                                ];
                            case 2:
                                e = _state.sent();
                                (ref = (_obj = observability_slim/* globalObservability.getSentryClient */.w.getSentryClient()).captureException) === null || ref === void 0 ? void 0 : ref.call(_obj, e, {
                                    data: {
                                        entryId: entryId
                                    }
                                });
                                return [
                                    2,
                                    [
                                        entryId,
                                        null
                                    ]
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                });
                return function safeLoader() {
                    return _ref.apply(this, arguments);
                };
            }();
            loaderPromises.push(safeLoader());
        };
        for(var _iterator = includes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return loaderPromises;
}

;// CONCATENATED MODULE: ./src/cms/index.ts












/**
 * Fetch depth required to support MegaNav structure:
 * Page → header → mainNav → sections → links
 */ var FETCH_DEEP = 4;
var FETCH_SHALLOW = 2;
var sysFields = (/* unused pure expression or super */ null && ([
    "createdAt",
    "updatedAt"
]));
var metaFields = (/* unused pure expression or super */ null && ([
    "tags"
]));
var selectedFields = (/* unused pure expression or super */ null && ([
    "slug",
    "seoBase",
    "authors",
    "showAuthorFooter",
    "articleName",
    "articleSubtitle",
    "header",
    "footer",
    // no relatedArticles
    "headerSummary",
    "headerImage",
    "keyTakeaways",
    "body",
    "editors",
    "reviewers",
    "openGraph",
    "openGraphArticle",
    "twitterCard",
    "publisher",
    "publishDate",
    "actualizationDate",
    "hideReadingTime",
    "stickyAddressWidget", 
]));
function fetchArticleMetadata(client, slug) {
    return _fetchArticleMetadata.apply(this, arguments);
}
function _fetchArticleMetadata() {
    _fetchArticleMetadata = _async_to_generator(function(client, slug) {
        var fieldsWithoutBody, entry;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    fieldsWithoutBody = selectedFields.filter(function(f) {
                        return f !== "body" && f !== "keyTakeaways";
                    });
                    return [
                        4,
                        client.getEntries({
                            content_type: "article",
                            include: FETCH_DEEP,
                            "fields.slug": slug,
                            select: sysFields.map(function(x) {
                                return "sys.".concat(x);
                            }).concat(fieldsWithoutBody.map(function(x) {
                                return "fields.".concat(x);
                            })).concat(metaFields.map(function(x) {
                                return "metadata.".concat(x);
                            })).join(","),
                            limit: 1
                        })
                    ];
                case 1:
                    entry = _state.sent();
                    return [
                        2,
                        entry.items.length > 0 ? entry : null
                    ];
            }
        });
    });
    return _fetchArticleMetadata.apply(this, arguments);
}
function fetchArticleBody(client, slug) {
    return _fetchArticleBody.apply(this, arguments);
}
function _fetchArticleBody() {
    _fetchArticleBody = _async_to_generator(function(client, slug) {
        var bodyEntry;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        client.getEntries({
                            content_type: "article",
                            include: FETCH_SHALLOW,
                            "fields.slug": slug,
                            select: "fields.body,fields.keyTakeaways",
                            limit: 1
                        })
                    ];
                case 1:
                    bodyEntry = _state.sent();
                    return [
                        2,
                        bodyEntry.items.length > 0 ? bodyEntry : null
                    ];
            }
        });
    });
    return _fetchArticleBody.apply(this, arguments);
}
function mergeArticleData(metadataEntry, bodyEntry) {
    var ref, ref1;
    if (!metadataEntry || !bodyEntry) {
        throw new Error("Cannot merge article data: missing metadata or body");
    }
    var safeMetadata = JSON.parse(metadataEntry.stringifySafe());
    var safeBody = JSON.parse(bodyEntry.stringifySafe());
    var article = safeMetadata.items[0];
    article.fields.body = safeBody.items[0].fields.body;
    article.fields.keyTakeaways = safeBody.items[0].fields.keyTakeaways;
    var ref2, ref3;
    var mergedIncludes = _to_consumable_array((ref2 = (ref = safeMetadata.includes) === null || ref === void 0 ? void 0 : ref.Entry) !== null && ref2 !== void 0 ? ref2 : []).concat(_to_consumable_array((ref3 = (ref1 = safeBody.includes) === null || ref1 === void 0 ? void 0 : ref1.Entry) !== null && ref3 !== void 0 ? ref3 : []));
    return {
        article: article,
        mergedIncludes: mergedIncludes
    };
}
function hydrateArticleEntries(article, mergedIncludes, requestUrl, slug) {
    return _hydrateArticleEntries.apply(this, arguments);
}
function _hydrateArticleEntries() {
    _hydrateArticleEntries = _async_to_generator(function(article, mergedIncludes, requestUrl, slug) {
        var hydratedEntries, e, _obj, ref;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        Promise.all(hydrateEntries({
                            includes: mergedIncludes,
                            entryLookup: articleEntryLookup,
                            root: article,
                            pageContext: {
                                url: requestUrl
                            }
                        }))
                    ];
                case 1:
                    hydratedEntries = _state.sent();
                    return [
                        2,
                        Object.fromEntries(hydratedEntries)
                    ];
                case 2:
                    e = _state.sent();
                    (ref = (_obj = globalObservability.getSentryClient()).captureException) === null || ref === void 0 ? void 0 : ref.call(_obj, e, {
                        data: {
                            slug: slug
                        }
                    });
                    return [
                        2,
                        {}
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return _hydrateArticleEntries.apply(this, arguments);
}
/*
  Mixed-depth fetch strategy for articles:

  To support deep navigation (4 levels) while avoiding oversized responses,
  we fetch metadata and body content separately:
  1. Metadata + navigation (include=4) for full MegaNav structure
  2. Body content (include=1) to keep response size manageable

  This prevents "Invalid string length" errors on articles with many embedded assets
  while maintaining full navigation functionality.
*/ function fetchArticleBySlug(_) {
    return _fetchArticleBySlug.apply(this, arguments);
}
function _fetchArticleBySlug() {
    _fetchArticleBySlug = _async_to_generator(function(param) {
        var slug, requestUrl, ref, client, calculateReadingTime, roundReadingTime, ref1, metadataEntry, bodyEntry, ref2, article, mergedIncludes, _, readingTimeMinutes, idToLoaderData, _keyTakeaways, fields;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    slug = param.slug, requestUrl = param.requestUrl;
                    client = createContentfulClient();
                    calculateReadingTime = function(input) {
                        var WORDS_PER_MINUTE = 200;
                        var matches = input.match(/(\w+)/g);
                        if (!matches) {
                            return null;
                        }
                        return matches.length / WORDS_PER_MINUTE;
                    };
                    roundReadingTime = function(time) {
                        return time !== null ? Math.round(time) : null;
                    };
                    return [
                        4,
                        Promise.all([
                            fetchArticleMetadata(client, slug),
                            fetchArticleBody(client, slug)
                        ])
                    ];
                case 1:
                    ref1 = _sliced_to_array.apply(void 0, [
                        _state.sent(),
                        2
                    ]), metadataEntry = ref1[0], bodyEntry = ref1[1];
                    if (!metadataEntry || !bodyEntry) {
                        return [
                            2,
                            null
                        ];
                    }
                    ref2 = mergeArticleData(metadataEntry, bodyEntry), article = ref2.article, mergedIncludes = ref2.mergedIncludes;
                    _ = article.fields;
                    return [
                        4,
                        getRelatedArticles(article).catch(function() {
                            return [];
                        })
                    ];
                case 2:
                    _.relatedArticles = _state.sent();
                    readingTimeMinutes = roundReadingTime(calculateReadingTime([
                        article.fields.articleName,
                        article.fields.headerSummary,
                        article.fields.keyTakeaways && documentToPlainTextString(article.fields.keyTakeaways),
                        documentToPlainTextString(article.fields.body)
                    ].filter(Boolean).join("")));
                    return [
                        4,
                        hydrateArticleEntries(article, mergedIncludes, requestUrl, slug)
                    ];
                case 3:
                    idToLoaderData = _state.sent();
                    fields = _object_spread_props(_object_spread({}, article.fields), {
                        keyTakeaways: (_keyTakeaways = article.fields.keyTakeaways) !== null && _keyTakeaways !== void 0 ? _keyTakeaways : null
                    });
                    return [
                        2,
                        {
                            sys: {
                                createdAt: article.sys.createdAt,
                                updatedAt: article.sys.updatedAt,
                                tags: ((ref = article.metadata.tags) === null || ref === void 0 ? void 0 : ref.map(function(item) {
                                    var ref;
                                    return item === null || item === void 0 ? void 0 : (ref = item.sys) === null || ref === void 0 ? void 0 : ref.id;
                                }).filter(Boolean)) || []
                            },
                            fields: fields,
                            readingTimeMinutes: readingTimeMinutes,
                            idToLoaderData: idToLoaderData
                        }
                    ];
            }
        });
    });
    return _fetchArticleBySlug.apply(this, arguments);
}
function getRelatedArticles(article) {
    return _getRelatedArticles.apply(this, arguments);
}
function _getRelatedArticles() {
    _getRelatedArticles = _async_to_generator(function(article) {
        var ref, articleWithRelated;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        fetchEntriesById("article", [
                            article.sys.id
                        ], {
                            select: "fields.relatedArticles",
                            include: 0
                        })
                    ];
                case 1:
                    articleWithRelated = _state.sent()[0];
                    return [
                        4,
                        fetchEntriesById("article", ((articleWithRelated === null || articleWithRelated === void 0 ? void 0 : (ref = articleWithRelated.fields) === null || ref === void 0 ? void 0 : ref.relatedArticles) || []).map(function(a) {
                            return a.sys.id;
                        }), {
                            select: "fields.slug,fields.authors,fields.articleName"
                        })
                    ];
                case 2:
                    return [
                        2,
                        _state.sent().filter(function(article) {
                            return !!article;
                        })
                    ];
            }
        });
    });
    return _getRelatedArticles.apply(this, arguments);
}
function getCashOfferModal() {
    return _getCashOfferModal.apply(this, arguments);
}
function _getCashOfferModal() {
    _getCashOfferModal = (0,src_async_to_generator/* default */.Z)(function() {
        var cashOfferModal, e, // Capture the exception using the Sentry client
        _obj, ref;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        (0,api/* fetchEntryById */.yR)("lpComponentGetCashOfferModal", "29FQNyPKP58Niqf5jcSM58", {
                            include: FETCH_DEEP
                        })
                    ];
                case 1:
                    cashOfferModal = _state.sent();
                    return [
                        2,
                        cashOfferModal
                    ];
                case 2:
                    e = _state.sent();
                    (ref = (_obj = observability_slim/* globalObservability.getSentryClient */.w.getSentryClient()).captureException) === null || ref === void 0 ? void 0 : ref.call(_obj, e, {
                        data: {
                            entryId: "29FQNyPKP58Niqf5jcSM58"
                        }
                    });
                    return [
                        3,
                        3
                    ];
                case 3:
                    return [
                        2,
                        undefined
                    ];
            }
        });
    });
    return _getCashOfferModal.apply(this, arguments);
}
function fetchLandingPageV2BySlug(_) {
    return _fetchLandingPageV2BySlug.apply(this, arguments);
}
function _fetchLandingPageV2BySlug() {
    _fetchLandingPageV2BySlug = (0,src_async_to_generator/* default */.Z)(function(param) {
        var slug, pageNum, requestUrl, locale, client, entry, safeEntry, page, hydratedEntries, ref, ref1, e, _obj, ref2, idToLoaderData;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    slug = param.slug, pageNum = param.pageNum, requestUrl = param.requestUrl, locale = param.locale;
                    client = (0,api/* createContentfulClient */.u_)();
                    return [
                        4,
                        client.getEntries({
                            content_type: "landingPageV2",
                            /*
      The field "include" specifies how many levels down of nested
      data that this fetch call should return. Please be aware that any
      value greater than 2 may have a significant impact on page performance,
      so it should be used sparingly and content authors should understand the
      impact of overusing components with several levels of nested data.

      Setting to FETCH_DEEP to support MegaNav structure:
      LandingPage → header → mainNav → sections → links
    */ include: FETCH_DEEP,
                            "fields.slug": slug,
                            limit: 1,
                            locale: locale
                        })
                    ];
                case 1:
                    entry = _state.sent();
                    if (entry.items.length === 0) {
                        return [
                            2,
                            null
                        ];
                    }
                    safeEntry = JSON.parse(entry.stringifySafe());
                    page = safeEntry.items[0];
                    hydratedEntries = [];
                    _state.label = 2;
                case 2:
                    _state.trys.push([
                        2,
                        4,
                        ,
                        5
                    ]);
                    return [
                        4,
                        Promise.all(loaders_hydrateEntries({
                            includes: (ref1 = (ref = safeEntry.includes) === null || ref === void 0 ? void 0 : ref.Entry) !== null && ref1 !== void 0 ? ref1 : [],
                            entryLookup: landingPageV2/* default */.Z,
                            root: page,
                            pageContext: {
                                url: requestUrl,
                                pageNum: pageNum
                            }
                        }))
                    ];
                case 3:
                    hydratedEntries = _state.sent();
                    return [
                        3,
                        5
                    ];
                case 4:
                    e = _state.sent();
                    (ref2 = (_obj = observability_slim/* globalObservability.getSentryClient */.w.getSentryClient()).captureException) === null || ref2 === void 0 ? void 0 : ref2.call(_obj, e, {
                        data: {
                            slug: slug
                        }
                    });
                    return [
                        3,
                        5
                    ];
                case 5:
                    idToLoaderData = Object.fromEntries(hydratedEntries);
                    return [
                        2,
                        {
                            fields: page.fields,
                            idToLoaderData: idToLoaderData,
                            markets: [],
                            public: page.fields.public
                        }
                    ];
            }
        });
    });
    return _fetchLandingPageV2BySlug.apply(this, arguments);
}
/**
 * Type guard: Check if item is a SimpleList (has sections) or just a Link
 */ function isSimpleList(item) {
    return (item === null || item === void 0 ? void 0 : item.fields) != null && "title" in item.fields && "links" in item.fields;
}
/**
 * Transforms a simple link (ILpElementLink) to { name, href }
 */ function transformSimpleLink(link) {
    var ref, ref1;
    return {
        name: ((ref = link.fields) === null || ref === void 0 ? void 0 : ref.text) || "",
        href: ((ref1 = link.fields) === null || ref1 === void 0 ? void 0 : ref1.url) || ""
    };
}
/**
 * Transforms a section (ILpElementSimpleList with nested ILpElementLink items)
 */ function transformSection(section) {
    var ref;
    var links = ((ref = section.fields.links) === null || ref === void 0 ? void 0 : ref.filter(function(link) {
        return link != null;
    }).map(function(link) {
        return transformSimpleLink(link);
    })) || [];
    return {
        title: section.fields.title || "",
        links: links
    };
}
/**
 * Transforms ISiteHeader mainNav into MegaNavItem[] format
 *
 * Two patterns:
 * 1. ILpElementLink → Simple nav item (e.g., "Agents")
 * 2. ILpElementSimpleList → Nav with dropdown containing sections (each section is also ILpElementSimpleList)
 */ function transformHeaderNavToMegaNav(mainNav) {
    if (!(mainNav === null || mainNav === void 0 ? void 0 : mainNav.length)) return [];
    return mainNav.filter(function(item) {
        return item === null || item === void 0 ? void 0 : item.fields;
    }).map(function(navItem) {
        var ref, ref1, ref2, ref3;
        // Pattern 1: Simple link without dropdown
        if (!isSimpleList(navItem)) {
            return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, transformSimpleLink(navItem)), {
                sections: undefined
            });
        }
        // Pattern 2: Nav item with dropdown sections
        var sections = (((ref = navItem.fields) === null || ref === void 0 ? void 0 : ref.links) || []).filter(function(link) {
            return link && isSimpleList(link);
        }).map(function(section) {
            return transformSection(section);
        });
        if (sections.length === 0) return null;
        return {
            name: ((ref1 = navItem.fields) === null || ref1 === void 0 ? void 0 : ref1.title) || "",
            href: ((ref3 = (ref2 = sections[0]) === null || ref2 === void 0 ? void 0 : ref2.links[0]) === null || ref3 === void 0 ? void 0 : ref3.href) || "#",
            sections: sections
        };
    }).filter(function(item) {
        return item !== null;
    });
}
// Default Contentful entry IDs for global header/footer
var DEFAULT_HEADER_ENTRY_ID = "17QZKVW8LvgeQ2PY4kMoxC"; // "Default - Global Nav"
var DEFAULT_FOOTER_ENTRY_ID = "7xQR3lEo4pIkwZx2RdRqFC"; // "Default SiteFooter"
/**
 * Fetches the main site header by its Contentful entry ID.
 * This allows non-CMS pages (like marketplace) to use the same header/meganav.
 *
 * Uses FETCH_DEEP (4) to get nested nav structure:
 * header → mainNav → sections → links
 *
 * Results are cached in-memory for NAV_HEADER_CACHE_TTL_MS to reduce
 * Contentful API calls during SSR. The cache is per-process, so each
 * server instance maintains its own copy.
 */ var NAV_HEADER_CACHE_TTL_MS = 60000;
var cachedHeader = null;
function fetchMainSiteHeader() {
    return _fetchMainSiteHeader.apply(this, arguments);
}
function _fetchMainSiteHeader() {
    _fetchMainSiteHeader = _async_to_generator(function() {
        var header, error, _obj, ref;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (cachedHeader && Date.now() < cachedHeader.expiresAt) {
                        return [
                            2,
                            cachedHeader.data
                        ];
                    }
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        fetchEntryById("siteHeader", DEFAULT_HEADER_ENTRY_ID, {
                            include: FETCH_DEEP
                        })
                    ];
                case 2:
                    header = _state.sent();
                    cachedHeader = {
                        data: header,
                        expiresAt: Date.now() + NAV_HEADER_CACHE_TTL_MS
                    };
                    return [
                        2,
                        cachedHeader.data
                    ];
                case 3:
                    error = _state.sent();
                    (ref = (_obj = globalObservability.getSentryClient()).captureException) === null || ref === void 0 ? void 0 : ref.call(_obj, error, {
                        data: {
                            entryId: DEFAULT_HEADER_ENTRY_ID
                        }
                    });
                    return [
                        2,
                        null
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return _fetchMainSiteHeader.apply(this, arguments);
}
/**
 * Fetches the main site footer by its Contentful entry ID.
 * This allows non-CMS pages (like marketplace) to use the same footer.
 *
 * Uses FETCH_DEEP (4) to get nested nav structure:
 * footer → footerNav → links
 */ function fetchMainSiteFooter() {
    return _fetchMainSiteFooter.apply(this, arguments);
}
function _fetchMainSiteFooter() {
    _fetchMainSiteFooter = _async_to_generator(function() {
        var footer, error, _obj, ref;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        fetchEntryById("siteFooter", DEFAULT_FOOTER_ENTRY_ID, {
                            include: FETCH_DEEP
                        })
                    ];
                case 1:
                    footer = _state.sent();
                    return [
                        2,
                        footer
                    ];
                case 2:
                    error = _state.sent();
                    (ref = (_obj = globalObservability.getSentryClient()).captureException) === null || ref === void 0 ? void 0 : ref.call(_obj, error, {
                        data: {
                            entryId: DEFAULT_FOOTER_ENTRY_ID
                        }
                    });
                    return [
                        2,
                        null
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return _fetchMainSiteFooter.apply(this, arguments);
}
/**
 * Fetches both the main site header and footer by their Contentful entry IDs.
 * More efficient than calling fetchMainSiteHeader and fetchMainSiteFooter separately.
 */ function fetchMainSiteHeaderAndFooter() {
    return _fetchMainSiteHeaderAndFooter.apply(this, arguments);
}
function _fetchMainSiteHeaderAndFooter() {
    _fetchMainSiteHeaderAndFooter = (0,src_async_to_generator/* default */.Z)(function() {
        var ref, header, footer, error, _obj, ref1;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        Promise.all([
                            (0,api/* fetchEntryById */.yR)("siteHeader", DEFAULT_HEADER_ENTRY_ID, {
                                include: FETCH_DEEP
                            }),
                            (0,api/* fetchEntryById */.yR)("siteFooter", DEFAULT_FOOTER_ENTRY_ID, {
                                include: FETCH_DEEP
                            })
                        ])
                    ];
                case 1:
                    ref = src_sliced_to_array/* default.apply */.Z.apply(void 0, [
                        _state.sent(),
                        2
                    ]), header = ref[0], footer = ref[1];
                    return [
                        2,
                        {
                            header: header !== null && header !== void 0 ? header : null,
                            footer: footer !== null && footer !== void 0 ? footer : null
                        }
                    ];
                case 2:
                    error = _state.sent();
                    (ref1 = (_obj = observability_slim/* globalObservability.getSentryClient */.w.getSentryClient()).captureException) === null || ref1 === void 0 ? void 0 : ref1.call(_obj, error, {
                        data: {
                            headerEntryId: DEFAULT_HEADER_ENTRY_ID,
                            footerEntryId: DEFAULT_FOOTER_ENTRY_ID
                        }
                    });
                    return [
                        2,
                        {
                            header: null,
                            footer: null
                        }
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return _fetchMainSiteHeaderAndFooter.apply(this, arguments);
}
var getHeaderFooterStaticProps = function() {
    var _ref = (0,src_async_to_generator/* default */.Z)(function() {
        var ref, header, footer, e;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        fetchMainSiteHeaderAndFooter()
                    ];
                case 1:
                    ref = _state.sent(), header = ref.header, footer = ref.footer;
                    return [
                        2,
                        {
                            props: {
                                header: header,
                                footer: footer
                            },
                            revalidate: 60
                        }
                    ];
                case 2:
                    e = _state.sent();
                    return [
                        2,
                        {
                            props: {
                                header: null,
                                footer: null
                            },
                            revalidate: 60
                        }
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function getHeaderFooterStaticProps() {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 23609:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ isAsset; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(46523);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(2267);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(76614);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(22470);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);





// Prevents hydration errors by only rendering on client
var ReactPlayer = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 2004).then(__webpack_require__.t.bind(__webpack_require__, 22004, 23));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(22004)
            ];
        }
    },
    ssr: false
});
var isAsset = function(x) {
    return x.file && x.file.url && x.file.contentType;
};
var isImageAsset = function(asset) {
    var ref;
    return asset.file.contentType.startsWith("image/") && ((ref = asset.file.details) === null || ref === void 0 ? void 0 : ref.image) != null;
};
var isVideoAsset = function(asset) {
    return asset.file.contentType.startsWith("video/");
};
var contentfulLoader = function(props) {
    var src = props.src, width = props.width, quality = props.quality;
    return "".concat(src, "?w=").concat(width, "&q=").concat(quality || 75);
};
var renderImage = function(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
        loader: contentfulLoader,
        layout: "responsive",
        src: props.src,
        sizes: "(max-width: 992px) 100vw, 50vw",
        alt: props.description || "Article image",
        width: props.width,
        height: props.height
    });
};
var VideoPlayer = function(props) {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), isPlaying = ref[0], setIsPlaying = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(true), showPlayButton = ref1[0], setShowPlayButton = ref1[1];
    var playerRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    var handlePlayClick = function() {
        setIsPlaying(true);
        setShowPlayButton(false);
    };
    var handlePause = function() {
        setIsPlaying(false);
        setShowPlayButton(true);
    };
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_4__/* .Box */ .x, {
        position: "relative",
        pt: "56.25%" // 16:9 aspect ratio
        ,
        display: "flex",
        justifyContent: "center",
        overflow: "hidden",
        borderRadius: "$16x",
        backgroundColor: "$backgroundInversePrimary",
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(ReactPlayer, {
                ref: playerRef,
                url: props.src,
                controls: true,
                playing: isPlaying,
                onPlay: handlePlayClick,
                onPause: handlePause,
                playsinline: true,
                width: "100%",
                height: "100%",
                style: {
                    position: "absolute",
                    left: 0,
                    top: 0
                }
            }),
            showPlayButton && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_5__/* .PressableBox */ .K, {
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                cursor: "pointer",
                zIndex: 10,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                onPress: handlePlayClick,
                "aria-label": "Play video",
                analyticsName: "video-play-button",
                style: {
                    width: "80px",
                    height: "80px",
                    borderRadius: "50%",
                    backgroundColor: "rgba(0, 0, 0, 0.7)"
                },
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("svg", {
                    width: "28",
                    height: "28",
                    viewBox: "0 0 28 28",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("path", {
                        d: "M21 14.5833L9.33337 22.1667L9.33337 7L21 14.5833Z",
                        fill: "white"
                    })
                })
            })
        ]
    });
};
var renderAsset = function(props) {
    // Create a ContentfulAsset-like object to use with helper functions
    var asset = {
        file: {
            url: props.src,
            contentType: props.contentType,
            details: {
                image: props.width && props.height ? {
                    width: props.width,
                    height: props.height
                } : undefined
            }
        },
        description: props.description
    };
    if (isImageAsset(asset)) {
        return renderImage({
            src: props.src,
            description: props.description,
            width: props.width,
            height: props.height
        });
    } else if (isVideoAsset(asset)) {
        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(VideoPlayer, {
            src: props.src,
            description: props.description
        });
    }
    // Fallback for unsupported asset types
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_4__/* .Box */ .x, {
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_6__/* .Text */ .x, {
                tag: "p",
                typography: "$bodyMedium",
                children: [
                    "Unsupported asset type: ",
                    props.contentType
                ]
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_7__/* .Link */ .r, {
                href: props.src,
                target: "_blank",
                "aria-label": "Download ".concat(props.description || "asset"),
                analyticsName: "asset-download",
                variant: "primary",
                children: [
                    "Download ",
                    props.description || "asset"
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (renderAsset);


/***/ }),

/***/ 32239:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ getLinkForAnchorTagWithId; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(51438);
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(28668);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(10253);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(71418);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _contentful_rich_text_react_renderer__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(74129);
/* harmony import */ var _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(86437);
/* harmony import */ var _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(76614);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(37122);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(22470);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(46523);
/* harmony import */ var _opendoor_observability_slim__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(74593);
/* harmony import */ var lodash_isEqual__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(18446);
/* harmony import */ var lodash_isEqual__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lodash_isEqual__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _components_globals__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(35480);
/* harmony import */ var _assets__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(23609);














var Sentry = _opendoor_observability_slim__WEBPACK_IMPORTED_MODULE_3__/* .globalObservability.getSentryClient */ .w.getSentryClient();
var getLinkForAnchorTagWithId = function(input) {
    var output = "";
    for(var i = 0; i < input.length; i++){
        var curr = input[i];
        if (curr === "-") {
            output = output + "-";
            continue;
        }
        if (curr.match(/\s/)) {
            output = output + "-";
            continue;
        }
        if (curr.match(/\W/)) {
            continue;
        }
        output = output + curr.toLowerCase();
    }
    output = output.replace(/-$/, "");
    var id = output.replaceAll(/-+/g, "-");
    return "#".concat(id);
};
var EntryErrorBoundary = /*#__PURE__*/ function(Component) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(EntryErrorBoundary, Component);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(EntryErrorBoundary);
    function EntryErrorBoundary(props) {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(this, EntryErrorBoundary);
        var _this;
        _this = _super.call(this, props);
        _this.state = {
            hasError: false
        };
        return _this;
    }
    var _proto = EntryErrorBoundary.prototype;
    _proto.componentDidCatch = function componentDidCatch(error, errorInfo) {
        var ref;
        (ref = Sentry.captureException) === null || ref === void 0 ? void 0 : ref.call(Sentry, error, {
            captureContext: {
                extra: {
                    errorInfo: errorInfo,
                    entry: this.props.entry,
                    loaderData: this.props.loaderData
                }
            }
        });
    };
    _proto.render = function render() {
        if (this.state.hasError) {
            return null;
        }
        return this.props.children;
    };
    EntryErrorBoundary.getDerivedStateFromError = function getDerivedStateFromError() {
        // Update state so the next render will show the fallback UI.
        return {
            hasError: true
        };
    };
    return EntryErrorBoundary;
}(react__WEBPACK_IMPORTED_MODULE_0__.Component);
/***
 * If you're not in prod and you add a "?dev" query param to your url it will
 * wrap each component and apply a label so you know exactly which component you're
 * currently looking at.
 */ var DevOverlay = function(param) {
    var contentTypeId = param.contentTypeId, children = param.children;
    var ref = useState(false), showOverlay = ref[0], setShowOverlay = ref[1];
    useEffect(function() {
        setShowOverlay(new URLSearchParams(window.location.search).has("dev"));
    }, []);
    if (!showOverlay) {
        return children;
    }
    return /*#__PURE__*/ _jsxs("div", {
        "data-dev-overlay": contentTypeId,
        style: {
            position: "relative",
            display: "flow-root"
        },
        children: [
            /*#__PURE__*/ _jsx("style", {
                children: "\n        [data-dev-overlay]::before {\n          content: attr(data-dev-overlay);\n          position: absolute;\n          top: 0;\n          left: 0;\n          background: salmon;\n          color: white;\n          font-size: 12px;\n          padding: 2px 6px;\n          border-bottom-right-radius: 4px;\n          pointer-events: none;\n          z-index: 9999;\n        }\n        [data-dev-overlay]::after {\n          content: '';\n          position: absolute;\n          inset: 0;\n          border: 2px solid salmon;\n          pointer-events: none;\n          z-index: 9999;\n        }\n      "
            }),
            children
        ]
    });
};
var RendererComponent = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.memo)(function(props) {
    return new RichTextRenderer(props).render();
}, function(prev, next) {
    return Object.entries(prev).every(function(param) {
        var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(param, 2), k = _param[0], v = _param[1];
        return lodash_isEqual__WEBPACK_IMPORTED_MODULE_4___default()(v, next[k]);
    });
});
RendererComponent.displayName = "RichTextRenderer";
var isAllText = function(content) {
    return content.every(function(c) {
        return _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_2__.helpers.isText(c);
    });
};
var RichTextRenderer = /*#__PURE__*/ function() {
    "use strict";
    function RichTextRenderer(param) {
        var body = param.body, idToLoaderData = param.idToLoaderData, entryLookup = param.entryLookup;
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(this, RichTextRenderer);
        this.body = body;
        this.idToLoaderData = idToLoaderData;
        this.entryLookup = entryLookup;
        this.options = this.getOption();
        this.generatedIds = {};
    }
    var _proto = RichTextRenderer.prototype;
    _proto.generateId = function generateId(content) {
        if (!isAllText(content)) {
            return null;
        }
        // Type hint, in the "skipId" section, we verified there
        // are only
        var input = content.reduce(function(acc, curr) {
            return acc + curr.value;
        }, "");
        var output = "";
        for(var i = 0; i < input.length; i++){
            var curr = input[i];
            // replace any non word charager with an empty space
            // skip dashes with this
            if (curr === "-") {
                output = output + "-";
                continue;
            }
            // whitespace
            if (curr.match(/\s/)) {
                output = output + "-";
                continue;
            }
            if (curr.match(/\W/)) {
                continue;
            }
            output = output + curr.toLowerCase();
        }
        var id = output.replaceAll(/-+/g, "-");
        // handle duplicates - we'll just increase the appended
        // index if we have a duplicate id
        if (id in this.generatedIds) {
            this.generatedIds[id] += 1;
            id = "".concat(id, "-").concat(this.generatedIds[id]);
        } else {
            this.generatedIds[id] = 0;
        }
        return id;
    };
    _proto.getOption = function getOption() {
        var _this = this;
        var _obj;
        return {
            renderNode: (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_obj, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_2__.BLOCKS.HEADING_1, function(node, children) {
                var id = _this.generateId(node.content);
                return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_13__/* .Text */ .x, {
                    tag: "h1",
                    id: id !== null && id !== void 0 ? id : "",
                    mt: "$1",
                    mb: "$1",
                    color: "$contentPrimary",
                    typography: "$subheaderLarge",
                    $largerThanMD: {
                        typography: "$headerMedium"
                    },
                    "$platform-web": {
                        scrollMarginTop: "80px"
                    },
                    children: children
                });
            }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_obj, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_2__.BLOCKS.HEADING_2, function(node, children) {
                var id = _this.generateId(node.content);
                return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_13__/* .Text */ .x, {
                    tag: "h2",
                    id: id !== null && id !== void 0 ? id : "",
                    mt: "$6",
                    mb: "$4",
                    color: "$contentPrimary",
                    typography: "$subheaderSmall",
                    $largerThanMD: {
                        typography: "$subheaderLarge"
                    },
                    "$platform-web": {
                        scrollMarginTop: "80px"
                    },
                    children: children
                });
            }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_obj, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_2__.BLOCKS.HEADING_3, function(node, children) {
                var id = _this.generateId(node.content);
                return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_13__/* .Text */ .x, {
                    tag: "h3",
                    id: id !== null && id !== void 0 ? id : "",
                    mt: "$5",
                    mb: "$3",
                    color: "$contentPrimary",
                    typography: "$subheaderXsmall",
                    $largerThanMD: {
                        typography: "$subheaderSmall"
                    },
                    "$platform-web": {
                        scrollMarginTop: "80px"
                    },
                    children: children
                });
            }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_obj, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_2__.BLOCKS.QUOTE, function(_, children) {
                return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_14__/* .Col */ .J, {
                    borderRadius: "$4x",
                    py: "$3",
                    px: "$3",
                    width: "100%",
                    backgroundColor: "$backgroundTertiary",
                    $largerThanMD: {
                        py: "$5",
                        px: "$6"
                    },
                    children: children
                });
            }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_obj, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_2__.BLOCKS.EMBEDDED_ENTRY, function(entryData) {
                var ref, ref1, ref2, ref3;
                var entryComponent = _this.entryLookup.block[(ref = entryData.data.target) === null || ref === void 0 ? void 0 : (ref1 = ref.sys) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.contentType) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.sys) === null || ref3 === void 0 ? void 0 : ref3.id];
                if (!entryComponent) {
                    return null;
                }
                return _this.renderEntry(entryComponent, entryData);
            }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_obj, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_2__.BLOCKS.EMBEDDED_ASSET, function(entryData) {
                var ref, ref1, ref2, ref3;
                var fields = entryData.data.target.fields;
                if (!(0,_assets__WEBPACK_IMPORTED_MODULE_6__/* .isAsset */ .X)(fields)) {
                    return null;
                }
                return (0,_assets__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
                    src: fields.file.url,
                    description: fields.description,
                    contentType: fields.file.contentType,
                    width: (ref = fields.file.details) === null || ref === void 0 ? void 0 : (ref1 = ref.image) === null || ref1 === void 0 ? void 0 : ref1.width,
                    height: (ref2 = fields.file.details) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.image) === null || ref3 === void 0 ? void 0 : ref3.height
                });
            }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_obj, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_2__.INLINES.EMBEDDED_ENTRY, function(entryData) {
                var ref, ref1, ref2, ref3;
                var entryComponent = _this.entryLookup.inline[(ref = entryData.data.target) === null || ref === void 0 ? void 0 : (ref1 = ref.sys) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.contentType) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.sys) === null || ref3 === void 0 ? void 0 : ref3.id];
                if (!entryComponent) {
                    return null;
                }
                return _this.renderEntry(entryComponent, entryData);
            }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_obj, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_2__.BLOCKS.HEADING_4, function(node, children) {
                var id = _this.generateId(node.content);
                return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_13__/* .Text */ .x, {
                    tag: "h4",
                    id: id !== null && id !== void 0 ? id : "",
                    typography: "$labelLarge",
                    $largerThanMD: {
                        typography: "$subheaderSmall"
                    },
                    "$platform-web": {
                        scrollMarginTop: "80px"
                    },
                    children: children
                });
            }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_obj, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_2__.BLOCKS.PARAGRAPH, function(entry, children) {
                var paragraphEntryContent = entry.content;
                if (!Array.isArray(children)) {
                    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_13__/* .Text */ .x, {
                        tag: "p",
                        mb: "$2",
                        typography: "$bodyMedium",
                        $largerThanMD: {
                            typography: "$bodyLarge"
                        },
                        children: children
                    });
                }
                // Don't render empty paragraph where the node only contains whitespace text
                var isEmptyParagraph = paragraphEntryContent.length === 1 && paragraphEntryContent[0].nodeType == "text" && typeof paragraphEntryContent[0].value === "string" && paragraphEntryContent[0].value.trim().length === 0;
                if (isEmptyParagraph) {
                    return null;
                }
                var zipped = paragraphEntryContent.map(function(e, i) {
                    return [
                        e,
                        children[i]
                    ];
                });
                var ref = zipped.reduce(function(acc, curr) {
                    var _curr = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(curr, 2), _$entry = _curr[0], child = _curr[1];
                    if (_$entry.nodeType === _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_2__.INLINES.EMBEDDED_ENTRY) {
                        acc.inline = acc.inline.concat(child);
                        return acc;
                    }
                    acc.standard = acc.standard.concat(child);
                    return acc;
                }, {
                    inline: [],
                    standard: []
                }), inline = ref.inline, standard = ref.standard;
                // note: this re-orders the text components, i.e. if you have
                // test <inline entry> test2, it will be rendered as
                // <inline entry> test test2. This doesn't seem ideal, but works
                // for our use-case. We may want to disallow inline embedded entries
                // in the future, and just use the block type.
                return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__/* .jsxs */ .BX)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__/* .Fragment */ .HY, {
                    children: [
                        inline,
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_13__/* .Text */ .x, {
                            tag: "p",
                            my: "$5",
                            typography: "$bodyMedium",
                            $largerThanMD: {
                                typography: "$bodyLarge"
                            },
                            children: standard
                        })
                    ]
                });
            }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_obj, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_2__.INLINES.HYPERLINK, function(node, children) {
                var target = "_blank";
                if (// https://opendoor.atlassian.net/jira/servicedesk/projects/ENGBUGS/queues/custom/1337/ENGBUGS-47459
                // we want all articles referenced in our articles to open in a new tab
                // we only add production urls to contentful
                !node.data.uri.startsWith(_components_globals__WEBPACK_IMPORTED_MODULE_5__/* .COSMOS_URLS.production */ .zu.production + "/articles") && (node.data.uri.startsWith("#") || node.data.uri.startsWith(_components_globals__WEBPACK_IMPORTED_MODULE_5__/* .COSMOS_URLS.production */ .zu.production))) {
                    target = "_self";
                }
                var hrefLink = node.data.uri;
                if (node.data.uri.startsWith("#") && node.content[0].nodeType === "text") {
                    var anchorHref = getLinkForAnchorTagWithId(node.content[0].value);
                    hrefLink = anchorHref;
                }
                return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_15__/* .Link */ .r, {
                    href: hrefLink,
                    analyticsName: "cosmos-articles-renderer",
                    "aria-label": "",
                    target: target,
                    typography: "$bodyMedium",
                    $largerThanMD: {
                        typography: "$bodyLarge"
                    },
                    children: children
                });
            }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_obj, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_2__.BLOCKS.TABLE, function(_, children) {
                return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_16__/* .Box */ .x, {
                    tag: "table",
                    "$platform-web": {
                        display: "table",
                        borderCollapse: "collapse"
                    },
                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_16__/* .Box */ .x, {
                        tag: "tbody",
                        "$platform-web": {
                            display: "table-row-group"
                        },
                        children: children
                    })
                });
            }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_obj, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_2__.BLOCKS.TABLE_CELL, function(_, children) {
                return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_16__/* .Box */ .x, {
                    tag: "td",
                    pr: "$3",
                    $largerThanSM: {
                        pr: "$4"
                    },
                    $largerThanMD: {
                        pr: "$5"
                    },
                    "$platform-web": {
                        display: "table-cell",
                        textAlign: "left",
                        verticalAlign: "middle"
                    },
                    children: children
                });
            }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_obj, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_2__.BLOCKS.TABLE_ROW, function(_, children) {
                return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_16__/* .Box */ .x, {
                    tag: "tr",
                    "$platform-web": {
                        display: "table-row"
                    },
                    children: children
                });
            }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_obj, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_2__.BLOCKS.TABLE_HEADER_CELL, function(_, children) {
                return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_16__/* .Box */ .x, {
                    tag: "th",
                    pr: "$3",
                    $largerThanSM: {
                        pr: "$4"
                    },
                    $largerThanMD: {
                        pr: "$5"
                    },
                    "$platform-web": {
                        display: "table-cell",
                        textAlign: "left",
                        verticalAlign: "middle"
                    },
                    children: children
                });
            }), _obj)
        };
    };
    /**
   * Render an entry safely, with Error Boundaries and safe server-side try-catch
   */ _proto.renderEntry = function renderEntry(entryComponent, entryData) {
        var ref, ref1, ref2, ref3;
        var loaderData = this.idToLoaderData[entryData.data.target.sys.id];
        var ref4 = this, body = ref4.body, idToLoaderData = ref4.idToLoaderData;
        var component;
        /**
     * Render the entry safely server-side
     */ try {
            component = entryComponent.render(entryData.data.target, loaderData, {
                body: body,
                idToLoaderData: idToLoaderData
            });
        } catch (e) {
            var _obj, ref5;
            (ref5 = (_obj = _opendoor_observability_slim__WEBPACK_IMPORTED_MODULE_3__/* .globalObservability.getSentryClient */ .w.getSentryClient()).captureException) === null || ref5 === void 0 ? void 0 : ref5.call(_obj, e, {
                data: {
                    target: entryData.data.target,
                    loaderData: loaderData
                }
            });
            return null;
        }
        var contentTypeId = (ref = entryData.data.target) === null || ref === void 0 ? void 0 : (ref1 = ref.sys) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.contentType) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.sys) === null || ref3 === void 0 ? void 0 : ref3.id;
        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__/* .jsx */ .tZ)(EntryErrorBoundary, {
            entry: entryData.data.target,
            loaderData: loaderData,
            children:  false ? /*#__PURE__*/ 0 : component
        });
    };
    /**
   * Custom memoized rich text renderer, only re-render it at a top-level if the body
   * input has changed (deep diff). Prevents re-renders if something at the top level
   * is misbehaving.
   */ _proto.render = function render() {
        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__/* .jsx */ .tZ)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__/* .Fragment */ .HY, {
            children: (0,_contentful_rich_text_react_renderer__WEBPACK_IMPORTED_MODULE_1__/* .documentToReactComponents */ .h)(this.body, this.options)
        });
    };
    return RichTextRenderer;
}();
RichTextRenderer.Component = RendererComponent;
/* harmony default export */ __webpack_exports__["Z"] = (RichTextRenderer);


/***/ }),

/***/ 46000:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ isSimpleLink; }
/* harmony export */ });
/**
 * Type guard to check if an item is a simple link (ILpElementLink) or a list (ILpElementSimpleList)
 */ function isSimpleLink(item) {
    return (item === null || item === void 0 ? void 0 : item.fields) != null && "text" in item.fields && "url" in item.fields;
}


/***/ }),

/***/ 17965:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ StickyAddressProvider; },
/* harmony export */   "v": function() { return /* binding */ useStickyAddress; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

var StickyAddressContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(null);
var StickyAddressProvider = StickyAddressContext.Provider;
var useStickyAddress = function() {
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(StickyAddressContext);
};


/***/ }),

/***/ 818:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(51438);
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(28668);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(10253);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(71418);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _contentful_rich_text_react_renderer__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(74129);
/* harmony import */ var _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(86437);
/* harmony import */ var _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(76614);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(46523);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(22470);
/* harmony import */ var _opendoor_observability_slim__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(74593);
/* harmony import */ var cms_renderer__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(32239);
/* harmony import */ var lodash_isEqual__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(18446);
/* harmony import */ var lodash_isEqual__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(lodash_isEqual__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _cms_renderer_assets__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(23609);
/* harmony import */ var _components_globals__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(35480);















var Sentry = _opendoor_observability_slim__WEBPACK_IMPORTED_MODULE_3__/* .globalObservability.getSentryClient */ .w.getSentryClient();
var EntryErrorBoundary = /*#__PURE__*/ function(Component) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(EntryErrorBoundary, Component);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(EntryErrorBoundary);
    function EntryErrorBoundary(props) {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(this, EntryErrorBoundary);
        var _this;
        _this = _super.call(this, props);
        _this.state = {
            hasError: false
        };
        return _this;
    }
    var _proto = EntryErrorBoundary.prototype;
    _proto.componentDidCatch = function componentDidCatch(error, errorInfo) {
        var ref;
        (ref = Sentry.captureException) === null || ref === void 0 ? void 0 : ref.call(Sentry, error, {
            captureContext: {
                extra: {
                    errorInfo: errorInfo,
                    entry: this.props.entry,
                    loaderData: this.props.loaderData
                }
            }
        });
    };
    _proto.render = function render() {
        if (this.state.hasError) {
            return null;
        }
        return this.props.children;
    };
    EntryErrorBoundary.getDerivedStateFromError = function getDerivedStateFromError() {
        // Update state so the next render will show the fallback UI.
        return {
            hasError: true
        };
    };
    return EntryErrorBoundary;
}(react__WEBPACK_IMPORTED_MODULE_0__.Component);
var scrollAnchorStyle = {
    scrollMarginTop: "80px"
};
var RendererComponent = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.memo)(function(props) {
    return new RichTextRenderer(props).render();
}, function(prev, next) {
    return Object.entries(prev).every(function(param) {
        var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(param, 2), k = _param[0], v = _param[1];
        return lodash_isEqual__WEBPACK_IMPORTED_MODULE_5___default()(v, next[k]);
    });
});
RendererComponent.displayName = "RichTextRenderer";
var isAllText = function(content) {
    return content.every(function(c) {
        return _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_2__.helpers.isText(c);
    });
};
var RichTextRenderer = /*#__PURE__*/ function() {
    "use strict";
    function RichTextRenderer(param) {
        var body = param.body, idToLoaderData = param.idToLoaderData, entryLookup = param.entryLookup;
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(this, RichTextRenderer);
        this.body = body;
        this.idToLoaderData = idToLoaderData;
        this.entryLookup = entryLookup;
        this.options = this.getOption();
        this.generatedIds = {};
    }
    var _proto = RichTextRenderer.prototype;
    _proto.generateId = function generateId(content) {
        if (!isAllText(content)) {
            return null;
        }
        // Type hint, in the "skipId" section, we verified there
        // are only
        var input = content.reduce(function(acc, curr) {
            return acc + curr.value;
        }, "");
        var output = "";
        for(var i = 0; i < input.length; i++){
            var curr = input[i];
            // replace any non word charager with an empty space
            // skip dashes with this
            if (curr === "-") {
                output = output + "-";
                continue;
            }
            // whitespace
            if (curr.match(/\s/)) {
                output = output + "-";
                continue;
            }
            if (curr.match(/\W/)) {
                continue;
            }
            output = output + curr.toLowerCase();
        }
        var id = output.replaceAll(/-+/g, "-");
        // handle duplicates - we'll just increase the appended
        // index if we have a duplicate id
        if (id in this.generatedIds) {
            this.generatedIds[id] += 1;
            id = "".concat(id, "-").concat(this.generatedIds[id]);
        } else {
            this.generatedIds[id] = 0;
        }
        return id;
    };
    _proto.getOption = function getOption() {
        var _this = this;
        var _obj;
        return {
            renderNode: (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(_obj, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_2__.BLOCKS.HEADING_1, function(node, children) {
                var id = _this.generateId(node.content);
                return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_14__/* .Text */ .x, {
                    display: "block",
                    tag: "h1",
                    typography: "$subheaderLarge",
                    id: id !== null && id !== void 0 ? id : "",
                    style: scrollAnchorStyle,
                    children: children
                });
            }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(_obj, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_2__.BLOCKS.HEADING_2, function(node, children) {
                var id = _this.generateId(node.content);
                return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_14__/* .Text */ .x, {
                    display: "block",
                    id: id !== null && id !== void 0 ? id : "",
                    typography: "$subheaderMedium",
                    tag: "h2",
                    style: scrollAnchorStyle,
                    children: children
                });
            }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(_obj, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_2__.BLOCKS.HEADING_3, function(node, children) {
                var id = _this.generateId(node.content);
                return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_14__/* .Text */ .x, {
                    display: "block",
                    tag: "h3",
                    typography: "$subheaderSmall",
                    id: id !== null && id !== void 0 ? id : "",
                    style: scrollAnchorStyle,
                    children: children
                });
            }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(_obj, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_2__.BLOCKS.HEADING_4, function(node, children) {
                var id = _this.generateId(node.content);
                return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_14__/* .Text */ .x, {
                    display: "block",
                    tag: "h4",
                    id: id !== null && id !== void 0 ? id : "",
                    typography: "$subheaderXsmall",
                    style: scrollAnchorStyle,
                    children: children
                });
            }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(_obj, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_2__.BLOCKS.QUOTE, function(_, children) {
                return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_15__/* .Box */ .x, {
                    tag: "blockquote",
                    borderRadius: "$4x",
                    mx: "$0",
                    p: "$3",
                    $largerThanMD: {
                        p: "$5"
                    },
                    width: "100%",
                    backgroundColor: "$backgroundStateHoverSecondary",
                    children: children
                });
            }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(_obj, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_2__.BLOCKS.EMBEDDED_ENTRY, function(entryData) {
                var ref, ref1, ref2, ref3;
                var entryComponent = _this.entryLookup.block[(ref = entryData.data.target) === null || ref === void 0 ? void 0 : (ref1 = ref.sys) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.contentType) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.sys) === null || ref3 === void 0 ? void 0 : ref3.id];
                if (!entryComponent) {
                    return null;
                }
                return _this.renderEntry(entryComponent, entryData);
            }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(_obj, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_2__.BLOCKS.EMBEDDED_ASSET, function(entryData) {
                var ref, ref1, ref2, ref3, ref4;
                var fields = entryData.data.target.fields;
                if (!(0,_cms_renderer_assets__WEBPACK_IMPORTED_MODULE_6__/* .isAsset */ .X)(fields)) {
                    return null;
                }
                return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_15__/* .Box */ .x, {
                    className: "embedded-entry-wrapper",
                    "$platform-web": {
                        gridColumn: "2 / -2"
                    },
                    children: (0,_cms_renderer_assets__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
                        src: (ref = fields.file) === null || ref === void 0 ? void 0 : ref.url,
                        description: fields.description,
                        width: (ref1 = fields.file.details) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.image) === null || ref2 === void 0 ? void 0 : ref2.width,
                        height: (ref3 = fields.file.details) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.image) === null || ref4 === void 0 ? void 0 : ref4.height,
                        contentType: fields.file.contentType
                    })
                });
            }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(_obj, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_2__.INLINES.EMBEDDED_ENTRY, function(entryData) {
                var ref, ref1, ref2, ref3;
                var entryComponent = _this.entryLookup.inline[(ref = entryData.data.target) === null || ref === void 0 ? void 0 : (ref1 = ref.sys) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.contentType) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.sys) === null || ref3 === void 0 ? void 0 : ref3.id];
                if (!entryComponent) {
                    return null;
                }
                return _this.renderEntry(entryComponent, entryData);
            }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(_obj, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_2__.BLOCKS.PARAGRAPH, function(entry, children) {
                var paragraphEntryContent = entry.content;
                if (!Array.isArray(children)) {
                    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_14__/* .Text */ .x, {
                        display: "block",
                        tag: "p",
                        typography: "$bodyLarge",
                        children: children
                    });
                }
                // Don't render empty paragraph where the node only contains whitespace text
                var isEmptyParagraph = paragraphEntryContent.length === 1 && paragraphEntryContent[0].nodeType == "text" && typeof paragraphEntryContent[0].value === "string" && paragraphEntryContent[0].value.trim().length === 0;
                if (isEmptyParagraph) {
                    return null;
                }
                var zipped = paragraphEntryContent.map(function(e, i) {
                    return [
                        e,
                        children[i]
                    ];
                });
                var ref = zipped.reduce(function(acc, curr) {
                    var _curr = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(curr, 2), _$entry = _curr[0], child = _curr[1];
                    if (_$entry.nodeType === _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_2__.INLINES.EMBEDDED_ENTRY) {
                        acc.inline = acc.inline.concat(child);
                        return acc;
                    }
                    acc.standard = acc.standard.concat(child);
                    return acc;
                }, {
                    inline: [],
                    standard: []
                }), inline = ref.inline, standard = ref.standard;
                // note: this re-orders the text components, i.e. if you have
                // test <inline entry> test2, it will be rendered as
                // <inline entry> test test2. This doesn't seem ideal, but works
                // for our use-case. We may want to disallow inline embedded entries
                // in the future, and just use the block type.
                return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__/* .jsxs */ .BX)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__/* .Fragment */ .HY, {
                    children: [
                        inline,
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_14__/* .Text */ .x, {
                            display: "block",
                            tag: "p",
                            typography: "$bodyMedium",
                            children: standard
                        })
                    ]
                });
            }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(_obj, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_2__.INLINES.HYPERLINK, function(node, children) {
                var target = "_blank";
                if (// https://opendoor.atlassian.net/jira/servicedesk/projects/ENGBUGS/queues/custom/1337/ENGBUGS-47459
                // we want all articles referenced in our articles to open in a new tab
                // we only add production urls to contentful
                !node.data.uri.startsWith(_components_globals__WEBPACK_IMPORTED_MODULE_7__/* .COSMOS_URLS.production */ .zu.production + "/articles") && (node.data.uri.startsWith("#") || node.data.uri.startsWith(_components_globals__WEBPACK_IMPORTED_MODULE_7__/* .COSMOS_URLS.production */ .zu.production))) {
                    target = "_self";
                }
                var hrefLink = node.data.uri;
                if (node.data.uri.startsWith("#") && node.content[0].nodeType === "text") {
                    var anchorHref = (0,cms_renderer__WEBPACK_IMPORTED_MODULE_4__/* .getLinkForAnchorTagWithId */ ._)(node.content[0].value);
                    hrefLink = anchorHref;
                }
                return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_16__/* .Link */ .r, {
                    href: hrefLink,
                    analyticsName: "cosmos-articles-renderer",
                    "aria-label": "",
                    target: target,
                    typography: "$bodyMedium",
                    $largerThanMD: {
                        typography: "$bodyLarge"
                    },
                    children: children
                });
            }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(_obj, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_2__.BLOCKS.TABLE, function(_, children) {
                return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_15__/* .Box */ .x, {
                    tag: "table",
                    "$platform-web": {
                        display: "table",
                        borderCollapse: "collapse"
                    },
                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_15__/* .Box */ .x, {
                        tag: "tbody",
                        "$platform-web": {
                            display: "table-row-group"
                        },
                        children: children
                    })
                });
            }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(_obj, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_2__.BLOCKS.TABLE_CELL, function(_, children) {
                return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_15__/* .Box */ .x, {
                    tag: "td",
                    pr: "$3",
                    $largerThanSM: {
                        pr: "$4"
                    },
                    $largerThanMD: {
                        pr: "$5"
                    },
                    "$platform-web": {
                        display: "table-cell",
                        textAlign: "left",
                        verticalAlign: "middle"
                    },
                    children: children
                });
            }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(_obj, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_2__.BLOCKS.TABLE_ROW, function(_, children) {
                return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_15__/* .Box */ .x, {
                    tag: "tr",
                    "$platform-web": {
                        display: "table-row"
                    },
                    children: children
                });
            }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(_obj, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_2__.BLOCKS.TABLE_HEADER_CELL, function(_, children) {
                return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_15__/* .Box */ .x, {
                    tag: "th",
                    pr: "$3",
                    $largerThanSM: {
                        pr: "$4"
                    },
                    $largerThanMD: {
                        pr: "$5"
                    },
                    "$platform-web": {
                        display: "table-cell",
                        textAlign: "left",
                        verticalAlign: "middle"
                    },
                    children: children
                });
            }), _obj)
        };
    };
    /**
   * Render an entry safely, with Error Boundaries and safe server-side try-catch
   */ _proto.renderEntry = function renderEntry(entryComponent, entryData) {
        var loaderData = this.idToLoaderData[entryData.data.target.sys.id];
        var ref = this, body = ref.body, idToLoaderData = ref.idToLoaderData;
        var component;
        /**
     * Render the entry safely server-side
     */ try {
            component = entryComponent.render(entryData.data.target, loaderData, {
                body: body,
                idToLoaderData: idToLoaderData
            });
        } catch (e) {
            var _obj, ref1;
            (ref1 = (_obj = _opendoor_observability_slim__WEBPACK_IMPORTED_MODULE_3__/* .globalObservability.getSentryClient */ .w.getSentryClient()).captureException) === null || ref1 === void 0 ? void 0 : ref1.call(_obj, e, {
                data: {
                    target: entryData.data.target,
                    loaderData: loaderData
                }
            });
            return null;
        }
        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__/* .jsx */ .tZ)(EntryErrorBoundary, {
            entry: entryData.data.target,
            loaderData: loaderData,
            children: component
        });
    };
    /**
   * Custom memoized rich text renderer, only re-render it at a top-level if the body
   * input has changed (deep diff). Prevents re-renders if something at the top level
   * is misbehaving.
   */ _proto.render = function render() {
        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__/* .jsx */ .tZ)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__/* .Fragment */ .HY, {
            children: (0,_contentful_rich_text_react_renderer__WEBPACK_IMPORTED_MODULE_1__/* .documentToReactComponents */ .h)(this.body, this.options)
        });
    };
    return RichTextRenderer;
}();
RichTextRenderer.Component = RendererComponent;
/* harmony default export */ __webpack_exports__["Z"] = (RichTextRenderer);


/***/ }),

/***/ 17976:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _globals__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35480);



var LazyLoad = function(param) {
    var children = param.children, _offset = param.offset, offset = _offset === void 0 ? _globals__WEBPACK_IMPORTED_MODULE_1__/* .LAZY_LOAD_OFFSET */ .eH : _offset, _once = param.once, once = _once === void 0 ? true : _once, className = param.className;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), isVisible = ref[0], setIsVisible = ref[1];
    var containerRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (!containerRef.current || isVisible && once) return;
        var observer = new IntersectionObserver(function(entries) {
            if (entries[0].isIntersecting) {
                setIsVisible(true);
                if (once) observer.disconnect();
            }
        }, {
            rootMargin: "".concat(offset, "px")
        });
        observer.observe(containerRef.current);
        return function() {
            return observer.disconnect();
        };
    }, [
        isVisible,
        offset,
        once
    ]);
    return(// eslint-disable-next-line @opendoor/no-html-elements
    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)("div", {
        ref: containerRef,
        className: className,
        children: isVisible ? children : null
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (LazyLoad);


/***/ }),

/***/ 11375:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(35944);
/* harmony import */ var _contentful_rich_text_plain_text_renderer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32924);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(22470);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(37122);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(46523);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(6967);
/* harmony import */ var _tabler_icons_react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(13431);
/* harmony import */ var components_landing_pages_v2_shared_Typography__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(78837);
/* harmony import */ var components_shared_Divider__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(2310);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _cms_entries_landingPageV2__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(43862);
/* harmony import */ var _cms_renderer__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(32239);
/* harmony import */ var _Grid__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(74263);










var isDocument = function(value) {
    return typeof value === "object" && value !== null && value.nodeType === "document";
};
var buildFaqSchema = function(faQs) {
    return {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: faQs.filter(function(faq) {
            return Boolean(faq === null || faq === void 0 ? void 0 : faq.fields);
        }).map(function(faq) {
            var _fields = faq.fields, title = _fields.title, body = _fields.body;
            return {
                "@type": "Question",
                name: title !== null && title !== void 0 ? title : "",
                acceptedAnswer: {
                    "@type": "Answer",
                    text: isDocument(body) ? (0,_contentful_rich_text_plain_text_renderer__WEBPACK_IMPORTED_MODULE_0__/* .documentToPlainTextString */ .a)(body) : ""
                }
            };
        })
    };
};
var RenderFAQsDisplay = function(entry) {
    var ref;
    var fields = entry.fields;
    var faqSchema = (fields === null || fields === void 0 ? void 0 : fields.faQs) && fields.faQs.length > 0 ? buildFaqSchema(fields.faQs) : null;
    var viewAllLink = (fields === null || fields === void 0 ? void 0 : fields.viewMoreLinkUrl) ? /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_7__/* .Link */ .r, {
        "aria-label": "View more FAQs",
        analyticsName: "cosmos-landing-page-faqs-display-".concat(fields === null || fields === void 0 ? void 0 : fields.analyticsId),
        href: fields === null || fields === void 0 ? void 0 : fields.viewMoreLinkUrl,
        children: [
            "View all FAQ",
            " ",
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_tabler_icons_react__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                size: 16,
                style: {
                    color: "#0D76D6",
                    verticalAlign: "middle"
                }
            })
        ]
    }) : null;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsxs */ .BX)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .Fragment */ .HY, {
        children: [
            faqSchema && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("script", {
                    type: "application/ld+json",
                    dangerouslySetInnerHTML: {
                        __html: JSON.stringify(faqSchema).replace(/</g, "\\u003c")
                    }
                })
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_9__/* .Col */ .J, {
                analyticsName: "cosmos-landing-page-faqs-display-".concat(fields === null || fields === void 0 ? void 0 : fields.analyticsId),
                trackImpression: true,
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_Grid__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                    backgroundColor: "$backgroundSecondary",
                    py: "$32x",
                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_10__/* .Box */ .x, {
                        "$platform-web": {
                            gridColumn: _Grid__WEBPACK_IMPORTED_MODULE_5__/* .gridStyles.colSpan12 */ .m.colSpan12
                        },
                        width: "100%",
                        flexDirection: "column",
                        $largerThanSM: {
                            flexDirection: "row",
                            pr: "$10x"
                        },
                        $largerThanMD: {
                            pr: "$4x"
                        },
                        alignContent: "center",
                        pr: "$4x",
                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_9__/* .Col */ .J, {
                            width: "100%",
                            gap: "$28x",
                            children: [
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_11__/* .Row */ .X, {
                                    width: "100%",
                                    justifyContent: "space-between",
                                    alignItems: "flex-end",
                                    children: [
                                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(components_landing_pages_v2_shared_Typography__WEBPACK_IMPORTED_MODULE_1__/* .TitleWithAccent */ .aI, {
                                            title: fields === null || fields === void 0 ? void 0 : fields.title,
                                            maxWidth: "unset",
                                            mb: "$0x"
                                        }),
                                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_9__/* .Col */ .J, {
                                            display: "none",
                                            $largerThanSM: {
                                                display: "flex"
                                            },
                                            pb: "$4x",
                                            children: viewAllLink
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_9__/* .Col */ .J, {
                                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_9__/* .Col */ .J, {
                                        children: fields === null || fields === void 0 ? void 0 : (ref = fields.faQs) === null || ref === void 0 ? void 0 : ref.map(function(faq, idx) {
                                            var ref, ref1;
                                            return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_9__/* .Col */ .J, {
                                                children: [
                                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_9__/* .Col */ .J, {
                                                        my: "$20x",
                                                        $largerThanSM: {
                                                            my: "$10x"
                                                        },
                                                        $largerThanMD: {
                                                            my: "$24x"
                                                        },
                                                        display: idx === 0 ? "none" : "flex",
                                                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(components_shared_Divider__WEBPACK_IMPORTED_MODULE_12__/* .Divider */ .i, {})
                                                    }),
                                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_10__/* .Box */ .x, {
                                                        gap: "$10x",
                                                        $largerThanSM: {
                                                            flexDirection: "row",
                                                            gap: "15%",
                                                            alignItems: "flex-start"
                                                        },
                                                        $largerThanLG: {
                                                            pr: "$44x"
                                                        },
                                                        width: "100%",
                                                        flexDirection: "column",
                                                        children: [
                                                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_9__/* .Col */ .J, {
                                                                width: "100%",
                                                                $largerThanSM: {
                                                                    width: "35%"
                                                                },
                                                                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(components_landing_pages_v2_shared_Typography__WEBPACK_IMPORTED_MODULE_1__/* .Subhead */ .vF, {
                                                                    $largerThanMD: {
                                                                        fontSize: 24
                                                                    },
                                                                    children: faq === null || faq === void 0 ? void 0 : (ref = faq.fields) === null || ref === void 0 ? void 0 : ref.title
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_9__/* .Col */ .J, {
                                                                width: "100%",
                                                                $largerThanSM: {
                                                                    width: "55%",
                                                                    mt: -20
                                                                },
                                                                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_cms_renderer__WEBPACK_IMPORTED_MODULE_4__/* ["default"].Component */ .Z.Component, {
                                                                    body: faq === null || faq === void 0 ? void 0 : (ref1 = faq.fields) === null || ref1 === void 0 ? void 0 : ref1.body,
                                                                    idToLoaderData: {},
                                                                    entryLookup: _cms_entries_landingPageV2__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }, idx);
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_9__/* .Col */ .J, {
                                    $largerThanSM: {
                                        display: "none"
                                    },
                                    children: viewAllLink
                                })
                            ]
                        })
                    })
                })
            })
        ]
    });
};
var FAQsDisplay = {
    render: RenderFAQsDisplay
};
/* harmony default export */ __webpack_exports__["default"] = (FAQsDisplay);


/***/ }),

/***/ 74263:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ gridStyles; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99534);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35944);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6967);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(37122);





var gridStyles = {
    colSpan12: "span 12 / span 12"
};
function Grid(_param) {
    var backgroundColor = _param.backgroundColor, children = _param.children, _verticalMargin = _param.verticalMargin, verticalMargin = _verticalMargin === void 0 ? false : _verticalMargin, _horizontalMargin = _param.horizontalMargin, horizontalMargin = _horizontalMargin === void 0 ? true : _horizontalMargin, _maxWidth = _param.maxWidth, maxWidth = _maxWidth === void 0 ? "$1440x" : _maxWidth, mr = _param.mr, ml = _param.ml, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_param, [
        "backgroundColor",
        "children",
        "verticalMargin",
        "horizontalMargin",
        "maxWidth",
        "mr",
        "ml"
    ]);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_2__/* .Row */ .X, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        width: "100%",
        justifyContent: "center"
    }, props), {
        backgroundColor: backgroundColor,
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_2__/* .Row */ .X, {
            width: "100%",
            maxWidth: maxWidth,
            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_5__/* .Col */ .J, {
                flexShrink: 1,
                "$platform-web": {
                    display: "grid",
                    gridTemplateColumns: "repeat(12, minmax(0, 1fr))"
                },
                columnGap: "$0x",
                $largerThanXS: {
                    columnGap: "$8x"
                },
                $largerThanSM: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
                    columnGap: "$10x"
                }, horizontalMargin && !mr ? {
                    mr: "$20x"
                } : {}, horizontalMargin && !ml ? {
                    ml: "$20x"
                } : {}, verticalMargin ? {
                    my: "$20x"
                } : {}),
                $largerThanMD: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, horizontalMargin && !mr ? {
                    mr: "$32x"
                } : {}, horizontalMargin && !ml ? {
                    ml: "$32x"
                } : {}, verticalMargin ? {
                    my: "$32x"
                } : {}),
                my: verticalMargin ? "$10x" : undefined,
                width: "100%",
                mr: mr || (horizontalMargin ? "$10x" : undefined),
                ml: ml || (horizontalMargin ? "$10x" : undefined),
                children: children
            })
        })
    }));
}
/* harmony default export */ __webpack_exports__["Z"] = (Grid);


/***/ }),

/***/ 32296:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "b": function() { return /* binding */ RenderHeroV2; },
  "Z": function() { return /* binding */ landing_pages_v2_HeroV2; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/@opendoor/auth-fe/dist/auth-fe.esm.js
var auth_fe_esm = __webpack_require__(45807);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Box/Box.js
var Box = __webpack_require__(46523);
// EXTERNAL MODULE: ./node_modules/@tamagui/core/dist/cjs/index.js
var cjs = __webpack_require__(86872);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/helpers/markets.ts
var markets = __webpack_require__(65446);
// EXTERNAL MODULE: ./src/components/shared/performance/pictures.tsx
var pictures = __webpack_require__(29212);
// EXTERNAL MODULE: ./src/components/landing-pages-v2/HeroV2.module.css
var HeroV2_module = __webpack_require__(69109);
var HeroV2_module_default = /*#__PURE__*/__webpack_require__.n(HeroV2_module);
// EXTERNAL MODULE: ./src/components/landing-pages-v2/shared/header/glass/constants.ts
var constants = __webpack_require__(97680);
// EXTERNAL MODULE: ./src/components/landing-pages-v2/shared/hero/heroConstants.ts
var heroConstants = __webpack_require__(78986);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js
var emotion_styled_browser_esm = __webpack_require__(37337);
;// CONCATENATED MODULE: ./src/components/landing-pages-v2/shared/hero/HeroImages.tsx







var HeroImageContainer = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(Box/* Box */.x, {
    target: "e19icmec0"
})({
    position: "relative",
    width: "100%",
    objectFit: "cover",
    borderRadius: "540px 540px 0px 0px",
    aspectRatio: "4 / 5",
    overflow: "hidden",
    "@media screen and (min-width: 768px)": {
        borderRadius: "540px 540px 36px 36px"
    }
});
var HeroImages = function(param) {
    var imageDesktopUrl = param.imageDesktopUrl, imageMobileUrl = param.imageMobileUrl, lowBandwidth = param.lowBandwidth;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                display: "none",
                $largerThanMD: {
                    display: "block"
                },
                children: imageDesktopUrl && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HeroImageContainer, {
                    children: (0,pictures/* generatePresetPictureSet */.eY)((0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, heroConstants/* HERO_IMAGE_DESKTOP_PROPS */.t6), {
                        photoUrl: imageDesktopUrl
                    }), lowBandwidth ? {
                        quality: 50
                    } : {}))
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                display: "block",
                $largerThanMD: {
                    display: "none"
                },
                children: imageMobileUrl && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HeroImageContainer, {
                    children: (0,pictures/* generatePresetPictureSet */.eY)((0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, heroConstants/* HERO_IMAGE_MOBILE_PROPS */.Sy), {
                        photoUrl: imageMobileUrl
                    }), lowBandwidth ? {
                        quality: 50
                    } : {}))
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/components/landing-pages-v2/shared/hero/HeroShared.tsx
var HeroShared = __webpack_require__(21076);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Text/index.js
var Text = __webpack_require__(76614);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Button/Button.js
var Button = __webpack_require__(25923);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Box/PressableBox.js
var PressableBox = __webpack_require__(2267);
// EXTERNAL MODULE: ./node_modules/@tabler/icons-react/dist/esm/icons/IconSearch.mjs
var IconSearch = __webpack_require__(13129);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Image/Image.js + 1 modules
var Image = __webpack_require__(97009);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Button/TextButton.js
var TextButton = __webpack_require__(52007);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/__generated__/icons/Checkmark.js
var Checkmark = __webpack_require__(74816);
;// CONCATENATED MODULE: ./src/components/landing-pages-v2/SocialProofBox.tsx




var STUBBED_REVIEWS = [
    {
        rating: 5,
        reviewer: {
            city: "San Antonio",
            productType: "sell"
        }
    },
    {
        rating: 5,
        reviewer: {
            city: "Oklahoma City",
            productType: "sell"
        }
    },
    {
        rating: 5,
        reviewer: {
            city: "Phoenix",
            productType: "sell"
        }
    }, 
];
var usePrefersReducedMotion = function() {
    var ref = (0,react.useState)(false), prefersReducedMotion = ref[0], setPrefersReducedMotion = ref[1];
    (0,react.useEffect)(function() {
        var ref;
        if (false) {}
        setPrefersReducedMotion((ref = window.matchMedia("(prefers-reduced-motion: reduce)")) === null || ref === void 0 ? void 0 : ref.matches);
    }, []);
    return prefersReducedMotion;
};
var SocialProofBox = function(param) {
    var _autoplayInterval = param.autoplayInterval, autoplayInterval = _autoplayInterval === void 0 ? 4000 : _autoplayInterval;
    var prefersReducedMotion = usePrefersReducedMotion();
    var intervalRef = (0,react.useRef)();
    var ref = (0,react.useState)(0), currentReviewIndex = ref[0], setCurrentReviewIndex = ref[1];
    (0,react.useEffect)(function() {
        if (prefersReducedMotion) {
            if (intervalRef.current) {
                clearInterval(intervalRef.current);
            }
            return;
        }
        intervalRef.current = setInterval(function() {
            setCurrentReviewIndex(function(prevIndex) {
                return prevIndex === STUBBED_REVIEWS.length - 1 ? 0 : prevIndex + 1;
            });
        }, autoplayInterval);
        return function() {
            return clearInterval(intervalRef.current);
        };
    }, [
        prefersReducedMotion,
        autoplayInterval
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CarouselFormat, {
        reviews: STUBBED_REVIEWS,
        currentIndex: currentReviewIndex,
        interval: autoplayInterval
    });
};
var FiveStarBanner = function(param) {
    var rating = param.rating;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
        flexDirection: "row",
        gap: "$1x",
        children: new Array(rating).fill("star").map(function(_, index) {
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image/* Image */.E, {
                alt: "Rating star",
                source: {
                    height: 16,
                    uri: "https://images.opendoor.com/source/s3/imgdrop-production/2024-11-1732263853253-76957.svg?service=cosmos&preset=square-2048",
                    width: 16
                }
            }, index);
        })
    });
};
// takes the interval with `infinite` instead of redrawing
// the content constantly to trigger animation, may diverge over time
var fadeInCss = function(interval, index) {
    return /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("transition:all 1s ease-in-out;animation:fadeIn-", index, " ", interval, "ms infinite ease-in-out;@keyframes fadeIn-", index, "{0%{opacity:0;}25%{opacity:1;}100%{opacity:0;}}");
};
var ReviewNav = function() {
    var goToReviews = (0,react.useCallback)(function() {
        return window.location.assign("https://opendoor.com/reviews");
    }, []);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TextButton/* TextButton */.A, {
        analyticsName: "social-proof-carousel-see-reviews",
        "aria-label": "See reviews",
        onPress: goToReviews,
        variant: "primary",
        label: "See reviews",
        fontWeight: "regular",
        size: "small",
        width: 88,
        alignItems: "flex-end",
        $smallerThanLG: {
            size: "xsmall",
            width: 76
        }
    });
};
var CarouselFormat = function(param) {
    var reviews = param.reviews, currentIndex = param.currentIndex, interval = param.interval;
    var ref;
    var prefersReducedMotion = usePrefersReducedMotion();
    if (reviews.length === 0) return null;
    var currentReview = reviews[currentIndex];
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
        flexDirection: "row",
        justifyContent: "space-between",
        gap: "$5x",
        borderRadius: "$12x",
        width: 652,
        padding: "$12x",
        style: {
            background: "rgba(242, 241, 240, 0.64)",
            backdropFilter: "blur(20px)",
            flex: "auto"
        },
        $smallerThanLG: {
            width: "100%",
            padding: "$8x",
            flexDirection: "column",
            gap: "$2x"
        },
        $smallerThanMD: {
            minHeight: 128,
            borderRadius: "$borderAllowance"
        },
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                flexDirection: "column",
                width: "100%",
                style: {
                    flex: "auto"
                },
                css: prefersReducedMotion ? null : fadeInCss(interval, currentIndex),
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FiveStarBanner, {
                        rating: currentReview.rating
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                        flexDirection: "row",
                        alignItems: "center",
                        gap: "$2x",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Text/* Text */.x, {
                                tag: "span",
                                typography: "$bodySmall",
                                color: "$contentSecondary",
                                $smallerThanLG: {
                                    typography: "$bodyXsmall"
                                },
                                children: [
                                    "Seller in\xa0",
                                    currentReview.reviewer.city
                                ]
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                tag: "p",
                                typography: "$labelSmall",
                                color: "$contentAccentBrand",
                                $smallerThanLG: {
                                    typography: "$labelXsmall"
                                },
                                children: ((ref = currentReview.reviewer) === null || ref === void 0 ? void 0 : ref.name) || "Verified Customer"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Checkmark/* default */.Z, {
                                size: 20,
                                color: "$contentAccentBrand"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                        display: "flex",
                        justifyContent: "space-between",
                        flexDirection: "row",
                        gap: "$4x",
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                            tag: "span",
                            typography: "$bodyMedium",
                            color: "$contentPrimary",
                            $smallerThanLG: {
                                typography: "$bodySmall"
                            },
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            children: (currentReview === null || currentReview === void 0 ? void 0 : currentReview.excerpt) || "A great experience from the beginning..."
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                display: "flex",
                justifyContent: "flex-end",
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ReviewNav, {})
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/components/shared/NewSellerFlowAddressInput.tsx
var NewSellerFlowAddressInput = __webpack_require__(4618);
;// CONCATENATED MODULE: ./src/components/landing-pages-v2/shared/hero/HeroTitleAndAddress.tsx










var HeroHeadline = function(param) {
    var title = param.title, subtitle = param.subtitle, isTreatment = param.isTreatment, textColor = param.textColor;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
        flexDirection: "column",
        gap: "$8",
        alignItems: "center",
        $largerThanSM: isTreatment ? {
            alignItems: "flex-start",
            mb: "$4"
        } : undefined,
        $largerThanMD: isTreatment ? undefined : {
            alignItems: "flex-start"
        },
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                tag: "h1",
                typography: "$displayXsmall",
                textAlign: "center"
            }, textColor ? {
                color: textColor
            } : {}), {
                $largerThanSM: isTreatment ? {
                    textAlign: "left"
                } : {
                    typography: "$displaySmall"
                },
                $largerThanMD: isTreatment ? {} : {
                    typography: "$displayMedium",
                    textAlign: "left"
                },
                style: isTreatment ? {
                    lineHeight: "80%"
                } : {},
                children: title
            })),
            subtitle && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                tag: "p",
                typography: "$bodyMedium",
                textAlign: "center"
            }, textColor ? {
                color: textColor
            } : {}), {
                $largerThanSM: isTreatment ? {
                    typography: "$bodyLarge",
                    textAlign: "left"
                } : {
                    typography: "$bodyLarge"
                },
                $largerThanMD: isTreatment ? undefined : {
                    textAlign: "left"
                },
                children: subtitle
            }))
        ]
    });
};
var HeroAddressSection = function(param) {
    var showAddressInput = param.showAddressInput, renderDesktopInput = param.renderDesktopInput, renderMobileInput = param.renderMobileInput, isTreatment = param.isTreatment, textColor = param.textColor;
    if (!showAddressInput) return null;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
        width: "100%",
        zIndex: 10,
        className: "hp-reskin-v2-address-entry-wrapper",
        $largerThanSM: isTreatment ? {
            marginBottom: "$4"
        } : undefined,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                id: "desktop-address-search",
                display: "none",
                $largerThanLG: {
                    display: "block"
                },
                children: renderDesktopInput()
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                id: "mobile-address-search",
                display: "block",
                $largerThanLG: {
                    display: "none"
                },
                children: renderMobileInput()
            }),
            isTreatment && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                typography: "$bodyMedium",
                tag: "p",
                color: textColor || "$contentSecondary",
                textAlign: "center",
                marginTop: "$4",
                $largerThanSM: {
                    textAlign: "left"
                },
                children: "No obligation. Takes 5 minutes. Your information stays private."
            })
        ]
    });
};
var HeroCtaButtonsSection = function(param) {
    var _ctaButton1Text = param.ctaButton1Text, ctaButton1Text = _ctaButton1Text === void 0 ? "Missing label" : _ctaButton1Text, ctaButton1Url = param.ctaButton1Url, showCtaButton2 = param.showCtaButton2, _ctaButton2Text = param.ctaButton2Text, ctaButton2Text = _ctaButton2Text === void 0 ? "Missing label" : _ctaButton2Text, ctaButton2Url = param.ctaButton2Url, analyticsPrefix = param.analyticsPrefix;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
        flexDirection: "column",
        gap: "$6",
        alignItems: "center",
        $largerThanMD: {
            flexDirection: "row",
            alignItems: "flex-start"
        },
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* Button */.z, {
                analyticsName: "".concat(analyticsPrefix, "-cta-button-1"),
                label: ctaButton1Text,
                size: "large",
                variant: "primary",
                href: ctaButton1Url
            }),
            showCtaButton2 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* Button */.z, {
                analyticsName: "".concat(analyticsPrefix, "-cta-button-2"),
                label: ctaButton2Text,
                size: "large",
                variant: "secondary",
                href: ctaButton2Url
            })
        ]
    });
};
var addressInputCommonProps = function(analyticsId, trackingKeyword) {
    return {
        hideLabel: true,
        inputLocation: "hero-cta",
        analyticsPrefix: "cosmos-landing-page-hero-v2".concat(analyticsId ? "-".concat(analyticsId) : ""),
        trackingTaxonomy: "new_homepage",
        trackingKeywords: trackingKeyword
    };
};
var TreatmentSearchButton = function(param) {
    var analyticsPrefix = param.analyticsPrefix, onPress = param.onPress, isLoading = param.isLoading;
    /*#__PURE__*/ return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PressableBox/* PressableBox */.K, {
        disabled: isLoading,
        analyticsName: analyticsPrefix,
        "aria-label": "Search",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: "$15",
        height: "$16",
        borderRadius: "$9x",
        backgroundColor: "$backgroundAccentBrand",
        cursor: "pointer",
        opacity: isLoading ? 0.7 : 1,
        "$platform-web": {
            marginTop: "-20px",
            marginRight: "-16px"
        },
        onPress: function(e) {
            var ref;
            e === null || e === void 0 ? void 0 : (ref = e.stopPropagation) === null || ref === void 0 ? void 0 : ref.call(e);
            onPress === null || onPress === void 0 ? void 0 : onPress();
        },
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconSearch/* default */.Z, {
            size: 24,
            color: "white",
            stroke: 2
        })
    });
};
var StyledDefaultActionButton = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(Button/* Button */.z, {
    target: "e14lmup10"
})("height:60px !important;margin-top:-17.5px;margin-right:-15px;");
var DefaultActionButton = function(param) {
    var label = param.label, analyticsPrefix = param.analyticsPrefix, onPress = param.onPress, isLoading = param.isLoading;
    /*#__PURE__*/ return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledDefaultActionButton, {
        disabled: isLoading,
        analyticsName: analyticsPrefix,
        label: isLoading ? "Loading" : label,
        size: "medium",
        variant: "primary",
        onPress: function(e) {
            var ref;
            e === null || e === void 0 ? void 0 : (ref = e.stopPropagation) === null || ref === void 0 ? void 0 : ref.call(e);
            onPress === null || onPress === void 0 ? void 0 : onPress();
        }
    });
};
var HeroTitleAndAddress = function(param) {
    var analyticsId = param.analyticsId, title = param.title, subtitle = param.subtitle, showAddressInput = param.showAddressInput, showSocialSection = param.showSocialSection, renderDesktopInput = param.renderDesktopInput, renderMobileInput = param.renderMobileInput, additionalAddressContent = param.additionalAddressContent, addressEntryRef = param.addressEntryRef, _addressCtaText = param.addressCtaText, addressCtaText = _addressCtaText === void 0 ? "Get cash offer" : _addressCtaText, _addressCtaTextSmall = param.addressCtaTextSmall, addressCtaTextSmall = _addressCtaTextSmall === void 0 ? "Get offer" : _addressCtaTextSmall, addressCtaPlaceholderText = param.addressCtaPlaceholderText, addressCtaPlaceholderTextSmall = param.addressCtaPlaceholderTextSmall, trackingKeyword = param.trackingKeyword, showCtaButtonsContainer = param.showCtaButtonsContainer, ctaButton1Text = param.ctaButton1Text, ctaButton1Url = param.ctaButton1Url, showCtaButton2 = param.showCtaButton2, ctaButton2Text = param.ctaButton2Text, ctaButton2Url = param.ctaButton2Url, textColor = param.textColor;
    var analyticsPrefix = (0,HeroShared/* useHeroContext */.bx)().analyticsPrefix;
    var isTreatment = Boolean(analyticsId && constants/* TREATMENT_ANALYTICS_IDS.includes */.pj.includes(analyticsId));
    var aiCommonProps = addressInputCommonProps(analyticsId, trackingKeyword);
    var DefaultInput = function(param) {
        var placeholder = param.placeholder, ctaLabel = param.ctaLabel;
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NewSellerFlowAddressInput/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, aiCommonProps), {
            placeholder: placeholder,
            actionButton: function(onPress, isLoading) {
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DefaultActionButton, {
                    analyticsPrefix: analyticsPrefix,
                    label: ctaLabel,
                    onPress: onPress,
                    isLoading: isLoading
                });
            }
        }));
    };
    var TreatmentInput = function(param) {
        var placeholder = param.placeholder;
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NewSellerFlowAddressInput/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, aiCommonProps), {
            placeholder: placeholder,
            actionButton: function(onPress, isLoading) {
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TreatmentSearchButton, {
                    analyticsPrefix: analyticsPrefix,
                    onPress: onPress,
                    isLoading: isLoading
                });
            }
        }));
    };
    var desktopInput = function() {
        if (isTreatment) {
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TreatmentInput, {
                placeholder: addressCtaPlaceholderText || "Enter your home address"
            });
        }
        if (renderDesktopInput) {
            return renderDesktopInput();
        }
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DefaultInput, {
            placeholder: addressCtaPlaceholderText || "Enter your home address",
            ctaLabel: addressCtaText
        });
    };
    var mobileInput = function() {
        if (isTreatment) {
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TreatmentInput, {
                placeholder: addressCtaPlaceholderTextSmall || "Enter an address"
            });
        }
        if (renderMobileInput) {
            return renderMobileInput();
        }
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DefaultInput, {
            placeholder: addressCtaPlaceholderTextSmall || "Enter an address",
            ctaLabel: addressCtaTextSmall
        });
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
        id: "title-and-address-entry",
        flexDirection: "column",
        width: "100%",
        gap: isTreatment ? "$4" : "$8",
        $largerThanSM: {
            gap: isTreatment ? "$0" : "$8"
        },
        $largerThanLG: {
            gap: isTreatment ? "$0" : "$8"
        },
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HeroHeadline, {
                title: title,
                subtitle: subtitle,
                isTreatment: isTreatment,
                textColor: textColor
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                display: "none",
                ref: function(el) {
                    return addressEntryRef(el);
                }
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                display: "flex",
                flexDirection: "column",
                alignItems: isTreatment ? "flex-start" : "center",
                gap: "$4",
                width: "100%",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HeroAddressSection, {
                        showAddressInput: showAddressInput,
                        renderDesktopInput: desktopInput,
                        renderMobileInput: mobileInput,
                        additionalContent: additionalAddressContent,
                        isTreatment: isTreatment,
                        textColor: textColor
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                        $smallerThanMD: {
                            display: "none"
                        },
                        $smallerThanLG: {
                            display: "inherit"
                        },
                        $largerThanMD: {
                            display: "none"
                        },
                        width: "100%",
                        children: showSocialSection && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SocialProofBox, {
                            autoplayInterval: 3000
                        })
                    })
                ]
            }),
            showCtaButtonsContainer && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HeroCtaButtonsSection, {
                ctaButton1Text: ctaButton1Text,
                ctaButton1Url: ctaButton1Url,
                showCtaButton2: showCtaButton2,
                ctaButton2Text: ctaButton2Text,
                ctaButton2Url: ctaButton2Url,
                analyticsPrefix: analyticsPrefix
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/components/landing-pages-v2/shared/hero/PressBox.tsx
var PressBox = __webpack_require__(44636);
// EXTERNAL MODULE: ./src/components/landing-pages-v2/StickyCTAUtility/StickyCTAUtility.tsx
var StickyCTAUtility = __webpack_require__(26557);
;// CONCATENATED MODULE: ./src/components/landing-pages-v2/HeroV2.tsx



















var FullBleedHero = function(param) {
    var fields = param.fields, headline = param.headline, customization = param.customization, analyticsPrefix = param.analyticsPrefix, hideStickyCta = param.hideStickyCta, showStickyCTAUtility = param.showStickyCTAUtility, addressEntryRef = param.addressEntryRef;
    var variant = (customization === null || customization === void 0 ? void 0 : customization.variant) || "default";
    var imageUrl = constants/* FULLBLEED_HERO_IMAGE_URL */.Do;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HeroShared/* HeroProvider */.yL, {
        variant: variant,
        analyticsPrefix: analyticsPrefix,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
            "data-hero": true,
            analyticsName: (customization === null || customization === void 0 ? void 0 : customization.analyticsName) || "cosmos-landing-page-hero-v2-".concat(fields === null || fields === void 0 ? void 0 : fields.analyticsId),
            trackImpression: true,
            inViewThreshold: 0.3,
            position: "relative",
            maxWidth: "$432",
            mx: "auto",
            pt: constants/* GLASS_HEADER_HEIGHT */.$C,
            borderBottomLeftRadius: "$6x",
            borderBottomRightRadius: "$6x",
            minHeight: "$100",
            height: 500,
            $largerThanSM: {
                minHeight: "$115"
            },
            $largerThanMD: {
                minHeight: "$125",
                borderBottomLeftRadius: "$9x",
                borderBottomRightRadius: "$9x"
            },
            children: [
                !hideStickyCta && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StickyCTAUtility/* StickyCTAUtility */.V, {
                    analyticsId: fields === null || fields === void 0 ? void 0 : fields.analyticsId,
                    isVisible: showStickyCTAUtility
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    overflow: "hidden",
                    borderBottomLeftRadius: "$6x",
                    borderBottomRightRadius: "$6x",
                    $largerThanMD: {
                        borderBottomLeftRadius: "$9x",
                        borderBottomRightRadius: "$9x"
                    },
                    children: [
                        imageUrl && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                            position: "absolute",
                            top: 0,
                            left: 0,
                            width: "100%",
                            height: "100%",
                            className: (HeroV2_module_default()).heroImageWrapper,
                            children: (0,pictures/* generatePresetPictureSet */.eY)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, heroConstants/* HERO_FULLBLEED_IMAGE_PROPS */.$B), {
                                photoUrl: imageUrl,
                                objectFit: "cover"
                            }))
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                            position: "absolute",
                            top: 0,
                            left: 0,
                            width: "66%",
                            height: "100%",
                            className: (HeroV2_module_default()).heroLeftGradient
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                            position: "absolute",
                            top: 0,
                            left: 0,
                            width: "100%",
                            height: "$23",
                            zIndex: 1,
                            className: (HeroV2_module_default()).heroTopGradient
                        })
                    ]
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                    position: "relative",
                    zIndex: 2,
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    width: "100%",
                    height: "100%",
                    px: "$5",
                    py: "$10",
                    maxWidth: "$328",
                    mx: "auto",
                    style: {
                        color: (0,cjs.getToken)("$contentInversePrimary", "color")
                    },
                    minHeight: 400 - constants/* GLASS_HEADER_HEIGHT */.$C,
                    $largerThanSM: {
                        pt: "$25",
                        minHeight: 460 - constants/* GLASS_HEADER_HEIGHT */.$C,
                        alignItems: "flex-start"
                    },
                    $largerThanMD: {
                        pt: "$14",
                        minHeight: 500 - constants/* GLASS_HEADER_HEIGHT */.$C
                    },
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                        maxWidth: "80%",
                        $largerThanSM: {
                            maxWidth: "50%"
                        },
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HeroTitleAndAddress, {
                            analyticsId: fields === null || fields === void 0 ? void 0 : fields.analyticsId,
                            title: headline,
                            subtitle: fields === null || fields === void 0 ? void 0 : fields.subtitle,
                            showAddressInput: fields === null || fields === void 0 ? void 0 : fields.showAddressInputCta,
                            showSocialSection: false,
                            textColor: "$contentInversePrimary",
                            renderDesktopInput: customization === null || customization === void 0 ? void 0 : customization.renderDesktopInput,
                            renderMobileInput: customization === null || customization === void 0 ? void 0 : customization.renderMobileInput,
                            additionalAddressContent: customization === null || customization === void 0 ? void 0 : customization.additionalAddressContent,
                            addressEntryRef: addressEntryRef,
                            addressCtaText: fields === null || fields === void 0 ? void 0 : fields.addressCtaText,
                            addressCtaTextSmall: fields === null || fields === void 0 ? void 0 : fields.addressCtaTextSmall,
                            addressCtaPlaceholderText: fields === null || fields === void 0 ? void 0 : fields.addressCtaPlaceholderText,
                            addressCtaPlaceholderTextSmall: fields === null || fields === void 0 ? void 0 : fields.addressCtaPlaceholderTextSmall,
                            showCtaButtonsContainer: fields === null || fields === void 0 ? void 0 : fields.showCtaButtonsContainer,
                            ctaButton1Text: fields === null || fields === void 0 ? void 0 : fields.ctaButton1Text,
                            ctaButton1Url: fields === null || fields === void 0 ? void 0 : fields.ctaButton1Url,
                            showCtaButton2: fields === null || fields === void 0 ? void 0 : fields.showCtaButton2,
                            ctaButton2Text: fields === null || fields === void 0 ? void 0 : fields.ctaButton2Text,
                            ctaButton2Url: fields === null || fields === void 0 ? void 0 : fields.ctaButton2Url,
                            trackingKeyword: fields === null || fields === void 0 ? void 0 : fields.trackingKeyword
                        })
                    })
                })
            ]
        })
    });
};
var ControlHero = function(param) {
    var fields = param.fields, customization = param.customization, addressEntryRef = param.addressEntryRef;
    var router = (0,next_router.useRouter)();
    var headlineMarketIdentifier = router.query.headline_market_name;
    var headlineMarketDisplayName = (0,markets/* getMarketDisplayNameForHeroV2 */.O_)(headlineMarketIdentifier);
    var displayMarketNameInHeadline = headlineMarketDisplayName && "showMarketNameInHeadline" in fields && fields.showMarketNameInHeadline && !(customization === null || customization === void 0 ? void 0 : customization.headline);
    var headline = (customization === null || customization === void 0 ? void 0 : customization.headline) !== undefined ? customization.headline : (fields === null || fields === void 0 ? void 0 : fields.title) + (displayMarketNameInHeadline ? " in ".concat(headlineMarketDisplayName) : "");
    var hasBothSocialAndPress = (fields === null || fields === void 0 ? void 0 : fields.showSocialSection) && (fields === null || fields === void 0 ? void 0 : fields.showPressSection);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
        width: "90%",
        mx: "auto",
        paddingHorizontal: "$10",
        $largerThanSM: {
            paddingBottom: hasBothSocialAndPress ? "$16" : "$0"
        },
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
            flexDirection: "column",
            justifyContent: "space-between",
            rowGap: "$10",
            position: "relative",
            $smallerThanSM: {
                paddingTop: "$10"
            },
            $largerThanSM: {
                flexDirection: "row",
                columnGap: "$8",
                rowGap: "$4"
            },
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                    $largerThanSM: {
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        width: "40%",
                        flexShrink: 0
                    },
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HeroTitleAndAddress, {
                        analyticsId: fields === null || fields === void 0 ? void 0 : fields.analyticsId,
                        title: headline,
                        subtitle: fields === null || fields === void 0 ? void 0 : fields.subtitle,
                        showAddressInput: fields === null || fields === void 0 ? void 0 : fields.showAddressInputCta,
                        showSocialSection: fields === null || fields === void 0 ? void 0 : fields.showSocialSection,
                        renderDesktopInput: customization === null || customization === void 0 ? void 0 : customization.renderDesktopInput,
                        renderMobileInput: customization === null || customization === void 0 ? void 0 : customization.renderMobileInput,
                        additionalAddressContent: customization === null || customization === void 0 ? void 0 : customization.additionalAddressContent,
                        addressEntryRef: addressEntryRef,
                        addressCtaText: fields === null || fields === void 0 ? void 0 : fields.addressCtaText,
                        addressCtaTextSmall: fields === null || fields === void 0 ? void 0 : fields.addressCtaTextSmall,
                        addressCtaPlaceholderText: fields === null || fields === void 0 ? void 0 : fields.addressCtaPlaceholderText,
                        addressCtaPlaceholderTextSmall: fields === null || fields === void 0 ? void 0 : fields.addressCtaPlaceholderTextSmall,
                        showCtaButtonsContainer: fields === null || fields === void 0 ? void 0 : fields.showCtaButtonsContainer,
                        ctaButton1Text: fields === null || fields === void 0 ? void 0 : fields.ctaButton1Text,
                        ctaButton1Url: fields === null || fields === void 0 ? void 0 : fields.ctaButton1Url,
                        showCtaButton2: fields === null || fields === void 0 ? void 0 : fields.showCtaButton2,
                        ctaButton2Text: fields === null || fields === void 0 ? void 0 : fields.ctaButton2Text,
                        ctaButton2Url: fields === null || fields === void 0 ? void 0 : fields.ctaButton2Url,
                        trackingKeyword: fields === null || fields === void 0 ? void 0 : fields.trackingKeyword
                    })
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                    position: "relative",
                    $largerThanSM: {
                        width: "50%",
                        flexShrink: 0
                    },
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HeroImages, {
                            imageDesktopUrl: fields === null || fields === void 0 ? void 0 : fields.imageDesktopUrl,
                            imageMobileUrl: fields === null || fields === void 0 ? void 0 : fields.imageMobileUrl,
                            lowBandwidth: customization === null || customization === void 0 ? void 0 : customization.lowBandwidth
                        }),
                        customization === null || customization === void 0 ? void 0 : customization.children
                    ]
                }),
                ((fields === null || fields === void 0 ? void 0 : fields.showSocialSection) || (fields === null || fields === void 0 ? void 0 : fields.showPressSection)) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                    id: "desktop-press-box",
                    position: "absolute",
                    left: "50%",
                    transform: "translateX(-50%)",
                    zIndex: 1,
                    $largerThanLG: {
                        bottom: 32
                    },
                    $largerThanSM: {
                        bottom: hasBothSocialAndPress ? -100 : -40
                    },
                    $smallerThanMD: {
                        position: "relative"
                    },
                    children: [
                        (fields === null || fields === void 0 ? void 0 : fields.showSocialSection) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                            $smallerThanMD: {
                                display: "inherit"
                            },
                            $smallerThanLG: {
                                display: "none"
                            },
                            $largerThanMD: {
                                display: "inherit"
                            },
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SocialProofBox, {
                                autoplayInterval: 3000
                            })
                        }),
                        (fields === null || fields === void 0 ? void 0 : fields.showPressSection) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                            marginTop: "$8",
                            $smallerThanMD: {
                                marginTop: 0
                            },
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PressBox/* PressBox */.j, {})
                        })
                    ]
                })
            ]
        })
    });
};
var RenderHeroV2 = function(entry, resolvedData, customization) {
    var router = (0,next_router.useRouter)();
    var authentication = (0,auth_fe_esm/* useAuth */.aC)().authentication;
    var fields = entry.fields;
    var isTreatment = constants/* TREATMENT_ANALYTICS_IDS.includes */.pj.includes(fields.analyticsId);
    var isFullBleedHero = isTreatment;
    var hideStickyCta = (customization === null || customization === void 0 ? void 0 : customization.hideStickyCtaOverride) !== undefined ? Boolean(customization.hideStickyCtaOverride) : (resolvedData === null || resolvedData === void 0 ? void 0 : resolvedData.stickyCTA) === "None" || authentication.state === "authenticated";
    var headlineMarketIdentifier = router.query.headline_market_name;
    var headlineMarketDisplayName = (0,markets/* getMarketDisplayNameForHeroV2 */.O_)(headlineMarketIdentifier);
    var displayMarketNameInHeadline = headlineMarketDisplayName && "showMarketNameInHeadline" in fields && fields.showMarketNameInHeadline && !(customization === null || customization === void 0 ? void 0 : customization.headline);
    var headline = (customization === null || customization === void 0 ? void 0 : customization.headline) !== undefined ? customization.headline : (fields === null || fields === void 0 ? void 0 : fields.title) + (displayMarketNameInHeadline ? " in ".concat(headlineMarketDisplayName) : "");
    var ref = (0,HeroShared/* useStickyCTA */.AJ)(), addressEntryRef = ref.addressEntryRef, showStickyCTAUtility = ref.showStickyCTAUtility;
    var variant = (customization === null || customization === void 0 ? void 0 : customization.variant) || "default";
    var analyticsPrefix = "cosmos-landing-page-hero-v2".concat((fields === null || fields === void 0 ? void 0 : fields.analyticsId) ? "-".concat(fields === null || fields === void 0 ? void 0 : fields.analyticsId) : "");
    if (isFullBleedHero) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FullBleedHero, {
            fields: fields,
            headline: headline,
            customization: customization,
            analyticsPrefix: analyticsPrefix,
            hideStickyCta: hideStickyCta,
            showStickyCTAUtility: showStickyCTAUtility,
            addressEntryRef: addressEntryRef
        });
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HeroShared/* HeroProvider */.yL, {
        variant: variant,
        analyticsPrefix: analyticsPrefix,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
            analyticsName: (customization === null || customization === void 0 ? void 0 : customization.analyticsName) || "cosmos-landing-page-hero-v2-".concat(fields === null || fields === void 0 ? void 0 : fields.analyticsId),
            trackImpression: true,
            inViewThreshold: 0.3,
            children: [
                !hideStickyCta && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StickyCTAUtility/* StickyCTAUtility */.V, {
                    analyticsId: fields === null || fields === void 0 ? void 0 : fields.analyticsId,
                    isVisible: showStickyCTAUtility
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ControlHero, {
                    fields: fields,
                    customization: customization,
                    addressEntryRef: addressEntryRef
                })
            ]
        })
    });
};
var heroV2Loader = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(input, root) {
        var preloadImages, loaderReturn;
        return (0,tslib_es6.__generator)(this, function(_state) {
            preloadImages = (0,HeroShared/* preloadHeroImages */.DB)({
                imageDesktopUrl: input.fields.imageDesktopUrl,
                imageMobileUrl: input.fields.imageMobileUrl
            });
            loaderReturn = {
                preloadImages: preloadImages,
                stickyCTA: (0,HeroShared/* getStickyCTAFromRoot */.Ul)(root)
            };
            return [
                2,
                loaderReturn
            ];
        });
    });
    return function heroV2Loader(input, root) {
        return _ref.apply(this, arguments);
    };
}();
var HeroV2 = {
    render: function(entry, resolvedData) {
        return RenderHeroV2(entry, resolvedData);
    },
    loader: heroV2Loader
};

/* harmony default export */ var landing_pages_v2_HeroV2 = (HeroV2);


/***/ }),

/***/ 50069:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ landing_pages_v2_HeroV2WithMarkers; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/@opendoor/auth-fe/dist/auth-fe.esm.js
var auth_fe_esm = __webpack_require__(45807);
// EXTERNAL MODULE: ./src/helpers/ReturnExperienceContext.tsx
var ReturnExperienceContext = __webpack_require__(78223);
// EXTERNAL MODULE: ./src/components/shared/NewSellerFlowAddressInput.tsx
var NewSellerFlowAddressInput = __webpack_require__(4618);
// EXTERNAL MODULE: ./src/components/landing-pages-v2/HeroV2.tsx + 3 modules
var HeroV2 = __webpack_require__(32296);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Button/IconButton.js
var IconButton = __webpack_require__(7603);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/__generated__/icons/RightArrow.js
var RightArrow = __webpack_require__(82717);
// EXTERNAL MODULE: ./node_modules/@tamagui/core/dist/cjs/index.js
var cjs = __webpack_require__(86872);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Box/Box.js
var Box = __webpack_require__(46523);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Text/index.js
var Text = __webpack_require__(76614);
// EXTERNAL MODULE: ./src/helpers/returnExperience.tsx
var returnExperience = __webpack_require__(82993);
// EXTERNAL MODULE: ./src/components/globals.ts
var globals = __webpack_require__(35480);
;// CONCATENATED MODULE: ./src/components/landing-pages-v2/ReturnExperience.tsx





var AltCTAButton = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconButton/* IconButton */.hU, {
        analyticsName: "cosmos-return-experience-".concat(returnExperience/* ExperienceType */.g[props.experience], "-icon-button"),
        icon: {
            Component: RightArrow/* default */.Z,
            label: "".concat(props.actionText)
        },
        onPress: function() {
            return props.url && window.location.assign(props.url);
        },
        size: "small",
        variant: "default",
        trackImpression: true
    });
};
var getActiveOfferExpiryText = function() {
    var daysToExpire = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 10;
    var expiryText = "expires in 2 days";
    if (daysToExpire < 1) {
        expiryText = "expires today";
    } else if (daysToExpire < 2) {
        expiryText = "expires in 1 day";
    } else if (daysToExpire < 3) {
        expiryText = "expires in 2 days";
    } else if (daysToExpire === 3) {
        expiryText = "expires in 3 days";
    }
    return expiryText;
};
var Headline = function(props) {
    switch(props.experience){
        case returnExperience/* ExperienceType.direct_mailer */.g.direct_mailer:
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                children: "Get started on your offer"
            });
        case returnExperience/* ExperienceType.offer_expired */.g.offer_expired:
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                children: [
                    "Get your updated offer",
                    props.smallerThanMD ? "" : " today"
                ]
            });
        case returnExperience/* ExperienceType.incomplete_flow */.g.incomplete_flow:
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                children: [
                    "Finish your offer",
                    props.smallerThanMD ? "" : " today"
                ]
            });
        case returnExperience/* ExperienceType.offer_increased */.g.offer_increased:
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                children: "Your offer increased"
            });
        case returnExperience/* ExperienceType.offer_expiring */.g.offer_expiring:
        case returnExperience/* ExperienceType.offer_decreased */.g.offer_decreased:
        case returnExperience/* ExperienceType.active_offer */.g.active_offer:
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                children: [
                    "Your offer ",
                    getActiveOfferExpiryText(props.daysToExpire)
                ]
            });
        default:
            return null;
    }
};
var ExperienceCTAButton = function(props) {
    var offerDashUrl = globals/* COSMOS_URL */.EQ;
    if (props.addressToken) {
        // Return to sell tab in hub for returning customers
        offerDashUrl = "".concat(globals/* CONSUMER_FE_URL */.ed, "/dashboard/sell/").concat(props.addressToken);
    } else if (props.sellerInputUUID) {
        offerDashUrl = "".concat(globals/* CONSUMER_FE_URL */.ed, "/dashboard/").concat(props.sellerInputUUID, "/overview");
    }
    switch(props.experience){
        case returnExperience/* ExperienceType.offer_expired */.g.offer_expired:
            {
                var baseUrl = offerDashUrl;
                var params = new URLSearchParams({
                    refresh_offer: "true",
                    refresh_source: "homepage_experience"
                }).toString();
                var refreshUrl = "".concat(baseUrl, "?").concat(params);
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AltCTAButton, {
                    actionText: "Refresh".concat(props.smallerThanMD ? " " : " your ", "offer"),
                    url: refreshUrl,
                    experience: props.experience
                });
            }
        case returnExperience/* ExperienceType.incomplete_flow */.g.incomplete_flow:
            // eslint-disable-next-line no-case-declarations
            var sellerFlowUrl = "".concat(globals/* CONSUMER_FE_URL */.ed, "/seller-lead/").concat(props.sellerInputUUID, "/").concat(props.sellerFlowLastCompletedSlug);
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AltCTAButton, {
                actionText: "Resume".concat(props.smallerThanMD ? " " : " your ", "offer"),
                url: sellerFlowUrl,
                experience: props.experience
            });
        case returnExperience/* ExperienceType.offer_increased */.g.offer_increased:
        case returnExperience/* ExperienceType.offer_expiring */.g.offer_expiring:
        case returnExperience/* ExperienceType.offer_decreased */.g.offer_decreased:
        case returnExperience/* ExperienceType.active_offer */.g.active_offer:
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AltCTAButton, {
                actionText: "View".concat(props.smallerThanMD ? " " : " your ", "offer"),
                url: offerDashUrl,
                experience: props.experience
            });
        default:
            return null;
    }
};
var ReturnExperienceHero = function() {
    var returnExperienceData = (0,ReturnExperienceContext/* useReturnExperienceContext */.$)().returnExperienceData;
    var smallerThanSM = (0,cjs.useMedia)().smallerThanSM;
    if (!returnExperienceData || (returnExperienceData === null || returnExperienceData === void 0 ? void 0 : returnExperienceData.experienceType) === null) {
        return null;
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
        animation: "contentfulArchAnimation",
        animateOnly: [
            "opacity",
            "transform"
        ],
        enterStyle: {
            y: -30,
            opacity: 0
        },
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
        top: -27,
        p: 16,
        pt: 43,
        analyticsName: "cosmos-return-experience-address-entry-slide-in",
        backgroundColor: "$backgroundSecondary",
        borderBottomRightRadius: 20,
        borderBottomLeftRadius: 20,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                gap: 5,
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                        tag: "span",
                        color: "$contentPrimary",
                        typography: "$labelSmall",
                        $largerThanMD: {
                            typography: "$labelMedium"
                        },
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Headline, {
                            experience: returnExperienceData.experienceType,
                            currentOfferPriceCents: returnExperienceData.currentOfferHeadlinePriceCents,
                            previousOfferPriceCents: returnExperienceData.previousOfferHeadlinePriceCents,
                            daysToExpire: returnExperienceData.offerExpiresInDays,
                            smallerThanMD: smallerThanSM
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                        tag: "span",
                        color: "$contentSecondary",
                        typography: "$bodySmall",
                        children: returnExperienceData.address
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ExperienceCTAButton, {
                experience: returnExperienceData.experienceType,
                sellerInputUUID: returnExperienceData.sellerInputUUID,
                customerUUID: returnExperienceData.customerUUID,
                addressToken: returnExperienceData.addressToken,
                smallerThanMD: false
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/components/helpers/LazyLoad.tsx
var LazyLoad = __webpack_require__(17976);
// EXTERNAL MODULE: ./src/components/landing-pages-v2/shared/Marker.tsx
var Marker = __webpack_require__(77741);
;// CONCATENATED MODULE: ./src/components/landing-pages-v2/shared/hero/HeroMarkers.tsx



var HeroMarkers = function(param) {
    var cashOfferMarkerImage = param.cashOfferMarkerImage, newOfferMarkerImage = param.newOfferMarkerImage, highestOfferMarkerImage = param.highestOfferMarkerImage;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LazyLoad/* default */.Z, {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Marker/* default */.ZP, {
                    imageSource: cashOfferMarkerImage,
                    preload: true,
                    lazy: false,
                    left: "57%",
                    top: "40%",
                    height: "$60x",
                    width: "$157x",
                    className: Marker/* MarkerFadeInClassName */.eO,
                    $largerThanSM: {
                        left: "60%",
                        top: "40%"
                    },
                    $largerThanMD: {
                        left: "50%",
                        top: "25%",
                        height: "$80x",
                        width: "$200x"
                    },
                    animationDelay: "0.5s"
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LazyLoad/* default */.Z, {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Marker/* default */.ZP, {
                    imageSource: newOfferMarkerImage,
                    preload: true,
                    lazy: false,
                    right: "55%",
                    top: "45%",
                    height: "$60x",
                    width: "$157x",
                    className: Marker/* MarkerFadeInClassName */.eO,
                    $largerThanSM: {
                        right: "52%",
                        top: "43%"
                    },
                    $largerThanMD: {
                        right: "57%",
                        top: "30%",
                        height: "$80x",
                        width: "$200x"
                    },
                    animationDelay: "1.5s"
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LazyLoad/* default */.Z, {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Marker/* default */.ZP, {
                    imageSource: highestOfferMarkerImage,
                    preload: true,
                    lazy: false,
                    right: "35%",
                    top: "20%",
                    height: "$60x",
                    width: "$157x",
                    className: Marker/* MarkerFadeInClassName */.eO,
                    $largerThanSM: {
                        right: "40%",
                        top: "22%"
                    },
                    $largerThanMD: {
                        right: "36%",
                        top: "7%",
                        height: "$80x",
                        width: "$200x"
                    },
                    animationDelay: "2.5s"
                })
            })
        ]
    });
};
/* harmony default export */ var hero_HeroMarkers = (HeroMarkers);

// EXTERNAL MODULE: ./src/components/landing-pages-v2/shared/hero/HeroShared.tsx
var HeroShared = __webpack_require__(21076);
;// CONCATENATED MODULE: ./src/components/landing-pages-v2/HeroV2WithMarkers.tsx












var RenderHeroV2WithMarkers = function(entry, resolvedData) {
    var fields = entry.fields;
    var authentication = (0,auth_fe_esm/* useAuth */.aC)().authentication;
    var showReturnExperience = (0,ReturnExperienceContext/* useReturnExperienceContext */.$)().showReturnExperience;
    var addressInputCommonProps = {
        hideLabel: true,
        inputLocation: "hero-cta",
        analyticsPrefix: "cosmos-landing-page-hero-v2-with-markers".concat((fields === null || fields === void 0 ? void 0 : fields.analyticsId) ? "-".concat(fields === null || fields === void 0 ? void 0 : fields.analyticsId) : ""),
        trackingTaxonomy: "new_homepage",
        trackingKeywords: fields === null || fields === void 0 ? void 0 : fields.trackingKeyword
    };
    // Convert resolvedData to match HeroV2's expected format
    var heroV2ResolvedData = resolvedData ? (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, resolvedData), {
        stickyCTA: resolvedData.stickyCTA || undefined
    }) : undefined;
    var customization = {
        variant: "withMarkers",
        hideStickyCtaOverride: entry.sys.locale === "es" || (resolvedData === null || resolvedData === void 0 ? void 0 : resolvedData.stickyCTA) === "None" || authentication.state === "authenticated",
        renderDesktopInput: function() {
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NewSellerFlowAddressInput/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, addressInputCommonProps), {
                placeholder: fields.addressCtaPlaceholderText || "Enter your home address"
            }));
        },
        renderMobileInput: function() {
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NewSellerFlowAddressInput/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, addressInputCommonProps), {
                placeholder: fields.addressCtaPlaceholderTextSmall || "Enter an address"
            }));
        },
        additionalAddressContent: showReturnExperience && entry.sys.locale !== "es" && !((fields === null || fields === void 0 ? void 0 : fields.analyticsId) === "syw-address-entry-direct-mail") ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ReturnExperienceHero, {}) : undefined,
        imageContainerStyles: {
            $largerThanMD: {
                width: "50%",
                justifyContent: "flex-end"
            }
        },
        desktopPressBoxBottom: "$15x",
        headline: (fields === null || fields === void 0 ? void 0 : fields.title) || "",
        analyticsName: "cosmos-landing-page-hero-v2-with-markers-".concat(fields === null || fields === void 0 ? void 0 : fields.analyticsId),
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(hero_HeroMarkers, {
            cashOfferMarkerImage: fields.cashOfferMarkerImage,
            newOfferMarkerImage: fields.newOfferMarkerImage,
            highestOfferMarkerImage: fields.highestOfferMarkerImage
        })
    };
    return (0,HeroV2/* RenderHeroV2 */.b)(entry, heroV2ResolvedData, customization);
};
var heroV2WithMarkersLoader = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(input, root) {
        var preloadImages, loaderReturn;
        return (0,tslib_es6.__generator)(this, function(_state) {
            preloadImages = (0,HeroShared/* preloadHeroImages */.DB)({
                imageDesktopUrl: input.fields.imageDesktopUrl,
                imageMobileUrl: input.fields.imageMobileUrl
            });
            loaderReturn = {
                preloadImages: preloadImages,
                stickyCTA: (0,HeroShared/* getStickyCTAFromRoot */.Ul)(root) || null
            };
            return [
                2,
                loaderReturn
            ];
        });
    });
    return function heroV2WithMarkersLoader(input, root) {
        return _ref.apply(this, arguments);
    };
}();
var HeroV2WithMarkers = {
    render: RenderHeroV2WithMarkers,
    loader: heroV2WithMarkersLoader
};
/* harmony default export */ var landing_pages_v2_HeroV2WithMarkers = (HeroV2WithMarkers);


/***/ }),

/***/ 51831:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CenteredLayout": function() { return /* binding */ CenteredLayout; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(26042);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(35944);
/* harmony import */ var _contentful_rich_text_react_renderer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(74129);
/* harmony import */ var _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86437);
/* harmony import */ var _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(76614);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(6967);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(37122);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(97009);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(22470);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(86872);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _tabler_icons_react__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(13431);
/* harmony import */ var _shared_Container__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93524);
/* harmony import */ var _shared_Typography__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(78837);









var bodyParser = function(param) {
    var gridColumnConfig = param.gridColumnConfig, blockquoteGridColumn = param.blockquoteGridColumn, pGridColumn = param.pGridColumn, textAlign = param.textAlign;
    var _obj;
    return {
        renderNode: (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_1__.BLOCKS.PARAGRAPH, function(_, children) {
            return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_6__/* .Text */ .x, {
                tag: "p",
                typography: "$bodyLarge",
                textAlign: textAlign,
                "$platform-web": {
                    gridColumn: pGridColumn !== null && pGridColumn !== void 0 ? pGridColumn : gridColumnConfig
                },
                children: children
            });
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_1__.BLOCKS.QUOTE, function(node, _) {
            var text = node.content.flatMap(function(p) {
                return "content" in p ? p.content : [];
            }).map(function(t) {
                return "value" in t ? t.value : "";
            }).join("");
            return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_7__/* .Row */ .X, {
                tag: "blockquote",
                ml: "$8",
                position: "relative",
                $largerThanSM: {
                    ml: "$0"
                },
                "$platform-web": {
                    gridColumn: blockquoteGridColumn
                },
                children: [
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_6__/* .Text */ .x, {
                        tag: "span",
                        "aria-hidden": true,
                        typography: "$headerMedium",
                        position: "absolute",
                        "$platform-web": {
                            right: "calc(100% + 16px)"
                        },
                        children: "“"
                    }),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_6__/* .Text */ .x, {
                        tag: "p",
                        typography: "$headerMedium",
                        textAlign: textAlign,
                        children: text
                    })
                ]
            });
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_1__.BLOCKS.HEADING_1, function(_, children) {
            return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_6__/* .Text */ .x, {
                tag: "h1",
                typography: "$subheaderLarge",
                textAlign: textAlign,
                "$platform-web": {
                    gridColumn: gridColumnConfig
                },
                children: children
            });
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_1__.BLOCKS.HEADING_2, function(_, children) {
            return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_6__/* .Text */ .x, {
                tag: "h2",
                typography: "$subheaderLarge",
                textAlign: textAlign,
                "$platform-web": {
                    gridColumn: gridColumnConfig
                },
                children: children
            });
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_1__.BLOCKS.HEADING_3, function(_, children) {
            return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_6__/* .Text */ .x, {
                tag: "h3",
                typography: "$subheaderMedium",
                textAlign: textAlign,
                "$platform-web": {
                    gridColumn: gridColumnConfig
                },
                children: children
            });
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_1__.BLOCKS.HEADING_4, function(_, children) {
            return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_6__/* .Text */ .x, {
                tag: "h4",
                typography: "$subheaderSmall",
                textAlign: textAlign,
                "$platform-web": {
                    gridColumn: gridColumnConfig
                },
                children: children
            });
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_1__.BLOCKS.HEADING_5, function(_, children) {
            return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_6__/* .Text */ .x, {
                tag: "h5",
                typography: "$bodyLarge",
                textAlign: textAlign,
                "$platform-web": {
                    gridColumn: gridColumnConfig
                },
                children: children
            });
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_1__.BLOCKS.HEADING_6, function(_, children) {
            return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_6__/* .Text */ .x, {
                tag: "h6",
                typography: "$bodyMedium",
                textAlign: textAlign,
                "$platform-web": {
                    gridColumn: gridColumnConfig
                },
                children: children
            });
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_1__.BLOCKS.UL_LIST, function(_, children) {
            return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_8__/* .Col */ .J, {
                tag: "ul",
                "$platform-web": {
                    gridColumn: gridColumnConfig
                },
                children: children
            });
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_1__.BLOCKS.OL_LIST, function(_, children) {
            return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_8__/* .Col */ .J, {
                tag: "ol",
                "$platform-web": {
                    gridColumn: gridColumnConfig
                },
                children: children
            });
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_1__.BLOCKS.EMBEDDED_ENTRY, function(node) {
            var target = node.data.target;
            if (target.sys.contentType.sys.id === "lpComponentMedia") {
                var ref, ref1, ref2, ref3;
                var fields = target.fields;
                var ref4;
                return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_8__/* .Col */ .J, {
                    "$platform-web": {
                        gridColumn: fields.size === "Large" ? "1 / -1" : gridColumnConfig,
                        scrollMarginTop: "80px"
                    },
                    children: fields.image && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_9__/* .Image */ .E, {
                        source: {
                            uri: (ref4 = (ref = fields.image.fields) === null || ref === void 0 ? void 0 : (ref1 = ref.file) === null || ref1 === void 0 ? void 0 : ref1.url) !== null && ref4 !== void 0 ? ref4 : ""
                        },
                        alt: ((ref2 = fields.image.fields) === null || ref2 === void 0 ? void 0 : ref2.description) || ((ref3 = fields.image.fields) === null || ref3 === void 0 ? void 0 : ref3.title) || "",
                        borderRadius: "$8x"
                    })
                });
            }
            var fields1 = target.fields;
            return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_8__/* .Col */ .J, {
                id: fields1.elementID,
                "$platform-web": {
                    gridColumn: gridColumnConfig,
                    scrollMarginTop: "80px"
                },
                children: fields1.title && (0,_contentful_rich_text_react_renderer__WEBPACK_IMPORTED_MODULE_0__/* .documentToReactComponents */ .h)(fields1.title)
            });
        }), _obj)
    };
};
var introOptions = {
    renderNode: (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_1__.BLOCKS.PARAGRAPH, function(_, children) {
        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_6__/* .Text */ .x, {
            tag: "p",
            typography: "$bodyLarge",
            children: children
        });
    })
};
var _obj;
var sidebarParse = {
    renderNode: (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_1__.BLOCKS.HEADING_2, function(_, children) {
        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_6__/* .Text */ .x, {
            tag: "h2",
            color: "$contentSecondary",
            typography: "$headerMedium",
            fontWeight: "$medium",
            mb: "$6",
            pb: "$6",
            borderBottomColor: "$borderPrimary",
            children: children
        });
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_1__.BLOCKS.UL_LIST, function(_, children) {
        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_8__/* .Col */ .J, {
            tag: "ul",
            role: "list",
            mb: "$6",
            p: "$0",
            "$platform-web": {
                listStyle: "none"
            },
            children: children
        });
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_1__.BLOCKS.LIST_ITEM, function(_, children) {
        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_8__/* .Col */ .J, {
            tag: "li",
            mb: "$6",
            children: children
        });
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_1__.BLOCKS.PARAGRAPH, function(_, children) {
        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_6__/* .Text */ .x, {
            tag: "p",
            typography: "$bodyMedium",
            color: "$contentSecondary",
            children: children
        });
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_1__.INLINES.HYPERLINK, function(node, children) {
        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_10__/* .Link */ .r, {
            href: node.data.uri,
            analyticsName: "cosmos-landing-page-standalone-text-sidebar",
            fontWeight: "$medium",
            mb: "$2",
            "$platform-web": {
                display: "block"
            },
            children: children
        });
    }), _obj)
};
var grid12Style = {
    display: "grid",
    gridTemplateColumns: "repeat(12, minmax(0, 1fr))",
    columnGap: "16px"
};
var grid8Style = {
    display: "grid",
    gridTemplateColumns: "repeat(8, minmax(0, 1fr))",
    columnGap: "16px"
};
// dialogId is for instances where the Standalone text is in a Sheet
var Header = function(param) {
    var entry = param.entry, dialogId = param.dialogId, centered = param.centered;
    var fields = entry.fields;
    var largerThanSM = (0,_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_11__.useMedia)().largerThanSM;
    var textAlign = centered && largerThanSM ? "center" : undefined;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_8__/* .Col */ .J, {
        tag: "header",
        mb: "$4",
        $largerThanSM: {
            mb: "$6"
        },
        children: [
            fields.title && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_shared_Typography__WEBPACK_IMPORTED_MODULE_3__/* .TitleWithAccent */ .aI, {
                overRideTitleTag: "h1",
                title: fields.title,
                titleAccent: fields.titleAccent,
                titleSize: fields.titleSize,
                marginHorizontal: fields.layout === "Centered" ? "auto" : undefined,
                textAlign: textAlign,
                id: dialogId || undefined
            }),
            fields.subhead && (fields.titleSize === "Large" ? /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_shared_Typography__WEBPACK_IMPORTED_MODULE_3__/* .Subhead */ .vF, {
                textAlign: textAlign,
                children: fields.subhead
            }) : /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_shared_Typography__WEBPACK_IMPORTED_MODULE_3__/* .SubheadSmall */ .Jm, {
                textAlign: textAlign,
                children: fields.subhead
            }))
        ]
    });
};
var Cta = function(param) {
    var entry = param.entry;
    var fields = entry.fields;
    var _ctaUrl;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_10__/* .Link */ .r, {
        "aria-label": fields.ctaDisplayText || undefined,
        analyticsName: "cosmos-landing-page-standalone-text-".concat(fields === null || fields === void 0 ? void 0 : fields.analyticsId),
        href: (_ctaUrl = fields.ctaUrl) !== null && _ctaUrl !== void 0 ? _ctaUrl : "",
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_7__/* .Row */ .X, {
            alignItems: "center",
            gap: "$2",
            mt: "$6",
            $largerThanSM: {
                mt: "$8"
            },
            "$platform-web": {
                display: "inline-flex"
            },
            children: [
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_tabler_icons_react__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                    size: 15
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_6__/* .Text */ .x, {
                    marginTop: -1,
                    tag: "p",
                    typography: "$bodyMedium",
                    fontWeight: "$medium",
                    color: "$backgroundAccentBrand",
                    whiteSpace: "nowrap",
                    children: fields.ctaDisplayText
                })
            ]
        })
    });
};
var introColumnsStyle = {
    display: "block",
    columns: "auto 3",
    columnGap: "24px"
};
var SidebarLayout = function(param) {
    var entry = param.entry;
    var fields = entry.fields;
    var ref = (0,_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_11__.useMedia)(), largerThanSM = ref.largerThanSM, largerThanMD = ref.largerThanMD;
    var _bodyPGap;
    var resolvedGap = (_bodyPGap = fields.bodyPGap) !== null && _bodyPGap !== void 0 ? _bodyPGap : 64;
    var halfGap = resolvedGap / 2;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .Fragment */ .HY, {
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_8__/* .Col */ .J, {
                "$platform-web": largerThanSM ? grid12Style : undefined,
                children: [
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_8__/* .Col */ .J, {
                        "$platform-web": {
                            gridColumn: "1 / 9"
                        },
                        children: [
                            (fields.title || fields.subhead) && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(Header, {
                                entry: entry
                            }),
                            fields.intro && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_8__/* .Col */ .J, {
                                gap: "$8",
                                mb: "$8",
                                $largerThanSM: {
                                    mb: "$16"
                                },
                                "$platform-web": largerThanMD ? introColumnsStyle : undefined,
                                children: (0,_contentful_rich_text_react_renderer__WEBPACK_IMPORTED_MODULE_0__/* .documentToReactComponents */ .h)(fields.intro, introOptions)
                            }),
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_8__/* .Col */ .J, {
                                mb: "$4",
                                $largerThanSM: {
                                    mb: "$0"
                                },
                                gap: halfGap,
                                "$platform-web": largerThanSM ? grid8Style : undefined,
                                children: fields.body && (0,_contentful_rich_text_react_renderer__WEBPACK_IMPORTED_MODULE_0__/* .documentToReactComponents */ .h)(fields.body, bodyParser({
                                    gridColumnConfig: "1 / 7",
                                    blockquoteGridColumn: "2 / -1"
                                }))
                            })
                        ]
                    }),
                    fields.sidebar && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_8__/* .Col */ .J, {
                        "$platform-web": {
                            gridColumn: "10 / -1"
                        },
                        children: (0,_contentful_rich_text_react_renderer__WEBPACK_IMPORTED_MODULE_0__/* .documentToReactComponents */ .h)(fields.sidebar, sidebarParse)
                    })
                ]
            }),
            fields.ctaDisplayText && fields.ctaUrl && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(Cta, {
                entry: entry
            })
        ]
    });
};
// Centered Layout is also used by Sheets
// dialogId is for instances where the Standalone text is in a Sheet
var CenteredLayout = function(param) {
    var entry = param.entry, dialogId = param.dialogId;
    var fields = entry.fields;
    var ref = (0,_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_11__.useMedia)(), largerThanSM = ref.largerThanSM, largerThanMD = ref.largerThanMD;
    var _bodyPGap;
    var resolvedGap = (_bodyPGap = fields.bodyPGap) !== null && _bodyPGap !== void 0 ? _bodyPGap : 64;
    var halfGap = resolvedGap / 2;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_8__/* .Col */ .J, {
        "$platform-web": largerThanSM ? grid12Style : undefined,
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_8__/* .Col */ .J, {
                gap: halfGap,
                "$platform-web": {
                    gridColumn: "3 / -3"
                },
                children: (fields.title || fields.subhead) && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(Header, {
                    entry: entry,
                    dialogId: dialogId,
                    centered: true
                })
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_8__/* .Col */ .J, {
                gap: halfGap,
                "$platform-web": largerThanSM ? (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({
                    gridColumn: "3 / -3"
                }, grid8Style) : {
                    gridColumn: "3 / -3"
                },
                children: [
                    fields.intro && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_8__/* .Col */ .J, {
                        gap: "$8",
                        mb: "$8",
                        $largerThanSM: {
                            mb: "$16"
                        },
                        "$platform-web": function() {
                            if (largerThanMD) return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({
                                gridColumn: "1 / -1"
                            }, introColumnsStyle);
                            if (largerThanSM) return {
                                gridColumn: "1 / -1"
                            };
                            return undefined;
                        }(),
                        children: (0,_contentful_rich_text_react_renderer__WEBPACK_IMPORTED_MODULE_0__/* .documentToReactComponents */ .h)(fields.intro, introOptions)
                    }),
                    fields.body && (0,_contentful_rich_text_react_renderer__WEBPACK_IMPORTED_MODULE_0__/* .documentToReactComponents */ .h)(fields.body, bodyParser({
                        gridColumnConfig: "2 / -2",
                        blockquoteGridColumn: "2 / -2",
                        textAlign: largerThanSM ? "center" : undefined
                    }))
                ]
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_8__/* .Col */ .J, {
                "$platform-web": largerThanSM ? {
                    gridColumn: "4 / -4",
                    textAlign: "center"
                } : {
                    gridColumn: "4 / -4"
                },
                children: fields.ctaDisplayText && fields.ctaUrl && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(Cta, {
                    entry: entry
                })
            })
        ]
    });
};
var DefaultLayout = function(param) {
    var entry = param.entry;
    var fields = entry.fields;
    var ref = (0,_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_11__.useMedia)(), largerThanSM = ref.largerThanSM, largerThanMD = ref.largerThanMD;
    var _bodyPGap;
    var resolvedGap = (_bodyPGap = fields.bodyPGap) !== null && _bodyPGap !== void 0 ? _bodyPGap : 64;
    var halfGap = resolvedGap / 2;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .Fragment */ .HY, {
        children: [
            (fields.title || fields.subhead) && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(Header, {
                entry: entry
            }),
            fields.intro && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_8__/* .Col */ .J, {
                gap: "$8",
                mb: "$8",
                $largerThanSM: {
                    mb: "$16"
                },
                "$platform-web": largerThanMD ? introColumnsStyle : undefined,
                children: (0,_contentful_rich_text_react_renderer__WEBPACK_IMPORTED_MODULE_0__/* .documentToReactComponents */ .h)(fields.intro, introOptions)
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_8__/* .Col */ .J, {
                gap: halfGap,
                "$platform-web": largerThanSM ? grid12Style : undefined,
                children: fields.body && (0,_contentful_rich_text_react_renderer__WEBPACK_IMPORTED_MODULE_0__/* .documentToReactComponents */ .h)(fields.body, bodyParser({
                    gridColumnConfig: "1 / 7",
                    blockquoteGridColumn: "2 / 11",
                    pGridColumn: fields.analyticsId === "cash-plus-h2-standalone" ? "1 / 9" : undefined
                }))
            }),
            fields.ctaDisplayText && fields.ctaUrl && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(Cta, {
                entry: entry
            })
        ]
    });
};
var RenderStandaloneText = function(entry) {
    var fields = entry.fields;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_shared_Container__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
        children: fields.layout === "Sidebar" ? /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(SidebarLayout, {
            entry: entry
        }) : fields.layout === "Centered" ? /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(CenteredLayout, {
            entry: entry
        }) : /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(DefaultLayout, {
            entry: entry
        })
    });
};
var StandaloneText = {
    render: RenderStandaloneText
};
/* harmony default export */ __webpack_exports__["default"] = (StandaloneText);


/***/ }),

/***/ 26557:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ StickyCTAUtility; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6967);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(76614);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(25923);
/* harmony import */ var _StickyCTAUtility_module_css__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(84327);
/* harmony import */ var _StickyCTAUtility_module_css__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_StickyCTAUtility_module_css__WEBPACK_IMPORTED_MODULE_1__);




var ANIMATION_DURATION = 0.7;
var StickyCTAUtility = function(param) {
    var isVisible = param.isVisible, analyticsId = param.analyticsId, _top = param.top, top = _top === void 0 ? "2%" : _top;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), showStickyCTAUtility = ref[0], setShowStickyCTAUtility = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(undefined), animate = ref1[0], setAnimate = ref1[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        setAnimate(isVisible ? (_StickyCTAUtility_module_css__WEBPACK_IMPORTED_MODULE_1___default().reveal) : (_StickyCTAUtility_module_css__WEBPACK_IMPORTED_MODULE_1___default().hide));
        if (isVisible) {
            setShowStickyCTAUtility(true);
        }
        setTimeout(function() {
            setAnimate(undefined);
            if (!isVisible) {
                setShowStickyCTAUtility(false);
            }
        }, ANIMATION_DURATION * 1000);
    }, [
        isVisible
    ]);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_3__/* .Row */ .X, {
        display: showStickyCTAUtility ? "flex" : "none",
        className: "".concat((_StickyCTAUtility_module_css__WEBPACK_IMPORTED_MODULE_1___default().container)).concat(animate ? " ".concat(animate) : ""),
        "$platform-web": {
            position: "fixed",
            top: top
        },
        zIndex: 9999,
        mx: "auto",
        width: "$75",
        $largerThanSM: {
            width: "$90"
        },
        justifyContent: "space-between",
        alignItems: "center",
        p: "$1half",
        borderRadius: "$10x",
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_4__/* .Text */ .x, {
                tag: "p",
                typography: "$labelXlarge",
                px: "$4",
                $largerThanSM: {
                    px: "$5"
                },
                children: "Still selling?"
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_5__/* .Button */ .z, {
                maxWidth: "$35",
                $largerThanLG: {
                    maxWidth: "$40"
                },
                onPress: function() {
                    return window.location.assign("/address-entry");
                },
                "aria-label": "sticky CTA utility",
                analyticsName: "cosmos-landing-page-sticky-cta-".concat(analyticsId),
                variant: "primary",
                size: "xsmall",
                label: "Get cash offer",
                minHeight: "$4",
                $largerThanMD: {
                    minHeight: "$13"
                }
            })
        ]
    });
};


/***/ }),

/***/ 44682:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ LPFauxBtn; },
/* harmony export */   "o": function() { return /* binding */ LPLink; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(86872);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(22470);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(76614);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(46523);
/* harmony import */ var _Buttons_module_css__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(88218);
/* harmony import */ var _Buttons_module_css__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_Buttons_module_css__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _styles_ComponentTheme__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(12090);








// Tell the button which keys from the component theme to use
// based on the variant name.
var getBtnTheme = function(variant) {
    var theme = {
        Primary: {
            bg: "buttonBg",
            color: "buttonColor",
            hover: "buttonHoverBg",
            active: "buttonActiveBg"
        },
        Secondary: {
            bg: "secondaryButtonBg",
            color: "secondaryButtonColor",
            hover: "secondaryButtonHoverBg",
            active: "secondaryButtonActiveBg"
        },
        Tertiary: {
            bg: "tertiaryButtonBg",
            color: "tertiaryButtonColor",
            hover: "tertiaryButtonHoverColor",
            active: "tertiaryButtonActiveColor"
        },
        Text: {
            bg: "transparent",
            color: "linkColor",
            hover: "linkHoverColor",
            active: "linkColor"
        }
    };
    return {
        bg: theme[variant].bg,
        color: theme[variant].color,
        hover: theme[variant].hover,
        active: theme[variant].active
    };
};
// Bricks-next token overrides per variant, used when bnTheme is provided.
var getBNBtnTheme = function(variant, bnTheme, getColorValue) {
    switch(variant){
        case "Secondary":
            return {
                bg: getColorValue(bnTheme.contentPrimary),
                color: getColorValue(bnTheme.bgPrimary),
                hover: getColorValue(bnTheme.secondaryBtnHover),
                active: getColorValue(bnTheme.contentPrimary)
            };
        case "Tertiary":
            return {
                bg: getColorValue(bnTheme.bgPrimaryLight),
                color: getColorValue(bnTheme.contentPrimary),
                hover: getColorValue(bnTheme.tertiaryBtnHover),
                active: getColorValue(bnTheme.bgPrimaryLight)
            };
        case "Primary":
        default:
            return {
                bg: getColorValue(bnTheme.bgAccentBrand),
                color: getColorValue(bnTheme.buttonLabelPrimary),
                hover: getColorValue(bnTheme.bgHoverAccentBrand),
                active: getColorValue(bnTheme.bgHoverAccentBrand)
            };
    }
};
// TODO: Remove component theme once bnTheme is completely implemented
var LPLink = function(_param) {
    var componentTheme = _param.componentTheme, bnTheme = _param.bnTheme, _ctaStyle = _param.ctaStyle, ctaStyle = _ctaStyle === void 0 ? "Primary" : _ctaStyle, ctaUrl = _param.ctaUrl, ctaDisplayText = _param.ctaDisplayText, ref = _param.ref, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "componentTheme",
        "bnTheme",
        "ctaStyle",
        "ctaUrl",
        "ctaDisplayText",
        "ref"
    ]);
    var btnTheme = getBtnTheme(ctaStyle);
    var getColorValue = function(bnColorToken) {
        return (0,_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_3__.getToken)(bnColorToken, "color");
    };
    var bnBtn = bnTheme ? getBNBtnTheme(ctaStyle, bnTheme, getColorValue) : null;
    var ref1, ref2;
    var backgroundColor = (ref2 = bnBtn === null || bnBtn === void 0 ? void 0 : bnBtn.bg) !== null && ref2 !== void 0 ? ref2 : (0,_styles_ComponentTheme__WEBPACK_IMPORTED_MODULE_1__/* .resolveBricksColor */ .pz)((ref1 = componentTheme === null || componentTheme === void 0 ? void 0 : componentTheme[btnTheme.bg]) !== null && ref1 !== void 0 ? ref1 : "brandBlue600");
    var ref3, ref4;
    var color = (ref4 = bnBtn === null || bnBtn === void 0 ? void 0 : bnBtn.color) !== null && ref4 !== void 0 ? ref4 : (0,_styles_ComponentTheme__WEBPACK_IMPORTED_MODULE_1__/* .resolveBricksColor */ .pz)((ref3 = componentTheme === null || componentTheme === void 0 ? void 0 : componentTheme[btnTheme.color]) !== null && ref3 !== void 0 ? ref3 : "white0");
    var ref5, ref6;
    var hoverBg = (ref6 = bnBtn === null || bnBtn === void 0 ? void 0 : bnBtn.hover) !== null && ref6 !== void 0 ? ref6 : (0,_styles_ComponentTheme__WEBPACK_IMPORTED_MODULE_1__/* .resolveBricksColor */ .pz)((ref5 = componentTheme === null || componentTheme === void 0 ? void 0 : componentTheme[btnTheme.hover]) !== null && ref5 !== void 0 ? ref5 : "white0");
    var ref7, ref8;
    var activeBg = (ref8 = bnBtn === null || bnBtn === void 0 ? void 0 : bnBtn.active) !== null && ref8 !== void 0 ? ref8 : (0,_styles_ComponentTheme__WEBPACK_IMPORTED_MODULE_1__/* .resolveBricksColor */ .pz)((ref7 = componentTheme === null || componentTheme === void 0 ? void 0 : componentTheme[btnTheme.active]) !== null && ref7 !== void 0 ? ref7 : "white0");
    var ref9, ref10, ref11;
    return ctaStyle === "Text" ? /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_5__/* .Link */ .r, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
        color: (ref9 = (0,_styles_ComponentTheme__WEBPACK_IMPORTED_MODULE_1__/* .resolveBricksColor */ .pz)(componentTheme === null || componentTheme === void 0 ? void 0 : componentTheme.linkColor)) !== null && ref9 !== void 0 ? ref9 : getColorValue(bnTheme === null || bnTheme === void 0 ? void 0 : bnTheme.linkColor),
        cursor: "pointer",
        display: "inline-flex",
        href: ctaUrl,
        size: "medium",
        typography: "$labelMedium",
        mt: "$6",
        ref: ref
    }, props), {
        hoverStyle: {
            color: (ref10 = (0,_styles_ComponentTheme__WEBPACK_IMPORTED_MODULE_1__/* .resolveBricksColor */ .pz)(componentTheme === null || componentTheme === void 0 ? void 0 : componentTheme.linkHoverColor)) !== null && ref10 !== void 0 ? ref10 : getColorValue(bnTheme === null || bnTheme === void 0 ? void 0 : bnTheme.linkHover)
        },
        pressStyle: {
            color: (ref11 = (0,_styles_ComponentTheme__WEBPACK_IMPORTED_MODULE_1__/* .resolveBricksColor */ .pz)(componentTheme === null || componentTheme === void 0 ? void 0 : componentTheme.linkColor)) !== null && ref11 !== void 0 ? ref11 : getColorValue(bnTheme === null || bnTheme === void 0 ? void 0 : bnTheme.linkHover)
        },
        children: ctaDisplayText
    })) : /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_5__/* .Link */ .r, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
        backgroundColor: backgroundColor,
        borderRadius: "$8x",
        className: (_Buttons_module_css__WEBPACK_IMPORTED_MODULE_8___default().lpButton),
        color: color,
        cursor: "pointer",
        href: ctaUrl,
        display: "inline-flex",
        size: "medium",
        position: "relative",
        py: "$4",
        px: "$6",
        mt: "$6",
        width: "auto",
        ref: ref,
        style: {
            "--lp-btn-hover-bg": hoverBg
        },
        hoverStyle: {
            color: color
        },
        focusVisibleStyle: {
            color: color,
            backgroundColor: hoverBg
        },
        pressStyle: {
            color: color,
            backgroundColor: activeBg
        }
    }, props), {
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_9__/* .Text */ .x, {
            tag: "span",
            typography: "$bodyMedium",
            color: color,
            zIndex: 5,
            children: ctaDisplayText
        })
    }));
};
var LPFauxBtn = function(_param) {
    var componentTheme = _param.componentTheme, _ctaStyle = _param.ctaStyle, ctaStyle = _ctaStyle === void 0 ? "Primary" : _ctaStyle, ctaDisplayText = _param.ctaDisplayText, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "componentTheme",
        "ctaStyle",
        "ctaDisplayText"
    ]);
    var btnTheme = getBtnTheme(ctaStyle);
    var backgroundColor = (0,_styles_ComponentTheme__WEBPACK_IMPORTED_MODULE_1__/* .resolveBricksColor */ .pz)(componentTheme ? componentTheme[btnTheme.bg] : "brandBlue600");
    var color = (0,_styles_ComponentTheme__WEBPACK_IMPORTED_MODULE_1__/* .resolveBricksColor */ .pz)(componentTheme ? componentTheme[btnTheme.color] : "white0");
    var hoverBg = (0,_styles_ComponentTheme__WEBPACK_IMPORTED_MODULE_1__/* .resolveBricksColor */ .pz)(componentTheme ? componentTheme[btnTheme.hover] : "blue700");
    var activeBg = (0,_styles_ComponentTheme__WEBPACK_IMPORTED_MODULE_1__/* .resolveBricksColor */ .pz)(componentTheme ? componentTheme[btnTheme.active] : "blue700");
    return ctaStyle === "Text" ? /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_9__/* .Text */ .x, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
        tag: "span",
        typography: "$bodyMedium",
        color: (0,_styles_ComponentTheme__WEBPACK_IMPORTED_MODULE_1__/* .resolveBricksColor */ .pz)(componentTheme.linkColor),
        cursor: "pointer",
        display: "inline-flex",
        mt: "$8"
    }, props), {
        hoverStyle: {
            color: (0,_styles_ComponentTheme__WEBPACK_IMPORTED_MODULE_1__/* .resolveBricksColor */ .pz)(componentTheme.linkHoverColor)
        },
        pressStyle: {
            color: (0,_styles_ComponentTheme__WEBPACK_IMPORTED_MODULE_1__/* .resolveBricksColor */ .pz)(componentTheme.linkColor)
        },
        children: ctaDisplayText
    })) : /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_10__/* .Box */ .x, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
        tag: "span",
        backgroundColor: backgroundColor,
        borderRadius: "$8x",
        className: (_Buttons_module_css__WEBPACK_IMPORTED_MODULE_8___default().lpButton),
        cursor: "pointer",
        display: "inline-flex",
        position: "relative",
        py: "$4",
        px: "$6",
        mt: "$8",
        width: "auto",
        style: {
            "--lp-btn-hover-bg": hoverBg
        },
        hoverStyle: {
            backgroundColor: backgroundColor
        },
        focusVisibleStyle: {
            backgroundColor: hoverBg
        },
        pressStyle: {
            backgroundColor: activeBg
        }
    }, props), {
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_9__/* .Text */ .x, {
            tag: "span",
            typography: "$bodyMedium",
            color: color,
            zIndex: 5,
            children: ctaDisplayText
        })
    }));
};


/***/ }),

/***/ 93524:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "IX": function() { return /* binding */ LandingPageSectionContainer; },
/* harmony export */   "z6": function() { return /* binding */ NetProceedsCalculatorContainer; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99534);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(35944);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(46523);
/* harmony import */ var components_helpers_LazyLoad__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(17976);






var Container = function(_param) {
    var children = _param.children, backgroundColor = _param.backgroundColor, style = _param.style, noSectionSpacing = _param.noSectionSpacing, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_param, [
        "children",
        "backgroundColor",
        "style",
        "noSectionSpacing"
    ]);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(components_helpers_LazyLoad__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z, {
        className: noSectionSpacing ? undefined : "lp-section",
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .x, {
            backgroundColor: backgroundColor,
            style: style,
            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .x, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                display: "block",
                maxWidth: 1440,
                paddingHorizontal: "$10x",
                $largerThanSM: {
                    paddingHorizontal: "$20x"
                },
                $largerThanMD: {
                    paddingHorizontal: "$32x"
                },
                width: "100%",
                marginHorizontal: "auto"
            }, props), {
                children: children
            }))
        })
    });
};
var NetProceedsCalculatorContainer = function(_param) /*#__PURE__*/ {
    var children = _param.children, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_param, [
        "children"
    ]);
    return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .x, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        display: "block",
        maxWidth: 1440,
        paddingHorizontal: "$10x",
        $largerThanSM: {
            paddingHorizontal: "$20x"
        },
        $largerThanMD: {
            paddingHorizontal: "$32x"
        },
        width: "100%",
        marginHorizontal: "auto"
    }, props), {
        children: children
    }));
};
var LandingPageSectionContainer = function(_param) {
    var children = _param.children, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_param, [
        "children"
    ]);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(components_helpers_LazyLoad__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z, {
        className: "lp-section",
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .x, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
            marginTop: "$16x",
            display: "block",
            maxWidth: 1440,
            paddingHorizontal: "$10x",
            $largerThanSM: {
                paddingHorizontal: "$20x"
            },
            $largerThanMD: {
                paddingHorizontal: "$32x"
            },
            width: "100%",
            marginHorizontal: "auto"
        }, props), {
            children: children
        }))
    });
};

/* harmony default export */ __webpack_exports__["ZP"] = (Container);


/***/ }),

/***/ 77741:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "XM": function() { return /* binding */ MarkerPulseClassName; },
/* harmony export */   "eO": function() { return /* binding */ MarkerFadeInClassName; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35944);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(37122);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(6967);
/* harmony import */ var components_shared_performance_pictures__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(29212);
/* harmony import */ var _Marker_module_css__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89785);
/* harmony import */ var _Marker_module_css__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_Marker_module_css__WEBPACK_IMPORTED_MODULE_1__);







var MarkerPulseClassName = (_Marker_module_css__WEBPACK_IMPORTED_MODULE_1___default().markerPulse);
var MarkerFadeInClassName = (_Marker_module_css__WEBPACK_IMPORTED_MODULE_1___default().markerFadeIn);
var Marker = function(_param) {
    var imageSource = _param.imageSource, _preload = _param.preload, preload = _preload === void 0 ? false : _preload, _lazy = _param.lazy, lazy = _lazy === void 0 ? true : _lazy, _animationDelay = _param.animationDelay, animationDelay = _animationDelay === void 0 ? "0s" : _animationDelay, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "imageSource",
        "preload",
        "lazy",
        "animationDelay"
    ]);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_4__/* .Col */ .J, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        position: "absolute"
    }, props), {
        style: {
            animationDelay: animationDelay
        },
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_7__/* .Row */ .X, {
            justifyContent: "center",
            alignItems: "center",
            width: "100%",
            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(components_shared_performance_pictures__WEBPACK_IMPORTED_MODULE_0__/* .Picture */ .t, {
                preload: preload,
                lazy: lazy,
                sources: [
                    {
                        srcSet: imageSource,
                        media: "(min-width: 0px)",
                        key: imageSource
                    }
                ],
                objectFit: "cover"
            })
        })
    }));
};
/* harmony default export */ __webpack_exports__["ZP"] = (Marker);


/***/ }),

/***/ 78147:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73935);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(46523);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(7603);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(31944);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(2267);
/* harmony import */ var _tabler_icons_react__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(77373);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(94796);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(21190);
/* harmony import */ var _StandaloneText__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(51831);
/* harmony import */ var _trapFocus__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(92690);








var backdropVariants = {
    hidden: {
        opacity: 0,
        transition: {
            ease: [
                0.55,
                0,
                0.15,
                1
            ],
            delay: 0.5,
            duration: 0.2
        }
    },
    visible: {
        opacity: 1,
        transition: {
            ease: [
                0.55,
                0,
                0.15,
                1
            ],
            duration: 0.2
        }
    }
};
var boxVariants = {
    hidden: {
        y: "100%",
        transition: {
            ease: [
                0.55,
                0,
                0.15,
                1
            ],
            duration: 0.5
        }
    },
    visible: {
        y: 0,
        transition: {
            ease: [
                0.55,
                0,
                0.15,
                1
            ],
            duration: 0.75
        }
    }
};
var SheetContent = function(param) {
    var entry = param.entry, setIsVisible = param.setIsVisible;
    var dialogId = "dialog-".concat(Math.floor(Math.random() * 100 + 1), "-").concat(entry.sys.id);
    var containerRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    var onComplete = function(definition) {
        // Only focus on main sheet container when the visible animation is complete
        // or it messes up the animation
        if (definition === "visible") {
            var ref;
            (ref = containerRef.current) === null || ref === void 0 ? void 0 : ref.focus();
        }
    };
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("div", {
        role: "presentation",
        onKeyDown: function(e) {
            return (0,_trapFocus__WEBPACK_IMPORTED_MODULE_4__/* .trapFocus */ .S)(e, containerRef);
        },
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_5__/* .Box */ .x, {
            display: "block",
            bottom: 0,
            top: 0,
            left: 0,
            right: 0,
            pt: "$20",
            px: "$4",
            pb: "$0",
            zIndex: 3000,
            $largerThanSM: {
                pt: "$28",
                px: "$4",
                pb: "$0"
            },
            "$platform-web": {
                position: "fixed",
                display: "grid",
                gridTemplateRows: "1fr",
                gridTemplateColumns: "1fr",
                overflow: "auto",
                overscrollBehaviorY: "contain"
            },
            children: [
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(framer_motion__WEBPACK_IMPORTED_MODULE_6__/* .motion.div */ .E.div, {
                    onAnimationComplete: function(definition) {
                        onComplete(definition);
                    },
                    variants: boxVariants,
                    initial: "hidden",
                    animate: "visible",
                    exit: "hidden",
                    style: {
                        gridArea: "1 / 1 / -1 / -1",
                        zIndex: 10,
                        position: "relative"
                    },
                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_5__/* .Box */ .x, {
                        display: "block",
                        tabIndex: -1,
                        ref: containerRef,
                        backgroundColor: "$backgroundPrimary",
                        maxWidth: "$360",
                        mx: "auto",
                        pt: "$16",
                        px: "$4",
                        pb: "$8",
                        role: "dialog",
                        "aria-labelledby": dialogId,
                        "aria-modal": true,
                        borderTopLeftRadius: "$8x",
                        borderTopRightRadius: "$8x",
                        minHeight: "100%",
                        $largerThanSM: {
                            pt: "$37",
                            px: "$4",
                            pb: "$8"
                        },
                        "$platform-web": {
                            outline: "0"
                        },
                        children: [
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_7__/* .IconButton */ .hU, {
                                analyticsName: "",
                                "aria-label": "Close",
                                onPress: function() {
                                    return setIsVisible(false);
                                },
                                size: "large",
                                icon: {
                                    Component: (0,_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_8__/* .adaptExternalIcon */ .f)(_tabler_icons_react__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z),
                                    label: "Close"
                                },
                                backgroundColor: "$backgroundTertiary",
                                position: "absolute",
                                right: "$4",
                                top: "$4"
                            }),
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_StandaloneText__WEBPACK_IMPORTED_MODULE_2__.CenteredLayout, {
                                entry: entry,
                                dialogId: dialogId
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(framer_motion__WEBPACK_IMPORTED_MODULE_6__/* .motion.div */ .E.div, {
                    variants: backdropVariants,
                    initial: "hidden",
                    animate: "visible",
                    exit: "hidden",
                    style: {
                        gridArea: "1 / 1 / -1 / -1",
                        zIndex: 0
                    },
                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_10__/* .PressableBox */ .K, {
                        analyticsName: "",
                        onPress: function() {
                            return setIsVisible(false);
                        },
                        "aria-hidden": true,
                        bottom: 0,
                        top: 0,
                        left: 0,
                        right: 0,
                        "aria-label": "Close sheet",
                        "$platform-web": {
                            position: "fixed",
                            backgroundColor: "rgba(0, 0, 0, 0.2)"
                        }
                    })
                })
            ]
        })
    });
};
var Sheet = function(param) {
    var entry = param.entry, isVisible = param.isVisible, setIsVisible = param.setIsVisible, exitComplete = param.exitComplete;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), mounted = ref[0], setMounted = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        return setMounted(true);
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        document.body.classList.toggle("has-sheet", isVisible);
    }, [
        isVisible
    ]);
    var escFunction = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(event) {
        if (event.key === "Escape") {
            setIsVisible(false);
        }
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        document.addEventListener("keydown", escFunction, false);
        return function() {
            document.removeEventListener("keydown", escFunction, false);
        };
    }, [
        escFunction
    ]);
    return mounted ? /*#__PURE__*/ (0,react_dom__WEBPACK_IMPORTED_MODULE_1__.createPortal)(/*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(framer_motion__WEBPACK_IMPORTED_MODULE_11__/* .AnimatePresence */ .M, {
        initial: false,
        onExitComplete: function() {
            return exitComplete();
        },
        children: isVisible && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(framer_motion__WEBPACK_IMPORTED_MODULE_6__/* .motion.div */ .E.div, {
            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(SheetContent, {
                entry: entry,
                setIsVisible: setIsVisible
            })
        }, "sheet-".concat(entry.sys.id))
    }), document.body) : null;
};
/* harmony default export */ __webpack_exports__["Z"] = (Sheet);


/***/ }),

/***/ 78837:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Jm": function() { return /* binding */ SubheadSmall; },
/* harmony export */   "Xe": function() { return /* binding */ Desc; },
/* harmony export */   "aI": function() { return /* binding */ TitleWithAccent; },
/* harmony export */   "j4": function() { return /* binding */ Eyebrow; },
/* harmony export */   "vF": function() { return /* binding */ Subhead; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99534);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(35944);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(76614);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(45972);






var Eyebrow = function(_param) {
    var children = _param.children, size = _param.size, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_param, [
        "children",
        "size"
    ]);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_3__/* .Text */ .x, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        tag: "p",
        typography: size !== null && size !== void 0 ? size : "$bodySmall",
        fontWeight: "$medium",
        display: "block",
        color: "$borderStateHoverPrimary"
    }, props), {
        children: children
    }));
};
var Subhead = function(_param) {
    var children = _param.children, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_param, [
        "children"
    ]);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_3__/* .Text */ .x, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        tag: "h4",
        display: "block",
        typography: "$bodyLarge",
        fontWeight: "$medium",
        color: "$contentPrimary"
    }, props), {
        children: children
    }));
};
var SubheadSmall = function(_param) {
    var children = _param.children, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_param, [
        "children"
    ]);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_3__/* .Text */ .x, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        tag: "h3",
        typography: "$bodyLarge",
        $smallerThanLG: {
            typography: "$bodyMedium",
            fontWeight: "$medium"
        },
        fontWeight: "$medium",
        color: "$contentPrimary",
        display: "block"
    }, props), {
        children: children
    }));
};
var TitleWithAccent = function(_param) {
    var title = _param.title, titleAccent = _param.titleAccent, titleSize = _param.titleSize, titleColor = _param.titleColor, titleAccentColor = _param.titleAccentColor, breakTitles = _param.breakTitles, overRideTitleTag = _param.overRideTitleTag, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_param, [
        "title",
        "titleAccent",
        "titleSize",
        "titleColor",
        "titleAccentColor",
        "breakTitles",
        "overRideTitleTag"
    ]);
    var typography = {
        typography: titleSize === "Large" ? "$headerSmall" : "$headerMedium",
        $largerThanSM: {
            typography: titleSize === "Large" ? "$displaySmall" : "$headerMedium"
        },
        $largerThanMD: {
            typography: titleSize === "Large" ? "$displaySmall" : "$headerMedium"
        }
    };
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_3__/* .Text */ .x, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        tag: overRideTitleTag || "h2"
    }, typography), {
        display: "block",
        maxWidth: "16ch",
        color: titleColor || "$contentPrimary",
        mb: "$8x"
    }), props), {
        whiteSpace: "normal",
        children: [
            (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .markdownToReactElement */ .vl)(title || ""),
            breakTitles && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)("br", {}),
            titleAccent && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_3__/* .Text */ .x, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                tag: "span"
            }, typography), {
                color: titleAccentColor || "$contentTertiary"
            }), props), {
                whiteSpace: "normal",
                children: [
                    " ",
                    (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .markdownToReactElement */ .vl)(titleAccent)
                ]
            }))
        ]
    }));
};
var Desc = function(_param) {
    var children = _param.children, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_param, [
        "children"
    ]);
    if (!children) return null;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_3__/* .Text */ .x, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        tag: "p",
        color: "$contentPrimary",
        typography: "$bodyLarge",
        display: "block"
    }, props), {
        children: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .markdownToReactElement */ .vl)(children)
    }));
};


/***/ }),

/***/ 97680:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$C": function() { return /* binding */ GLASS_HEADER_HEIGHT; },
/* harmony export */   "Do": function() { return /* binding */ FULLBLEED_HERO_IMAGE_URL; },
/* harmony export */   "Iu": function() { return /* binding */ GLASS_NAV_ACTIVE_COLOR; },
/* harmony export */   "pj": function() { return /* binding */ TREATMENT_ANALYTICS_IDS; },
/* harmony export */   "rf": function() { return /* binding */ redirectToLogin; }
/* harmony export */ });
/* harmony import */ var _globals__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(35480);

var GLASS_HEADER_HEIGHT = 72;
// No bricks-next semantic token available — used for nav active state and flyout section titles
var GLASS_NAV_ACTIVE_COLOR = "#B5CAFF";
var FULLBLEED_HERO_IMAGE_URL = "https://images.opendoor.com/source/s3/imgdrop-production/2026-04-1775664739908-77107_hero-desktop-1728w.jpg?service=cosmos";
// Shared experiment identifier — used across hero, layout, and header gating logic
var TREATMENT_ANALYTICS_IDS = [
    "hero-test-vercel",
    "fc-address-entry-btf-test"
];
var redirectToLogin = function() {
    if (true) {
        window.location.href = "".concat(_globals__WEBPACK_IMPORTED_MODULE_0__/* .COSMOS_URL */ .EQ, "/login?redirectTo=").concat(encodeURIComponent(window.location.pathname));
    }
};


/***/ }),

/***/ 21076:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AJ": function() { return /* binding */ useStickyCTA; },
/* harmony export */   "DB": function() { return /* binding */ preloadHeroImages; },
/* harmony export */   "Ul": function() { return /* binding */ getStickyCTAFromRoot; },
/* harmony export */   "bx": function() { return /* binding */ useHeroContext; },
/* harmony export */   "yL": function() { return /* binding */ HeroProvider; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(36305);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_intersection_observer__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70131);
/* harmony import */ var _shared_performance_pictures__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29212);
/* harmony import */ var _heroConstants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(78986);








var HeroContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(null);
var HeroProvider = function(param) {
    var variant = param.variant, analyticsPrefix = param.analyticsPrefix, children = param.children;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(HeroContext.Provider, {
        value: {
            variant: variant,
            analyticsPrefix: analyticsPrefix
        },
        children: children
    });
};
var useHeroContext = function() {
    var context = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(HeroContext);
    if (!context) {
        throw new Error("useHeroContext must be used within a HeroProvider");
    }
    return context;
};
var useStickyCTA = function() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), hasBeenInView = ref[0], setHasBeenInView = ref[1];
    var ref1 = (0,react_intersection_observer__WEBPACK_IMPORTED_MODULE_4__/* .useInView */ .YD)(), addressEntryRef = ref1.ref, addressEntryInView = ref1.inView;
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (addressEntryInView) {
            setHasBeenInView(true);
        }
    }, [
        addressEntryInView
    ]);
    // Only show after user has scrolled past it at least once
    var showStickyCTAUtility = hasBeenInView && !addressEntryInView;
    return {
        addressEntryRef: addressEntryRef,
        showStickyCTAUtility: showStickyCTAUtility
    };
};
var preloadHeroImages = function(param) {
    var imageDesktopUrl = param.imageDesktopUrl, imageMobileUrl = param.imageMobileUrl;
    var preloadImages = [];
    if (imageDesktopUrl) {
        var _preloadImages;
        var sources = (0,_shared_performance_pictures__WEBPACK_IMPORTED_MODULE_1__/* .generatePresetPictureSetProps */ .$c)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, _heroConstants__WEBPACK_IMPORTED_MODULE_2__/* .HERO_IMAGE_DESKTOP_PROPS */ .t6), {
            photoUrl: imageDesktopUrl
        })).sources;
        (_preloadImages = preloadImages).push.apply(_preloadImages, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(sources));
    }
    if (imageMobileUrl) {
        var _preloadImages1;
        var sources1 = (0,_shared_performance_pictures__WEBPACK_IMPORTED_MODULE_1__/* .generatePresetPictureSetProps */ .$c)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, _heroConstants__WEBPACK_IMPORTED_MODULE_2__/* .HERO_IMAGE_MOBILE_PROPS */ .Sy), {
            photoUrl: imageMobileUrl
        })).sources;
        (_preloadImages1 = preloadImages).push.apply(_preloadImages1, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(sources1));
    }
    return preloadImages;
};
var getStickyCTAFromRoot = function(root) {
    var ref;
    return (root === null || root === void 0 ? void 0 : (ref = root.fields) === null || ref === void 0 ? void 0 : ref.stickyCta) || "";
};


/***/ }),

/***/ 44636:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ PressBox; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(35944);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(46523);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6967);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(76614);




var LOGO_HEIGHT = 20;
var PRESET = "square-256";
var createLogoUrl = function(baseUrl, dpr) {
    var params = new URLSearchParams({
        preset: PRESET,
        service: "cosmos",
        dpr: "".concat(dpr)
    });
    return "".concat(baseUrl, "?").concat(params.toString());
};
var FORBES_LOGO_URL = "https://images.opendoor.com/source/s3/imgdrop-production/2023-07-1690500903565-83391.png";
var FORTUNE_LOGO_URL = "https://images.opendoor.com/source/s3/imgdrop-production/2023-07-1690500903560-61291.png";
var NEW_YORK_TIMES_LOGO_URL = "https://images.opendoor.com/source/s3/imgdrop-production/2023-07-1690500903555-88900.png";
var WALL_STREET_JOURNAL_LOGO_URL = "https://images.opendoor.com/source/s3/imgdrop-production/2023-07-1690500903562-10942.png";
var PRESS_LOGOS = [
    NEW_YORK_TIMES_LOGO_URL,
    FORBES_LOGO_URL,
    WALL_STREET_JOURNAL_LOGO_URL,
    FORTUNE_LOGO_URL, 
];
var PressBox = function(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .x, {
        justifyContent: "center",
        width: "100%",
        $largerThanMD: {
            width: "auto"
        },
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_2__/* .Row */ .X, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
            flexWrap: "wrap",
            columnGap: "$6x",
            padding: "$10x",
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
            borderRadius: 0,
            $largerThanSM: {
                borderRadius: 20,
                width: "unset"
            },
            style: {
                backgroundColor: "rgba(242, 241, 240, 0.64)",
                backdropFilter: "blur(20px)"
            }
        }, props), {
            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_2__/* .Row */ .X, {
                alignItems: "center",
                justifyContent: "center",
                style: {
                    display: "grid",
                    gridTemplateColumns: "repeat(3, max-content)",
                    gap: "24px",
                    width: "100%",
                    justifyItems: "center"
                },
                children: [
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_5__/* .Text */ .x, {
                        tag: "span",
                        typography: "$bodyMedium",
                        color: "$contentStateInactivePrimary",
                        $smallerThanMD: {
                            width: "100%",
                            textAlign: "center"
                        },
                        children: "Featured in:"
                    }),
                    PRESS_LOGOS.map(function(photoUrl) {
                        var srcSet = [
                            "".concat(createLogoUrl(photoUrl, 1), " 1x"),
                            "".concat(createLogoUrl(photoUrl, 2), " 2x"),
                            "".concat(createLogoUrl(photoUrl, 3), " 3x"), 
                        ].join(", ");
                        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .x, {
                            height: LOGO_HEIGHT,
                            width: "auto",
                            display: "flex",
                            justifyContent: "center",
                            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("img", {
                                src: createLogoUrl(photoUrl, 1),
                                srcSet: srcSet,
                                alt: "",
                                style: {
                                    height: "100%",
                                    width: "auto",
                                    objectFit: "contain"
                                }
                            })
                        }, photoUrl);
                    })
                ]
            })
        }))
    });
};


/***/ }),

/***/ 78986:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$B": function() { return /* binding */ HERO_FULLBLEED_IMAGE_PROPS; },
/* harmony export */   "Sy": function() { return /* binding */ HERO_IMAGE_MOBILE_PROPS; },
/* harmony export */   "t6": function() { return /* binding */ HERO_IMAGE_DESKTOP_PROPS; }
/* harmony export */ });
// Bricks-next breakpoints: SM (375px), MD (768px), LG (1201px), XL (1400px)
var BREAKPOINTS = {
    SM: 375,
    MD: 768,
    LG: 1201,
    XL: 1400
};
var HERO_DESKTOP_IMAGE_SIZES = [
    {
        minWidth: BREAKPOINTS.MD,
        maxWidth: BREAKPOINTS.LG,
        preset: "square-512"
    },
    {
        minWidth: BREAKPOINTS.LG,
        maxWidth: BREAKPOINTS.XL,
        preset: "square-512"
    },
    {
        minWidth: BREAKPOINTS.XL,
        maxWidth: null,
        preset: "square-1024"
    }, 
];
var HERO_MOBILE_IMAGE_SIZES = [
    {
        minWidth: 0,
        maxWidth: BREAKPOINTS.SM,
        preset: "square-256"
    },
    {
        minWidth: BREAKPOINTS.SM,
        maxWidth: BREAKPOINTS.MD,
        preset: "square-256"
    },
    {
        minWidth: BREAKPOINTS.MD,
        maxWidth: BREAKPOINTS.LG,
        preset: "square-512"
    }, 
];
var HERO_IMAGE_DESKTOP_PROPS = {
    sizes: HERO_DESKTOP_IMAGE_SIZES,
    debugImageSizes: false,
    lazy: false,
    preload: true,
    fetchPriority: "high"
};
var HERO_IMAGE_MOBILE_PROPS = {
    sizes: HERO_MOBILE_IMAGE_SIZES,
    debugImageSizes: false,
    lazy: false,
    preload: true,
    fetchPriority: "high"
};
var HERO_FULLBLEED_IMAGE_SIZES = [
    {
        minWidth: 0,
        maxWidth: BREAKPOINTS.SM,
        preset: "square-512"
    },
    {
        minWidth: BREAKPOINTS.SM,
        maxWidth: BREAKPOINTS.MD,
        preset: "square-1024"
    },
    {
        minWidth: BREAKPOINTS.MD,
        maxWidth: BREAKPOINTS.XL,
        preset: "square-1024"
    },
    {
        minWidth: BREAKPOINTS.XL,
        maxWidth: null,
        preset: "square-2048"
    }, 
];
var HERO_FULLBLEED_IMAGE_PROPS = {
    sizes: HERO_FULLBLEED_IMAGE_SIZES,
    debugImageSizes: false,
    lazy: false,
    preload: true,
    fetchPriority: "high"
};


/***/ }),

/***/ 12090:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CW": function() { return /* binding */ BNColorThemes; },
/* harmony export */   "_Y": function() { return /* binding */ getComponentThemeColors; },
/* harmony export */   "pz": function() { return /* binding */ resolveBricksColor; },
/* harmony export */   "u$": function() { return /* binding */ getBNComponentThemeColors; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(69396);


// Bricks ColorScheme name → CSS hex value
// Used to translate old componentTheme color tokens for bricks-next components
var BRICKS_COLOR_TO_CSS = {
    // Brand blues
    brandBlue600: "#0040E6",
    blue50: "#F2F4F7",
    blue100: "#DFEAF8",
    blue200: "#BBD7FA",
    blue500: "#2B54EA",
    blue700: "#002F93",
    blue900: "#00256B",
    // Warm greys
    white0: "#FFFFFF",
    warmgrey100: "#FAF8F7",
    warmgrey200: "#ECE9E7",
    warmgrey300: "#DEDAD7",
    warmgrey700: "#9D9893",
    warmgrey800: "#736D68",
    warmgrey900: "#403E3C",
    warmgrey950: "#21201F",
    // Earth
    earth100: "#F3F3EE",
    earth200: "#ECE9E7",
    earth300: "#D7D7C4",
    earth700: "#C3C3AF",
    // Legacy
    neutrals100: "#21201F"
};
var _color;
/**
 * Resolve a bricks ColorScheme name to a CSS hex value that bricks-next
 * components can render. Returns the input unchanged if no mapping exists
 * (e.g. already a hex value or bricks-next token).
 *
 * The return type is intentionally loosened so the result can be passed
 * directly to bricks-next color/backgroundColor props without per-site casts.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
var resolveBricksColor = function(color) {
    return (_color = BRICKS_COLOR_TO_CSS[color]) !== null && _color !== void 0 ? _color : color;
};
var getComponentThemeColors = function(background) {
    var theme = {
        "White 0": {
            bg: "white0",
            color: "warmgrey950",
            colorLight: "warmgrey700",
            foregroundColor: "dark",
            buttonBg: "brandBlue600",
            buttonColor: "white0",
            buttonHoverBg: "blue700",
            buttonActiveBg: "blue900",
            secondaryButtonBg: "warmgrey950",
            secondaryButtonColor: "white0",
            secondaryButtonHoverBg: "warmgrey900",
            secondaryButtonActiveBg: "warmgrey950",
            tertiaryButtonBg: "warmgrey200",
            tertiaryButtonColor: "warmgrey950",
            tertiaryButtonHoverColor: "warmgrey300",
            tertiaryButtonActiveColor: "warmgrey200",
            linkColor: "blue700",
            linkAltColor: "warmgrey900",
            linkHoverColor: "blue500",
            cardHoverBg: "rgba(0, 0, 0, 0.05)",
            cardActiveBg: "rgba(0, 0, 0, 0.1)"
        },
        "Off White": {
            bg: "warmgrey100",
            color: "warmgrey950",
            colorLight: "warmgrey700",
            foregroundColor: "dark",
            buttonBg: "brandBlue600",
            buttonColor: "white0",
            buttonHoverBg: "blue700",
            buttonActiveBg: "blue900",
            secondaryButtonBg: "warmgrey950",
            secondaryButtonColor: "white0",
            secondaryButtonHoverBg: "warmgrey900",
            secondaryButtonActiveBg: "warmgrey950",
            tertiaryButtonBg: "warmgrey200",
            tertiaryButtonColor: "warmgrey950",
            tertiaryButtonHoverColor: "warmgrey300",
            tertiaryButtonActiveColor: "warmgrey200",
            linkColor: "blue700",
            linkAltColor: "warmgrey900",
            linkHoverColor: "blue500",
            cardHoverBg: "rgba(0, 0, 0, 0.05)",
            cardActiveBg: "rgba(0, 0, 0, 0.1)"
        },
        "Earth 100": {
            bg: "earth100",
            color: "warmgrey950",
            colorLight: "warmgrey700",
            foregroundColor: "dark",
            buttonBg: "brandBlue600",
            buttonColor: "white0",
            buttonHoverBg: "blue700",
            buttonActiveBg: "blue900",
            secondaryButtonBg: "warmgrey950",
            secondaryButtonColor: "white0",
            secondaryButtonHoverBg: "warmgrey900",
            secondaryButtonActiveBg: "warmgrey950",
            tertiaryButtonBg: "earth300",
            tertiaryButtonColor: "warmgrey950",
            tertiaryButtonHoverColor: "earth700",
            tertiaryButtonActiveColor: "earth700",
            linkColor: "blue700",
            linkAltColor: "warmgrey900",
            linkHoverColor: "blue500",
            cardHoverBg: "rgba(0, 0, 0, 0.05)",
            cardActiveBg: "rgba(0, 0, 0, 0.1)"
        },
        "Earth 200": {
            bg: "earth200",
            color: "warmgrey950",
            colorLight: "warmgrey700",
            foregroundColor: "dark",
            buttonBg: "brandBlue600",
            buttonColor: "white0",
            buttonHoverBg: "blue700",
            buttonActiveBg: "blue900",
            secondaryButtonBg: "warmgrey950",
            secondaryButtonColor: "white0",
            secondaryButtonHoverBg: "warmgrey900",
            secondaryButtonActiveBg: "warmgrey950",
            tertiaryButtonBg: "earth300",
            tertiaryButtonColor: "warmgrey950",
            tertiaryButtonHoverColor: "earth700",
            tertiaryButtonActiveColor: "earth700",
            linkColor: "blue700",
            linkAltColor: "warmgrey900",
            linkHoverColor: "blue500",
            cardHoverBg: "rgba(0, 0, 0, 0.05)",
            cardActiveBg: "rgba(0, 0, 0, 0.1)"
        },
        "Brand Blue 600": {
            bg: "brandBlue600",
            color: "white0",
            colorLight: "blue200",
            foregroundColor: "light",
            buttonBg: "warmgrey950",
            buttonColor: "white0",
            buttonHoverBg: "warmgrey900",
            buttonActiveBg: "warmgrey950",
            secondaryButtonBg: "white0",
            secondaryButtonColor: "brandBlue600",
            secondaryButtonHoverBg: "blue50",
            secondaryButtonActiveBg: "blue100",
            tertiaryButtonBg: "blue500",
            tertiaryButtonColor: "white0",
            tertiaryButtonHoverColor: "blue700",
            tertiaryButtonActiveColor: "blue900",
            linkColor: "white0",
            linkAltColor: "white0",
            linkHoverColor: "blue50",
            cardHoverBg: "rgba(0, 0, 0, 0.1)",
            cardActiveBg: "rgba(0, 0, 0, 0.2)"
        },
        "Warm Grey 200": {
            bg: "warmgrey200",
            color: "warmgrey950",
            colorLight: "warmgrey700",
            foregroundColor: "dark",
            buttonBg: "brandBlue600",
            buttonHoverBg: "blue700",
            buttonActiveBg: "blue900",
            buttonColor: "white0",
            secondaryButtonBg: "warmgrey950",
            secondaryButtonColor: "white0",
            secondaryButtonHoverBg: "warmgrey900",
            secondaryButtonActiveBg: "warmgrey950",
            tertiaryButtonBg: "warmgrey300",
            tertiaryButtonColor: "warmgrey950",
            tertiaryButtonHoverColor: "warmgrey100",
            tertiaryButtonActiveColor: "warmgrey300",
            linkColor: "blue700",
            linkAltColor: "warmgrey900",
            linkHoverColor: "blue500",
            cardHoverBg: "rgba(0, 0, 0, 0.05)",
            cardActiveBg: "rgba(0, 0, 0, 0.1)"
        },
        "Warm Grey 800": {
            bg: "warmgrey800",
            color: "white0",
            colorLight: "warmgrey300",
            foregroundColor: "light",
            buttonBg: "warmgrey950",
            buttonColor: "white0",
            buttonHoverBg: "warmgrey900",
            buttonActiveBg: "warmgrey900",
            secondaryButtonBg: "white0",
            secondaryButtonColor: "warmgrey950",
            secondaryButtonHoverBg: "blue50",
            secondaryButtonActiveBg: "blue100",
            tertiaryButtonBg: "warmgrey700",
            tertiaryButtonColor: "white0",
            tertiaryButtonHoverColor: "warmgrey900",
            tertiaryButtonActiveColor: "warmgrey700",
            linkColor: "white0",
            linkAltColor: "white0",
            linkHoverColor: "blue50",
            cardHoverBg: "rgba(0, 0, 0, 0.1)",
            cardActiveBg: "rgba(0, 0, 0, 0.2)"
        },
        "Warm Grey 950": {
            bg: "warmgrey950",
            color: "white0",
            colorLight: "warmgrey700",
            foregroundColor: "light",
            buttonBg: "brandBlue600",
            buttonColor: "white0",
            buttonHoverBg: "blue700",
            buttonActiveBg: "blue900",
            secondaryButtonBg: "white0",
            secondaryButtonColor: "warmgrey950",
            secondaryButtonHoverBg: "blue50",
            secondaryButtonActiveBg: "blue100",
            tertiaryButtonBg: "warmgrey900",
            tertiaryButtonColor: "white0",
            tertiaryButtonHoverColor: "warmgrey700",
            tertiaryButtonActiveColor: "warmgrey900",
            linkColor: "white0",
            linkAltColor: "white0",
            linkHoverColor: "blue50",
            cardHoverBg: "rgba(0, 0, 0, 0.1)",
            cardActiveBg: "rgba(0, 0, 0, 0.2)"
        },
        Dark: {
            bg: "neutrals100",
            // you can adjust the rest of these colors below for "dark theme"
            color: "white0",
            colorLight: "warmgrey700",
            foregroundColor: "light",
            buttonBg: "brandBlue600",
            buttonColor: "white0",
            buttonHoverBg: "blue700",
            buttonActiveBg: "blue900",
            secondaryButtonBg: "white0",
            secondaryButtonColor: "warmgrey950",
            secondaryButtonHoverBg: "blue50",
            secondaryButtonActiveBg: "blue100",
            tertiaryButtonBg: "warmgrey900",
            tertiaryButtonColor: "white0",
            tertiaryButtonHoverColor: "warmgrey700",
            tertiaryButtonActiveColor: "warmgrey900",
            linkColor: "white0",
            linkAltColor: "white0",
            linkHoverColor: "blue50",
            cardHoverBg: "rgba(0, 0, 0, 0.1)",
            cardActiveBg: "rgba(0, 0, 0, 0.2)"
        }
    };
    var _background;
    var currentTheme = (_background = theme[background]) !== null && _background !== void 0 ? _background : theme["White 0"];
    return {
        bg: currentTheme.bg,
        color: currentTheme.color,
        colorLight: currentTheme.colorLight,
        foregroundColor: currentTheme.foregroundColor,
        buttonBg: currentTheme.buttonBg,
        buttonColor: currentTheme.buttonColor,
        buttonHoverBg: currentTheme.buttonHoverBg,
        buttonActiveBg: currentTheme.buttonActiveBg,
        secondaryButtonBg: currentTheme.secondaryButtonBg,
        secondaryButtonColor: currentTheme.secondaryButtonColor,
        secondaryButtonHoverBg: currentTheme.secondaryButtonHoverBg,
        secondaryButtonActiveBg: currentTheme.secondaryButtonActiveBg,
        tertiaryButtonBg: currentTheme.tertiaryButtonBg,
        tertiaryButtonColor: currentTheme.tertiaryButtonColor,
        tertiaryButtonHoverColor: currentTheme.tertiaryButtonHoverColor,
        tertiaryButtonActiveColor: currentTheme.tertiaryButtonActiveColor,
        linkColor: currentTheme.linkColor,
        linkAltColor: currentTheme.linkAltColor || currentTheme.linkColor,
        linkHoverColor: currentTheme.linkHoverColor,
        cardHoverBg: currentTheme.cardHoverBg,
        cardActiveBg: currentTheme.cardActiveBg
    };
};
var BNColorThemes;
(function(BNColorThemes) {
    BNColorThemes["Light"] = "Light";
    BNColorThemes["Dark"] = "Dark";
    BNColorThemes["Grey"] = "Grey";
})(BNColorThemes || (BNColorThemes = {}));
/**
 * Function to determine the BricksNext theme colors for components based on the background color value.
 * @param background - The type of background: 'Dark', 'Grey', or 'Light'.
 * @returns An object containing the IBNComponentThemeConfig.
 */ var getBNComponentThemeColors = function(background) {
    // Theme colors that are same for all the varients
    var commonThemeConfig = {
        contentPrimaryAccent: "$contentTertiary",
        bgAccentBrand: "$backgroundAccentBrand",
        bgHoverAccentBrand: "$backgroundStateHoverAccentBrand",
        buttonLabelPrimary: "$contentInversePrimary",
        linkColor: "$backgroundAccentBrand",
        linkHover: "$backgroundStateHoverAccentBrand"
    };
    switch(background){
        case "Dark":
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, commonThemeConfig), {
                bgPrimary: "$backgroundInversePrimary",
                contentPrimary: "$contentInversePrimary",
                bgPrimaryLight: "$backgroundInverseStateHoverSecondary",
                inactivePrimary: "$contentStateInactivePrimary",
                secondaryBtnHover: "$contentInverseSecondary",
                tertiaryBtnHover: "$backgroundInverseTertiary"
            });
        case "Grey":
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, commonThemeConfig), {
                bgPrimary: "$backgroundTertiary",
                contentPrimary: "$contentPrimary",
                bgPrimaryLight: "$backgroundStateHoverPrimary",
                inactivePrimary: "$contentPrimary",
                secondaryBtnHover: "$contentSecondary",
                tertiaryBtnHover: "$backgroundSecondary"
            });
        case "Light":
        default:
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, commonThemeConfig), {
                bgPrimary: "$backgroundPrimary",
                contentPrimary: "$contentPrimary",
                bgPrimaryLight: "$backgroundStateHoverPrimary",
                inactivePrimary: "$contentPrimary",
                secondaryBtnHover: "$contentSecondary",
                tertiaryBtnHover: "$backgroundTertiary"
            });
    }
};


/***/ }),

/***/ 45972:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "jx": function() { return /* binding */ contentfulToImagesWorkerUrl; },
/* harmony export */   "rX": function() { return /* binding */ resizeImageUrl; },
/* harmony export */   "vl": function() { return /* binding */ markdownToReactElement; }
/* harmony export */ });
/* harmony import */ var react_html_parser__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30653);
/* harmony import */ var markdown_it__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(17441);


var markdownItOptions = {
    html: true,
    breaks: true,
    linkify: true,
    typographer: true
};
/**
 * Converts a Markdown string to one or more React elements
 * @param {string} markdown
 * @param {boolean} [allowHtml=false] - whether to allow HTML in source content
 * @param {string} [strip=false] - whether to strip a tag from the output
 * @return {HTMLElement}
 */ var markdownToReactElement = function(markdown) {
    var allowHtml = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
    markdownItOptions.html = allowHtml;
    var html = (0,markdown_it__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(markdownItOptions).renderInline(markdown);
    return (0,react_html_parser__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(html);
};
var SQUARE_PRESETS = [
    48,
    64,
    128,
    256,
    512,
    1024,
    2048
];
// Returns the smallest square preset that covers targetWidth, or the largest as fallback.
var squarePresetFor = function(targetWidth) {
    var match = SQUARE_PRESETS.find(function(s) {
        return s >= targetWidth;
    });
    return "square-".concat(match !== null && match !== void 0 ? match : 2048);
};
// Convert a CMS image URL (imgdrop.imgix.net or already-migrated images.opendoor.com)
// to a CDN URL sized via the nearest square preset.
var resizeImageUrl = function(url, targetWidth) {
    var preset = squarePresetFor(targetWidth);
    try {
        var parsed = new URL(url);
        if (parsed.hostname === "imgdrop.imgix.net") {
            var path = parsed.pathname.replace(/^\//, "");
            return "https://images.opendoor.com/source/s3/imgdrop-production/".concat(path, "?service=cosmos&preset=").concat(preset);
        }
        if (parsed.hostname === "images.opendoor.com") {
            parsed.searchParams.set("service", "cosmos");
            parsed.searchParams.set("preset", preset);
            return parsed.toString();
        }
        return url;
    } catch (e) {
        return url;
    }
};
var contentfulToImagesWorkerUrl = function(contentfulURL) {
    var normalized = contentfulURL.startsWith("//") ? "https:".concat(contentfulURL) : contentfulURL;
    var pathname = new URL(normalized).pathname;
    return "https://images.opendoor.com/source/contentful".concat(pathname);
};


/***/ }),

/***/ 68153:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N3": function() { return /* binding */ articlesLoader; }
/* harmony export */ });
/* unused harmony export articleLiteFields */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(36305);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(97582);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(35944);
/* harmony import */ var _opendoor_observability_slim__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(74593);
/* harmony import */ var cms_api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96141);
/* harmony import */ var components_landing_pages_v2_shared_Container__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93524);
/* harmony import */ var components_landing_pages_v2_shared_styles_ComponentTheme__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(12090);
/* harmony import */ var components_shared_CardCarouselV2__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3776);
/* harmony import */ var components_shared_Multicard_MulticardCard__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(63933);
/* harmony import */ var components_shared_Multicard_MulticardList__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(52683);
/* harmony import */ var _helpers_pagination__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(88279);
/* harmony import */ var _CardSectionHeader__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(72622);













var ARTICLES_PER_PAGE = 16;
var maparticlesToGenericMulticardDetails = function(article, theme, limit) {
    var ref, ref1;
    return {
        title: article === null || article === void 0 ? void 0 : article.articleName,
        imageUrl: (article === null || article === void 0 ? void 0 : (ref = article.openGraph) === null || ref === void 0 ? void 0 : (ref1 = ref.fields) === null || ref1 === void 0 ? void 0 : ref1.image) || "https://images.opendoor.com/source/s3/imgdrop-production/4b831192b06849a589afcef62a25757d.jpg?preset=square-2048",
        componentTheme: theme,
        redirectUrl: article === null || article === void 0 ? void 0 : article.slug,
        desc: (article === null || article === void 0 ? void 0 : article.articleSubtitle) || "",
        cardsLimit: limit
    };
};
var renderArticlesCards = function(entry, resolvedData) {
    var ref, ref1, ref2;
    var DEFAULT_CAROUSEL_CARDS_LIMIT = 4;
    var ref3, ref4;
    var articles = (ref4 = (ref3 = (ref = entry.fields) === null || ref === void 0 ? void 0 : ref.items) !== null && ref3 !== void 0 ? ref3 : resolvedData === null || resolvedData === void 0 ? void 0 : resolvedData.articles) !== null && ref4 !== void 0 ? ref4 : [];
    articles = articles.filter(function(a) {
        return !!a.fields;
    });
    var limit = !((ref1 = entry.fields) === null || ref1 === void 0 ? void 0 : ref1.limit) ? DEFAULT_CAROUSEL_CARDS_LIMIT : (ref2 = entry.fields) === null || ref2 === void 0 ? void 0 : ref2.limit;
    limit = articles.length < limit ? articles.length : limit;
    var componentTheme = (0,components_landing_pages_v2_shared_styles_ComponentTheme__WEBPACK_IMPORTED_MODULE_3__/* .getComponentThemeColors */ ._Y)(entry.fields.cardBackgroundColor || "Off White");
    if (articles.length === 0) {
        return null;
    }
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsxs */ .BX)(components_landing_pages_v2_shared_Container__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
        paddingTop: "$32x",
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(_CardSectionHeader__WEBPACK_IMPORTED_MODULE_7__/* .CardSectionHeader */ .y, {
                titleSize: entry.fields.titleSize,
                title: entry.fields.title,
                titleAccent: entry.fields.titleAccent,
                desc: entry.fields.desc,
                eyebrow: entry.fields.eyebrow,
                subhead: entry.fields.subHead,
                display: entry.fields.display
            }),
            entry.fields.display === "list" ? /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(components_shared_Multicard_MulticardList__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                cards: articles.map(function(article) {
                    return maparticlesToGenericMulticardDetails(article.fields, componentTheme);
                }),
                columnNumber: 4,
                componentTheme: componentTheme,
                cardVerticalAlignment: ""
            }) : /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(components_shared_CardCarouselV2__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                id: entry.sys.id,
                cards: articles,
                componentTheme: componentTheme,
                columnNumber: limit,
                renderCard: function(card, id) {
                    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(components_shared_Multicard_MulticardCard__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP, {
                        id: id,
                        card: maparticlesToGenericMulticardDetails(card.fields, componentTheme, limit),
                        componentTheme: componentTheme,
                        cardVerticalAlignment: "Top"
                    });
                }
            })
        ]
    });
};
// Fetch authors, editors, and reviewers if componentExperts is also in root
var fetchExperts = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(function(articles, root) {
        var _experts, _experts1, _experts2, isComponentExpertsFound, _content, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, content, ref, ref1, ref2, ref3, ref4, experts, authorIds, _iteratorNormalCompletion1, _didIteratorError1, _iteratorError1, _iterator1, _step1, article, ref5, ref6, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, author, authorEntries, ref7, editorIds, _iteratorNormalCompletion3, _didIteratorError3, _iteratorError3, _iterator3, _step3, article1, _editors, _iteratorNormalCompletion4, _didIteratorError4, _iteratorError4, _iterator4, _step4, editor, editorEntries, ref8, reviewerIds, _iteratorNormalCompletion5, _didIteratorError5, _iteratorError5, _iterator5, _step5, article2, _reviewers, _iteratorNormalCompletion6, _didIteratorError6, _iteratorError6, _iterator6, _step6, reviewer, reviewerEntries;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_10__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    isComponentExpertsFound = false;
                    _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(_iterator = ((_content = root === null || root === void 0 ? void 0 : root.fields.body.content) !== null && _content !== void 0 ? _content : [])[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            content = _step.value;
                            ;
                            if (((ref = content.data) === null || ref === void 0 ? void 0 : (ref1 = ref.target) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.sys) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.contentType) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.sys) === null || ref4 === void 0 ? void 0 : ref4.id) === "componentExperts") {
                                isComponentExpertsFound = true;
                                break;
                            }
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    if (!isComponentExpertsFound) {
                        return [
                            2,
                            []
                        ];
                    }
                    experts = [];
                    authorIds = [];
                    _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                    try {
                        for(_iterator1 = articles[Symbol.iterator](); !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                            article = _step1.value;
                            ;
                            ;
                            _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
                            try {
                                for(_iterator2 = ((ref6 = (ref5 = article.fields) === null || ref5 === void 0 ? void 0 : ref5.authors) !== null && ref6 !== void 0 ? ref6 : [])[Symbol.iterator](); !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                                    author = _step2.value;
                                    authorIds.push(author.sys.id);
                                }
                            } catch (err) {
                                _didIteratorError2 = true;
                                _iteratorError2 = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                                        _iterator2.return();
                                    }
                                } finally{
                                    if (_didIteratorError2) {
                                        throw _iteratorError2;
                                    }
                                }
                            }
                        }
                    } catch (err) {
                        _didIteratorError1 = true;
                        _iteratorError1 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                _iterator1.return();
                            }
                        } finally{
                            if (_didIteratorError1) {
                                throw _iteratorError1;
                            }
                        }
                    }
                    return [
                        4,
                        (0,cms_api__WEBPACK_IMPORTED_MODULE_1__/* .fetchEntriesById */ .x5)("author", authorIds)
                    ];
                case 1:
                    authorEntries = _state.sent();
                    (_experts = experts).push.apply(_experts, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(authorEntries.map(function(author) {
                        return (ref7 = author === null || author === void 0 ? void 0 : author.fields) !== null && ref7 !== void 0 ? ref7 : null;
                    })));
                    editorIds = [];
                    _iteratorNormalCompletion3 = true, _didIteratorError3 = false, _iteratorError3 = undefined;
                    try {
                        for(_iterator3 = articles[Symbol.iterator](); !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true){
                            article1 = _step3.value;
                            ;
                            _iteratorNormalCompletion4 = true, _didIteratorError4 = false, _iteratorError4 = undefined;
                            try {
                                for(_iterator4 = ((_editors = article1.fields.editors) !== null && _editors !== void 0 ? _editors : [])[Symbol.iterator](); !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true){
                                    editor = _step4.value;
                                    editorIds.push(editor.sys.id);
                                }
                            } catch (err) {
                                _didIteratorError4 = true;
                                _iteratorError4 = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion4 && _iterator4.return != null) {
                                        _iterator4.return();
                                    }
                                } finally{
                                    if (_didIteratorError4) {
                                        throw _iteratorError4;
                                    }
                                }
                            }
                        }
                    } catch (err) {
                        _didIteratorError3 = true;
                        _iteratorError3 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
                                _iterator3.return();
                            }
                        } finally{
                            if (_didIteratorError3) {
                                throw _iteratorError3;
                            }
                        }
                    }
                    return [
                        4,
                        (0,cms_api__WEBPACK_IMPORTED_MODULE_1__/* .fetchEntriesById */ .x5)("editor", editorIds)
                    ];
                case 2:
                    editorEntries = _state.sent();
                    (_experts1 = experts).push.apply(_experts1, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(editorEntries.map(function(editor) {
                        return (ref8 = editor === null || editor === void 0 ? void 0 : editor.fields) !== null && ref8 !== void 0 ? ref8 : null;
                    })));
                    reviewerIds = [];
                    _iteratorNormalCompletion5 = true, _didIteratorError5 = false, _iteratorError5 = undefined;
                    try {
                        for(_iterator5 = articles[Symbol.iterator](); !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true){
                            article2 = _step5.value;
                            ;
                            _iteratorNormalCompletion6 = true, _didIteratorError6 = false, _iteratorError6 = undefined;
                            try {
                                for(_iterator6 = ((_reviewers = article2.fields.reviewers) !== null && _reviewers !== void 0 ? _reviewers : [])[Symbol.iterator](); !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true){
                                    reviewer = _step6.value;
                                    reviewerIds.push(reviewer.sys.id);
                                }
                            } catch (err) {
                                _didIteratorError6 = true;
                                _iteratorError6 = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion6 && _iterator6.return != null) {
                                        _iterator6.return();
                                    }
                                } finally{
                                    if (_didIteratorError6) {
                                        throw _iteratorError6;
                                    }
                                }
                            }
                        }
                    } catch (err) {
                        _didIteratorError5 = true;
                        _iteratorError5 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion5 && _iterator5.return != null) {
                                _iterator5.return();
                            }
                        } finally{
                            if (_didIteratorError5) {
                                throw _iteratorError5;
                            }
                        }
                    }
                    return [
                        4,
                        (0,cms_api__WEBPACK_IMPORTED_MODULE_1__/* .fetchEntriesById */ .x5)("reviewer", reviewerIds)
                    ];
                case 3:
                    reviewerEntries = _state.sent();
                    (_experts2 = experts).push.apply(_experts2, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(reviewerEntries.reduce(function(acc, reviewer) {
                        if (!(reviewer === null || reviewer === void 0 ? void 0 : reviewer.fields)) {
                            return acc;
                        }
                        return acc.concat(reviewer.fields);
                    }, [])));
                    return [
                        2,
                        experts
                    ];
            }
        });
    });
    return function fetchExperts(articles, root) {
        return _ref.apply(this, arguments);
    };
}();
var articleLiteFields = "fields.slug,fields.articleName,fields.publishDate,metadata.tags,fields.openGraph";
var articleRichFields = "fields.headerSummary,fields.authors,fields.editors,fields.reviewers";
var articlesLoader = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(function(input, root) {
        var pageProps, loaderReturn, articles, ref, tags, ref1, ref2, ref3, ref4, articlesCollection, totalArticles, missingFields, sentry, ref5, _id, authorIds, authorEntries, ref6;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_10__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    pageProps = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : {
                        paginationIndex: 0
                    };
                    loaderReturn = {
                        authors: [],
                        articles: [],
                        experts: [],
                        tagNamesLookup: [],
                        total: 0
                    };
                    articles = [];
                    if ("items" in input.fields) {
                        ;
                        articles = ((ref = input.fields) === null || ref === void 0 ? void 0 : ref.items) || [];
                    }
                    tags = [];
                    if (!(articles.length === 0)) return [
                        3,
                        2
                    ];
                    tags = (ref3 = input === null || input === void 0 ? void 0 : (ref1 = input.metadata) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.tags) === null || ref2 === void 0 ? void 0 : ref2.filter(function(item) {
                        var ref, ref1;
                        return (item === null || item === void 0 ? void 0 : (ref = item.sys) === null || ref === void 0 ? void 0 : ref.type) === "Link" && (item === null || item === void 0 ? void 0 : (ref1 = item.sys) === null || ref1 === void 0 ? void 0 : ref1.linkType) === "Tag";
                    })) === null || ref3 === void 0 ? void 0 : ref3.map(function(item) {
                        var ref;
                        return item === null || item === void 0 ? void 0 : (ref = item.sys) === null || ref === void 0 ? void 0 : ref.id;
                    });
                    return [
                        4,
                        (0,cms_api__WEBPACK_IMPORTED_MODULE_1__/* .fetchArticlesByTags */ .X$)(tags || (root === null || root === void 0 ? void 0 : root.fields.topics), {
                            select: "".concat(articleLiteFields, ",").concat(articleRichFields),
                            skip: (0,_helpers_pagination__WEBPACK_IMPORTED_MODULE_12__/* .getSkipOffset */ .ur)(pageProps.paginationIndex),
                            limit: ((ref4 = input.fields) === null || ref4 === void 0 ? void 0 : ref4.limit) || ARTICLES_PER_PAGE
                        })
                    ];
                case 1:
                    articlesCollection = _state.sent();
                    articles = (articlesCollection === null || articlesCollection === void 0 ? void 0 : articlesCollection.items) || [];
                    totalArticles = articlesCollection === null || articlesCollection === void 0 ? void 0 : articlesCollection.total;
                    loaderReturn.total = totalArticles;
                    loaderReturn.articles = articles;
                    _state.label = 2;
                case 2:
                    missingFields = loaderReturn.articles.some(function(article) {
                        return !article.fields;
                    });
                    if (missingFields) {
                        sentry = _opendoor_observability_slim__WEBPACK_IMPORTED_MODULE_0__/* .globalObservability.getSentryClient */ .w.getSentryClient();
                        if (sentry !== undefined) {
                            ;
                            (ref5 = sentry.withScope) === null || ref5 === void 0 ? void 0 : ref5.call(sentry, function(scope) {
                                var ref;
                                scope.setContext("Loader Variables", {
                                    pageProps: pageProps,
                                    tags: tags
                                });
                                (ref = sentry.captureMessage) === null || ref === void 0 ? void 0 : ref.call(sentry, "articlesLoader returned undefined articles.fields", "error");
                            });
                        }
                        // fall back to logging to the console just in case
                        // eslint-disable-next-line no-console
                        console.log("articlesLoader returned undefined articles.fields", "error", {
                            data: {
                                input: input,
                                tags: tags,
                                root: root,
                                pageProps: pageProps,
                                articles: loaderReturn.articles
                            }
                        });
                    }
                    authorIds = articles.map(function(a) {
                        var ref, ref1;
                        return (_id = (ref = a.fields) === null || ref === void 0 ? void 0 : (ref1 = ref.authors) === null || ref1 === void 0 ? void 0 : ref1[0].sys.id) !== null && _id !== void 0 ? _id : "";
                    });
                    return [
                        4,
                        (0,cms_api__WEBPACK_IMPORTED_MODULE_1__/* .fetchEntriesById */ .x5)("author", authorIds, {
                            select: "fields.displayName,fields.credential,fields.picture,fields.firstName,fields.lastName"
                        })
                    ];
                case 3:
                    authorEntries = _state.sent();
                    loaderReturn.authors = authorEntries.map(function(author) {
                        return (ref6 = author === null || author === void 0 ? void 0 : author.fields) !== null && ref6 !== void 0 ? ref6 : null;
                    }); // JSON serializer cannot accept undefined value
                    return [
                        4,
                        fetchExperts(articles, root)
                    ];
                case 4:
                    loaderReturn.experts = _state.sent();
                    return [
                        2,
                        loaderReturn
                    ];
            }
        });
    });
    return function articlesLoader(input, root) {
        return _ref.apply(this, arguments);
    };
}();
var RelatedArticles = {
    render: renderArticlesCards,
    loader: articlesLoader
};
/* harmony default export */ __webpack_exports__["ZP"] = (RelatedArticles);


/***/ }),

/***/ 3776:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(31944);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(46523);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(6967);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(7603);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(22470);
/* harmony import */ var _tabler_icons_react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(40796);
/* harmony import */ var _tabler_icons_react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(13431);
/* harmony import */ var swiper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(71911);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(53481);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(swiper_css__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var swiper_css_pagination__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9320);
/* harmony import */ var swiper_css_pagination__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(swiper_css_pagination__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var swiper_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(30719);
/* harmony import */ var _CardCarouselV2_module_css__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(57824);
/* harmony import */ var _CardCarouselV2_module_css__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_CardCarouselV2_module_css__WEBPACK_IMPORTED_MODULE_10__);









var AdaptedArrowLeft = (0,_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_5__/* .adaptExternalIcon */ .f)(_tabler_icons_react__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z);
var AdaptedArrowRight = (0,_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_5__/* .adaptExternalIcon */ .f)(_tabler_icons_react__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z);
var CardCarouselV2 = function(param) {
    var id = param.id, cards = param.cards, columnNumber = param.columnNumber, minHeight = param.minHeight, footerLink = param.footerLink, footerLinkButtonText = param.footerLinkButtonText, layoutTheme = param.layoutTheme, renderCard = param.renderCard, _prependLink = param.prependLink, prependLink = _prependLink === void 0 ? true : _prependLink;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_9__/* .Box */ .x, {
        display: "block",
        pb: "$16",
        className: (_CardCarouselV2_module_css__WEBPACK_IMPORTED_MODULE_10___default().slider),
        "$platform-web": {
            boxSizing: "content-box"
        },
        mx: "auto",
        maxWidth: "$360",
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(swiper_react__WEBPACK_IMPORTED_MODULE_4__/* .Swiper */ .tq, {
                modules: [
                    swiper__WEBPACK_IMPORTED_MODULE_1__/* .Navigation */ .W_,
                    swiper__WEBPACK_IMPORTED_MODULE_1__/* .Pagination */ .tl
                ],
                pagination: {
                    clickable: true,
                    type: "bullets",
                    el: ".swiper-pagination-".concat(id)
                },
                navigation: {
                    prevEl: ".swiper-button-previous-".concat(id),
                    nextEl: ".swiper-button-next-".concat(id)
                },
                slidesPerView: 1.1,
                grabCursor: true,
                watchSlidesProgress: true,
                spaceBetween: 24,
                breakpoints: {
                    640: {
                        slidesPerView: 2
                    },
                    768: {
                        slidesPerView: columnNumber > 2 ? 3 : 2
                    },
                    1200: {
                        slidesPerView: columnNumber
                    }
                },
                children: cards === null || cards === void 0 ? void 0 : cards.map(function(card, idx) {
                    /*#__PURE__*/ return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(swiper_react__WEBPACK_IMPORTED_MODULE_4__/* .SwiperSlide */ .o5, {
                        style: {
                            minHeight: minHeight
                        },
                        children: renderCard === null || renderCard === void 0 ? void 0 : renderCard(card, id)
                    }, idx);
                })
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_11__/* .Row */ .X, {
                justifyContent: "space-between",
                pt: "$8",
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_11__/* .Row */ .X, {
                        gap: "$2half",
                        children: [
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_12__/* .IconButton */ .hU, {
                                size: "medium",
                                variant: "default",
                                icon: {
                                    Component: AdaptedArrowLeft,
                                    label: "Previous slide",
                                    size: 20
                                },
                                className: "swiper-button-previous swiper-button-previous-".concat(id),
                                type: "button",
                                analyticsName: "swiper-button-previous-".concat(id)
                            }),
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_12__/* .IconButton */ .hU, {
                                size: "medium",
                                variant: "default",
                                icon: {
                                    Component: AdaptedArrowRight,
                                    label: "Next slide",
                                    size: 20
                                },
                                className: "swiper-button-next swiper-button-next-".concat(id),
                                type: "button",
                                analyticsName: "swiper-button-next-".concat(id)
                            })
                        ]
                    }),
                    footerLink && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_13__/* .Link */ .r, {
                        analyticsName: "cosmos-multicard-see-all-link",
                        "aria-label": "see all link",
                        variant: layoutTheme === "Dark" ? "secondaryInverse" : "primary",
                        href: prependLink ? "/articles/topic/".concat(footerLink) : footerLink,
                        children: footerLinkButtonText || "See all"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CardCarouselV2);


/***/ }),

/***/ 72622:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ CardSectionHeader; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99534);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(35944);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(76614);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(46523);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(53481);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(swiper_css__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var swiper_css_pagination__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9320);
/* harmony import */ var swiper_css_pagination__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(swiper_css_pagination__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _landing_pages_v2_shared_Typography__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(78837);
/* harmony import */ var _landing_pages_v2_shared_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45972);









function getTypographyTokens(screenSize, titleSize, display) {
    switch(screenSize){
        case "largerThanMD":
            if (titleSize === "Default" && display === "carousel") return {
                title: "$headerMedium",
                subheader: "$bodyLarge"
            };
            if (titleSize === "Large" && display === "carousel") return {
                title: "$displaySmall",
                subheader: "$bodyLarge"
            };
            if (titleSize === "Default" && display === "list") return {
                title: "$headerMedium",
                subheader: "$bodyLarge"
            };
            if (titleSize === "Large" && display === "list") return {
                title: "$displaySmall",
                subheader: "$bodyLarge"
            };
            break;
        case "largerThanSM":
            if (titleSize === "Default" && display === "carousel") return {
                title: "$headerMedium",
                subheader: "$bodyLarge"
            };
            if (titleSize === "Large" && display === "carousel") return {
                title: "$displaySmall",
                subheader: "$bodyLarge"
            };
            if (titleSize === "Default" && display === "list") return {
                title: "$headerMedium",
                subheader: "$bodyLarge"
            };
            if (titleSize === "Large" && display === "list") return {
                title: "$displaySmall",
                subheader: "$bodyLarge"
            };
            break;
        default:
            if (titleSize === "Default" && display === "carousel") return {
                title: "$headerSmall",
                subheader: "$bodyLarge"
            };
            if (titleSize === "Large" && display === "carousel") return {
                title: "$headerMedium",
                subheader: "$bodyLarge"
            };
            if (titleSize === "Default" && display === "list") return {
                title: "$headerSmall",
                subheader: "$bodyLarge"
            };
            if (titleSize === "Large" && display === "list") return {
                title: "$headerMedium",
                subheader: "$bodyLarge"
            };
            return {
                title: "$headerMedium",
                subheader: "$bodyLarge"
            };
    }
    return {
        title: "$headerMedium",
        subheader: "$bodyLarge"
    };
}
var TitleWithAccent = function(_param) {
    var title = _param.title, titleAccent = _param.titleAccent, titleSize = _param.titleSize, titleColor = _param.titleColor, titleAccentColor = _param.titleAccentColor, breakTitles = _param.breakTitles, display = _param.display, typography = _param.typography, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
        "title",
        "titleAccent",
        "titleSize",
        "titleColor",
        "titleAccentColor",
        "breakTitles",
        "display",
        "typography"
    ]);
    var titleTypographyTokens = {
        typography: typography.typography.title,
        $largerThanSM: {
            typography: typography.$largerThanSM.typography.title
        },
        $largerThanMD: {
            typography: typography.$largerThanMD.typography.title
        }
    };
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_6__/* .Text */ .x, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
        tag: "h2"
    }, titleTypographyTokens), {
        display: "block",
        maxWidth: "16ch",
        color: titleColor || "$contentPrimary",
        mb: "$8x"
    }), props), {
        whiteSpace: "normal",
        children: [
            (0,_landing_pages_v2_shared_utils__WEBPACK_IMPORTED_MODULE_3__/* .markdownToReactElement */ .vl)(title || ""),
            breakTitles && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("br", {}),
            titleAccent && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_6__/* .Text */ .x, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
                tag: "span"
            }, titleTypographyTokens), {
                color: titleAccentColor || "$contentTertiary"
            }), props), {
                whiteSpace: "normal",
                children: [
                    " ",
                    (0,_landing_pages_v2_shared_utils__WEBPACK_IMPORTED_MODULE_3__/* .markdownToReactElement */ .vl)(titleAccent)
                ]
            }))
        ]
    }));
};
var CardSectionHeader = function(fields) {
    var titleSize = fields.titleSize, display = fields.display;
    var typography = {
        typography: getTypographyTokens("default", titleSize, display),
        $largerThanSM: {
            typography: getTypographyTokens("largerThanSM", titleSize, display)
        },
        $largerThanMD: {
            typography: getTypographyTokens("largerThanMD", titleSize, display)
        }
    };
    var subHeadTypographyTokens = {
        typography: typography.typography.subheader,
        $largerThanSM: {
            typography: typography.$largerThanSM.typography.subheader
        },
        $largerThanMD: {
            typography: typography.$largerThanMD.typography.subheader
        }
    };
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_9__/* .Box */ .x, {
        gap: "$16x",
        marginBottom: "$16x",
        maxWidth: "$744x",
        children: [
            fields.eyebrow && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_landing_pages_v2_shared_Typography__WEBPACK_IMPORTED_MODULE_2__/* .Eyebrow */ .j4, {
                children: fields.eyebrow
            }),
            fields.title && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(TitleWithAccent, {
                title: fields.title,
                titleAccent: fields.titleAccent,
                titleSize: fields.titleSize,
                typography: typography
            }),
            (fields.subhead || fields.desc) && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_9__/* .Box */ .x, {
                gap: "$4x",
                children: [
                    fields.subhead && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_6__/* .Text */ .x, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
                        tag: "h4",
                        display: "block"
                    }, subHeadTypographyTokens), {
                        fontWeight: "$medium",
                        color: "$contentPrimary",
                        children: fields.subhead
                    })),
                    fields.desc && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_landing_pages_v2_shared_Typography__WEBPACK_IMPORTED_MODULE_2__/* .Desc */ .Xe, {
                        color: "$contentPrimary",
                        $largerThanMD: {
                            fontSize: fields.titleSize === "Large" ? 24 : "unset"
                        },
                        children: fields.desc
                    })
                ]
            })
        ]
    });
};


/***/ }),

/***/ 2310:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ Divider; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(35944);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(46523);



var Divider = function(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .x, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
        tag: "hr",
        margin: 0,
        borderWidth: 0,
        borderTopWidth: 1,
        borderStyle: "solid",
        borderColor: "$borderSecondary",
        width: "100%"
    }, props));
};


/***/ }),

/***/ 63933:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DQ": function() { return /* binding */ getCardArch; },
/* harmony export */   "xu": function() { return /* binding */ CardImage; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(99534);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(70917);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(97009);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(46523);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(86872);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(22470);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(88111);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(76614);
/* harmony import */ var _landing_pages_v2_shared_Buttons__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(44682);
/* harmony import */ var _landing_pages_v2_shared_Sheet__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(78147);
/* harmony import */ var _landing_pages_v2_shared_Typography__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(78837);
/* harmony import */ var _landing_pages_v2_shared_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(45972);











var convertMinHeight = function(value) {
    if (!value) return undefined;
    return parseInt(value.replace("px", ""), 10);
};
var TitleSizeTokens = {
    small: "$bodyXlarge",
    medium: "$subheaderXsmall",
    large: "$subheaderSmall"
};
var getCardArch = function(param) {
    var cardStyle = param.cardStyle, isArched = param.isArched;
    if (cardStyle === "Arch") {
        return true;
    }
    return isArched;
};
var CardImage = function(_param) {
    var isArched = _param.isArched, src = _param.src, alt = _param.alt, columnNumber = _param.columnNumber, backgroundImageSize = _param.backgroundImageSize, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_param, [
        "isArched",
        "src",
        "alt",
        "columnNumber",
        "backgroundImageSize"
    ]);
    return(// eslint-disable-next-line @opendoor/no-html-elements
    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("div", {
        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_7__/* .css */ .iv)("div{background-size:", backgroundImageSize || "cover", ";}"),
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_8__/* .Image */ .E, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, props), {
            source: {
                uri: src,
                height: 180
            },
            flex: 1,
            minHeight: 160,
            $largerThanMD: {
                minHeight: 320
            },
            $largerThanSM: {
                minHeight: 200
            },
            // eslint-disable-next-line no-nested-ternary -- Grandfathered violation
            height: columnNumber ? columnNumber > 3 ? 180 : 240 : 180,
            alt: alt,
            marginLeft: -16,
            maxWidth: "unset",
            width: "calc(100% + 32px)",
            borderTopLeftRadius: isArched ? "$full" : "$12x",
            borderTopRightRadius: isArched ? "$full" : "$12x",
            borderBottomLeftRadius: "$2x",
            borderBottomRightRadius: "$2x"
        }))
    }));
};
var MulticardCard = function(param) {
    var id = param.id, card = param.card, isArched = param.isArched, minHeight = param.minHeight, componentTheme = param.componentTheme, cardVerticalAlignment = param.cardVerticalAlignment, isAccordion = param.isAccordion, columnNumber = param.columnNumber;
    return (card.ctaSheet || card.redirectUrl) && !isAccordion ? /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(CardSheet, {
        card: card,
        minHeight: minHeight,
        isArched: getCardArch({
            cardStyle: card.cardStyle,
            isArched: isArched
        }),
        componentTheme: componentTheme,
        cardVerticalAlignment: cardVerticalAlignment,
        columnNumber: columnNumber
    }) : /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_11__/* .Box */ .x, {
        display: "flex",
        minHeight: minHeight === "auto" ? "auto" : convertMinHeight(minHeight),
        overflow: "hidden",
        borderTopLeftRadius: isArched ? "$full" : "$12x",
        borderTopRightRadius: isArched ? "$full" : "$12x",
        borderBottomLeftRadius: "$12x",
        borderBottomRightRadius: "$12x",
        // eslint-disable-next-line no-nested-ternary -- Grandfathered violation
        paddingTop: card.imageUrl ? "$4x" : cardVerticalAlignment === "center" ? "$12x" : "$44x",
        paddingBottom: "$12x",
        paddingLeft: "$12x",
        paddingRight: "$12x",
        backgroundColor: (0,_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_12__.getToken)("$backgroundTertiary", "color"),
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(MulticardCardDetails, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, card), {
            isArched: getCardArch({
                cardStyle: card.cardStyle,
                isArched: isArched
            }),
            cardVerticalAlignment: cardVerticalAlignment,
            componentTheme: componentTheme,
            redirectUrl: card.redirectUrl,
            isAccordion: isAccordion
        }))
    }, id);
};
var CardSheet = function(param) {
    var card = param.card, isArched = param.isArched, componentTheme = param.componentTheme, cardVerticalAlignment = param.cardVerticalAlignment, columnNumber = param.columnNumber, minHeight = param.minHeight;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), isVisible = ref[0], setIsVisible = ref[1];
    var ctaRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    // When animation is complete
    var exitComplete = function() {
        if (card.ctaSheet) {
            var ref;
            (ref = ctaRef.current) === null || ref === void 0 ? void 0 : ref.focus();
        }
    };
    // Make visual buttons work like Buttons
    var onKeyDown = function(e) {
        if (card.redirectUrl && !card.ctaSheet) {
            e.stopPropagation();
        } else if (e.key === " " || e.key === "Spacebar") {
            setIsVisible(true);
        }
    };
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), playHover = ref1[0], setPlayHover = ref1[1];
    // eslint-disable-next-line no-nested-ternary -- Grandfathered violation
    var paddingTop = card.imageUrl ? "$4x" : cardVerticalAlignment === "center" ? "$12x" : "$44x", paddingBottom = "$12x";
    var _imageLayout = card.imageLayout, imageLayout = _imageLayout === void 0 ? "top" : _imageLayout, _backgroundImageSize = card.backgroundImageSize, backgroundImageSize = _backgroundImageSize === void 0 ? "cover" : _backgroundImageSize;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_11__/* .Box */ .x, {
        "$platform-web": {
            minHeight: minHeight
        },
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_13__/* .Link */ .r, {
                position: "relative",
                display: "flex",
                flexDirection: "column",
                width: "100%",
                height: "100%",
                overflow: "hidden",
                cursor: "pointer",
                borderTopRightRadius: isArched ? "$full" : "$12x",
                borderTopLeftRadius: isArched ? "$full" : "$12x",
                borderBottomLeftRadius: "$12x",
                borderBottomRightRadius: "$12x",
                paddingTop: imageLayout === "top" && backgroundImageSize !== "contain" ? paddingTop : paddingBottom,
                paddingLeft: "$12x",
                paddingRight: "$12x",
                paddingBottom: imageLayout === "top" && backgroundImageSize !== "contain" ? paddingBottom : paddingTop,
                "aria-label": card.ctaSheetLabel || "Open dialog",
                analyticsName: "cosmos-landing-page-multicard-".concat(card.analyticsId),
                outlineColor: "unset",
                href: !card.ctaSheet && card.redirectUrl ? card.redirectUrl : undefined,
                onPress: function() {
                    return card.ctaSheet && setIsVisible(true);
                },
                onPressIn: onKeyDown,
                ref: ctaRef,
                outlineWidth: 0,
                tabIndex: 0,
                backgroundColor: card.backgroundColor || "$backgroundTertiary",
                onMouseEnter: function() {
                    return setPlayHover(true);
                },
                onMouseLeave: function() {
                    return setPlayHover(false);
                },
                children: [
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(MulticardCardDetails, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, card), {
                        isArched: isArched,
                        componentTheme: componentTheme,
                        cardVerticalAlignment: cardVerticalAlignment,
                        analyticsId: card.analyticsId,
                        columnNumber: columnNumber
                    })),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_11__/* .Box */ .x, {
                        position: "absolute",
                        width: "100%",
                        height: "100%",
                        scale: playHover ? 2 : 0,
                        opacity: 0.08,
                        bottom: -200,
                        left: 0,
                        zIndex: 5,
                        animation: "decelerateFast",
                        borderTopRightRadius: "$full",
                        borderTopLeftRadius: "$full",
                        transformOrigin: "center bottom",
                        backgroundColor: "$backgroundInverseStateHoverSecondary"
                    }, "my-square")
                ]
            }),
            card.ctaSheet && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_landing_pages_v2_shared_Sheet__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                entry: card.ctaSheet,
                isVisible: isVisible,
                setIsVisible: setIsVisible,
                exitComplete: exitComplete
            })
        ]
    });
};
var AccordionDetails = function(param) {
    var title = param.title, desc = param.desc;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_14__/* .Accordion */ .U, {
        variant: "regular",
        size: "medium",
        isFullWidth: true,
        analyticsName: "cosmos-multicard-accordion",
        items: [
            {
                title: title,
                description: desc ? /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_15__/* .Text */ .x, {
                    typography: "$bodyMedium",
                    tag: "p",
                    color: "$contentPrimary",
                    children: (0,_landing_pages_v2_shared_utils__WEBPACK_IMPORTED_MODULE_4__/* .markdownToReactElement */ .vl)(desc)
                }) : ""
            }, 
        ]
    });
};
var MulticardCardDetails = function(param) {
    var eyebrow = param.eyebrow, imageUrl = param.imageUrl, title = param.title, subhead = param.subhead, desc = param.desc, ctaDisplayText = param.ctaDisplayText, ctaStyle = param.ctaStyle, isArched = param.isArched, isAccordion = param.isAccordion, componentTheme = param.componentTheme, redirectUrl = param.redirectUrl, analyticsId = param.analyticsId, columnNumber = param.columnNumber, titleSize = param.titleSize, _imageLayout = param.imageLayout, imageLayout = _imageLayout === void 0 ? "top" : _imageLayout, _backgroundImageSize = param.backgroundImageSize, backgroundImageSize = _backgroundImageSize === void 0 ? "cover" : _backgroundImageSize;
    var maxCardTitleLen = 48;
    var ref;
    var truncatedTitle = (ref = title && title.length > maxCardTitleLen ? "".concat(title.slice(0, maxCardTitleLen), "...") : title) !== null && ref !== void 0 ? ref : "";
    var titleSizeToken = TitleSizeTokens[titleSize || "large"];
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_11__/* .Box */ .x, {
        flexDirection: imageLayout === "bottom" ? "column-reverse" : "column",
        children: [
            imageUrl && (redirectUrl ? /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_13__/* .Link */ .r, {
                href: isAccordion ? redirectUrl : undefined,
                "aria-label": title || "",
                analyticsName: "cosmos-landing-page-multicard-".concat(analyticsId),
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(CardImage, {
                    isArched: !!isArched,
                    src: imageUrl,
                    alt: title || "Card Image",
                    flex: 1,
                    zIndex: 5,
                    mb: imageLayout === "top" && backgroundImageSize !== "contain" ? "$16x" : undefined,
                    columnNumber: columnNumber,
                    backgroundImageSize: backgroundImageSize
                })
            }) : /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(CardImage, {
                isArched: !!isArched,
                src: imageUrl,
                alt: title || "",
                flex: 1,
                zIndex: 5,
                mb: imageLayout === "top" && backgroundImageSize !== "contain" ? "$16x" : undefined,
                columnNumber: columnNumber,
                backgroundImageSize: backgroundImageSize
            })),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_11__/* .Box */ .x, {
                flex: 1,
                children: isAccordion ? /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(AccordionDetails, {
                    title: truncatedTitle,
                    desc: desc || ""
                }) : /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsxs */ .BX)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .Fragment */ .HY, {
                    children: [
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_11__/* .Box */ .x, {
                            zIndex: 5,
                            display: "flex",
                            children: [
                                eyebrow && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_landing_pages_v2_shared_Typography__WEBPACK_IMPORTED_MODULE_3__/* .Eyebrow */ .j4, {
                                    mb: 2,
                                    children: eyebrow
                                }),
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_15__/* .Text */ .x, {
                                    typography: titleSizeToken,
                                    fontWeight: "$medium",
                                    tag: "h3",
                                    color: "$contentPrimary",
                                    mb: 5,
                                    children: truncatedTitle
                                })
                            ]
                        }),
                        subhead && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_15__/* .Text */ .x, {
                            tag: "p",
                            typography: "$bodyMedium",
                            color: "$contentPrimary",
                            fontWeight: "$medium",
                            children: subhead
                        }),
                        desc && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_15__/* .Text */ .x, {
                            typography: "$bodyMedium",
                            tag: "p",
                            color: "$contentPrimary",
                            children: (0,_landing_pages_v2_shared_utils__WEBPACK_IMPORTED_MODULE_4__/* .markdownToReactElement */ .vl)(desc)
                        }),
                        ctaDisplayText && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_landing_pages_v2_shared_Buttons__WEBPACK_IMPORTED_MODULE_1__/* .LPFauxBtn */ .B, {
                            componentTheme: componentTheme,
                            ctaDisplayText: ctaDisplayText,
                            ctaStyle: ctaStyle,
                            mt: "$5"
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["ZP"] = (MulticardCard);


/***/ }),

/***/ 52683:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(46523);
/* harmony import */ var _MulticardCard__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(63933);
/* harmony import */ var _MulticardList_module_css__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(82994);
/* harmony import */ var _MulticardList_module_css__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_MulticardList_module_css__WEBPACK_IMPORTED_MODULE_4__);





var MulticardList = function(param) {
    var cards = param.cards, componentTheme = param.componentTheme, columnNumber = param.columnNumber, isArched = param.isArched, isAccordion = param.isAccordion, minHeight = param.minHeight, cardVerticalAlignment = param.cardVerticalAlignment;
    /*#__PURE__*/ return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .x, {
        tag: "ul",
        m: "$0",
        p: "$0",
        role: "list",
        gap: "$4",
        className: (_MulticardList_module_css__WEBPACK_IMPORTED_MODULE_4___default().list),
        style: {
            "--column-number": columnNumber
        },
        children: cards === null || cards === void 0 ? void 0 : cards.map(function(card, idx) {
            return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(_MulticardCard__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP, {
                card: card,
                id: "".concat(idx),
                componentTheme: componentTheme,
                isArched: isArched,
                isAccordion: isAccordion,
                minHeight: minHeight,
                cardVerticalAlignment: cardVerticalAlignment,
                columnNumber: columnNumber
            }, idx);
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (MulticardList);


/***/ }),

/***/ 4618:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(97582);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(52007);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(37122);
/* harmony import */ var _opendoor_cinderblocks_core_AddressInput__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87028);
/* harmony import */ var _opendoor_observability_slim__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(74593);
/* harmony import */ var helpers_observability__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(49048);
/* harmony import */ var helpers_queryParams__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(43552);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _components_landing_pages_v2_AddressConfirmationModal__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(75569);
/* harmony import */ var _helpers_AddressValidationContext__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(8345);













var ManualEntryButton = function(param) {
    var onMouseDown = param.onMouseDown, onPress = param.onPress;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_9__/* .TextButton */ .A, {
        onMouseDown: onMouseDown,
        label: "Enter address manually instead",
        analyticsName: "cosmos-address-input-manual-entry",
        type: "button",
        onPress: onPress,
        width: "100%",
        variant: "primary",
        size: "medium",
        px: "$5",
        pt: "$2half",
        pb: "$5"
    });
};
var NewSellerFlowAddressInput = function(param) {
    var actionButton = param.actionButton, channel = param.channel, hideLabel = param.hideLabel, icon = param.icon, inputLocation = param.inputLocation, pageSetPath = param.pageSetPath, placeholder = param.placeholder, trackingKeywords = param.trackingKeywords, trackingTaxonomy = param.trackingTaxonomy, _size = param.size, size = _size === void 0 ? "large" : _size;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_5__.useRouter)();
    var trackJourneyEvent = (0,helpers_observability__WEBPACK_IMPORTED_MODULE_3__/* .useObservability */ .C3)().trackJourneyEvent;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(""), searchTerm = ref[0], setSearchTerm = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), isFocused = ref1[0], setIsFocused = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), isConfirmationModalOpen = ref2[0], setIsConfirmationModalOpen = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)([]), predictions = ref3[0], setPredictions = ref3[1];
    var ref4 = (0,_helpers_AddressValidationContext__WEBPACK_IMPORTED_MODULE_7__/* .useAddressValidationContext */ .oK)(), validatedAddress = ref4.validatedAddress, setValidatedAddress = ref4.setValidatedAddress, setAddressResults = ref4.setAddressResults, setFirstPrediction = ref4.setFirstPrediction, setPartnerReferralId = ref4.setPartnerReferralId, setPageSetPath = ref4.setPageSetPath, setTrackingKeywords = ref4.setTrackingKeywords, setChannel = ref4.setChannel;
    var partner_referral = (0,helpers_queryParams__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)().partner_referral;
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (partner_referral) {
            setPartnerReferralId(partner_referral);
        }
        if (pageSetPath) {
            setPageSetPath(pageSetPath);
        }
        if (trackingKeywords) {
            setTrackingKeywords(trackingKeywords);
        }
        if (channel) {
            setChannel(channel);
        }
    }, [
        partner_referral,
        pageSetPath,
        trackingKeywords,
        channel
    ]);
    var handleMouseDown = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(e) {
        e.preventDefault();
    }, []);
    var handleManualEntryPress = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        router.push({
            pathname: "/manual-address-entry",
            query: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, trackingKeywords != null && {
                trackingKeywords: trackingKeywords
            }, partner_referral != null && {
                partnerReferralId: partner_referral
            }, pageSetPath != null && {
                pageSetPath: pageSetPath
            }, channel != null && {
                channel: channel
            })
        });
    }, [
        router,
        trackingKeywords,
        partner_referral,
        pageSetPath,
        channel
    ]);
    var handleFocus = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        setIsFocused(true);
    }, []);
    var handleBlur = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        setIsFocused(false);
    }, []);
    var handlePredictionsChange = function(newPredictions) {
        setPredictions(newPredictions);
        if (newPredictions.length > 0) {
            setFirstPrediction(newPredictions[0]);
        }
    };
    var handleSearchTermChange = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(newSearchTerm) {
        setSearchTerm(newSearchTerm);
    }, []);
    var customAction = predictions.length < 5 && searchTerm !== "" && isFocused ? /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(ManualEntryButton, {
        onMouseDown: handleMouseDown,
        onPress: handleManualEntryPress
    }) : undefined;
    var handleAddressValidated = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(function(validationResult) {
            var validatedAddr, results, needsManualEntry, needsUnitSelection, selectedAddress;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_12__.__generator)(this, function(_state) {
                validatedAddr = validationResult.address, results = validationResult.results, needsManualEntry = validationResult.needsManualEntry, needsUnitSelection = validationResult.needsUnitSelection;
                selectedAddress = {
                    id: validatedAddr.id,
                    street1: validatedAddr.street1,
                    city: validatedAddr.city,
                    state: validatedAddr.state,
                    postal_code: validatedAddr.postal_code,
                    unit: validatedAddr.unit,
                    latitude: validatedAddr.latitude,
                    longitude: validatedAddr.longitude,
                    result: results,
                    source: validatedAddr.source
                };
                setAddressResults(results);
                setValidatedAddress(selectedAddress);
                // Redirect to manual entry if needed
                if (needsManualEntry) {
                    router.push({
                        pathname: "/manual-address-entry",
                        query: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({
                            address: JSON.stringify(selectedAddress),
                            result: results
                        }, partner_referral != null && {
                            partnerReferralId: partner_referral
                        }, pageSetPath != null && {
                            pageSetPath: pageSetPath
                        }, trackingKeywords != null && {
                            trackingKeywords: trackingKeywords
                        }, channel != null && {
                            channel: channel
                        })
                    });
                    return [
                        2
                    ];
                }
                // Show confirmation modal if unit selection is needed
                if (needsUnitSelection) {
                    setIsConfirmationModalOpen(true);
                    return [
                        2
                    ];
                }
                setIsConfirmationModalOpen(true);
                return [
                    2
                ];
            });
        });
        return function handleAddressValidated(validationResult) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleError = function(error) {
        var _obj, ref;
        (ref = (_obj = _opendoor_observability_slim__WEBPACK_IMPORTED_MODULE_2__/* .globalObservability.getSentryClient */ .w.getSentryClient()).captureException) === null || ref === void 0 ? void 0 : ref.call(_obj, error);
    };
    var handleAddressSelect = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(function(address) {
            var ref;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_12__.__generator)(this, function(_state) {
                try {
                    ;
                    // Track analytics - flush immediately since navigation follows shortly
                    trackJourneyEvent("sell", "addressEntryV2", {
                        street1: address.street1,
                        city: address.city,
                        state: address.state,
                        postalCode: address.postal_code,
                        unit: address.unit,
                        latitude: address.latitude,
                        longitude: address.longitude,
                        sourcePage: router.asPath,
                        campaign: (ref = router.query) === null || ref === void 0 ? void 0 : ref.utm_campaign
                    }, {
                        flush: true
                    });
                } catch (e) {
                    handleError(e);
                }
                return [
                    2
                ];
            });
        });
        return function handleAddressSelect(address) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_13__/* .Col */ .J, {
        flex: 1,
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_13__/* .Col */ .J, {
                className: "od-address-input",
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_13__/* .Col */ .J, {
                    position: "relative",
                    className: "cta-input-form",
                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(_opendoor_cinderblocks_core_AddressInput__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                        id: "home-address-input",
                        label: "Enter your home address",
                        hideLabel: hideLabel,
                        placeholder: placeholder,
                        disabled: false,
                        onAddressSelect: handleAddressSelect,
                        onAddressValidated: handleAddressValidated,
                        validateAddress: true,
                        onError: handleError,
                        onPredictionsChange: handlePredictionsChange,
                        onSearchTermChange: handleSearchTermChange,
                        onFocus: handleFocus,
                        onBlur: handleBlur,
                        customAction: customAction,
                        listBoxId: "cb1-listbox",
                        listBoxAriaLabel: "addresses",
                        actionButton: actionButton,
                        icon: icon,
                        size: size
                    })
                })
            }),
            isConfirmationModalOpen && validatedAddress && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(_components_landing_pages_v2_AddressConfirmationModal__WEBPACK_IMPORTED_MODULE_6__/* .AddressConfirmationModal */ .Xo, {
                setIsOpen: setIsConfirmationModalOpen,
                isOpen: isConfirmationModalOpen,
                partnerReferralId: partner_referral,
                initialAddress: validatedAddress,
                pageSetPath: pageSetPath,
                trackingKeywords: trackingKeywords,
                channel: channel,
                inputLocation: inputLocation,
                trackingTaxonomy: trackingTaxonomy
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (NewSellerFlowAddressInput);


/***/ }),

/***/ 29212:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$c": function() { return /* binding */ generatePresetPictureSetProps; },
/* harmony export */   "eY": function() { return /* binding */ generatePresetPictureSet; },
/* harmony export */   "t": function() { return /* binding */ Picture; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35944);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(46523);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_0__);






var Picture = function(param) {
    var preload = param.preload, lazy = param.lazy, borderRadius = param.borderRadius, sources = param.sources, _objectFit = param.objectFit, objectFit = _objectFit === void 0 ? "cover" : _objectFit, fetchPriority = param.fetchPriority, _alt = param.alt, alt = _alt === void 0 ? "" : _alt;
    var pictureElement = /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsxs */ .BX)("picture", {
        style: {
            height: "100%",
            width: "100%"
        },
        children: [
            sources.map(function(param) {
                var srcSet = param.srcSet, media = param.media, key = param.key;
                return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("source", {
                    srcSet: srcSet,
                    media: media
                }, "".concat(key, "-source"));
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("img", {
                src: "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7",
                style: {
                    objectFit: objectFit,
                    width: "100%",
                    height: "100%"
                },
                alt: alt,
                loading: lazy ? "lazy" : undefined,
                // @ts-expect-error: fetchpriority is a valid attribute but missing from React 18 types
                fetchpriority: fetchPriority
            })
        ]
    });
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsxs */ .BX)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .Fragment */ .HY, {
        children: [
            preload && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)((next_head__WEBPACK_IMPORTED_MODULE_0___default()), {
                children: sources.map(function(param) {
                    var srcSet = param.srcSet, media = param.media, key = param.key;
                    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("link", {
                        rel: "preload",
                        as: "image",
                        href: "",
                        // @ts-expect-error: react incorrectly capitalizes this if you use
                        // the "typescript" suggestion of `imgSrcSet`
                        imagesrcset: srcSet,
                        media: media,
                        fetchpriority: fetchPriority !== null && fetchPriority !== void 0 ? fetchPriority : "high"
                    }, "".concat(key, "-preload"));
                })
            }),
            borderRadius ? /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .x, {
                overflow: "hidden",
                borderRadius: borderRadius,
                height: "100%",
                width: "100%",
                children: pictureElement
            }) : pictureElement
        ]
    });
};
var generatePresetPictureSetProps = function(_param) {
    var photoUrl = _param.photoUrl, sizes = _param.sizes, borderRadius = _param.borderRadius, lazy = _param.lazy, _dpr = _param.dpr, dpr = _dpr === void 0 ? [
        1,
        2,
        3
    ] : _dpr, _preload = _param.preload, preload = _preload === void 0 ? false : _preload, objectFit = _param.objectFit, fetchPriority = _param.fetchPriority, quality = _param.quality, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "photoUrl",
        "sizes",
        "borderRadius",
        "lazy",
        "dpr",
        "preload",
        "objectFit",
        "fetchPriority",
        "quality"
    ]);
    // sort in reverse because <source> matches in order, required to use
    // the min-width selectors
    var sortedSizes = sizes.sort(function(a, b) {
        return a.minWidth <= b.minWidth ? -1 : 1;
    });
    var sources = sortedSizes.map(function(param) {
        var minWidth = param.minWidth, maxWidth = param.maxWidth, preset = param.preset, presetScale = param.presetScale;
        var paramsRecord = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
            preset: preset
        }, presetScale ? {
            presetScale: presetScale
        } : {}), {
            service: "cosmos",
            auto: "format,compress"
        }), quality !== undefined ? {
            q: "".concat(quality)
        } : {});
        var srcSet = dpr && (dpr === null || dpr === void 0 ? void 0 : dpr.length) > 0 ? dpr.map(function(d) {
            var finalParams = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, paramsRecord), {
                dpr: "".concat(d)
            });
            return "".concat(photoUrl, "?").concat(new URLSearchParams(finalParams).toString(), " ").concat(d, "x");
        }).join(", ") : "".concat(photoUrl, "?").concat(new URLSearchParams(paramsRecord).toString());
        var media = maxWidth === null ? "(min-width: ".concat(minWidth, "px)") : "(min-width: ".concat(minWidth, "px) and (max-width: ").concat(maxWidth - 1, "px)");
        return {
            srcSet: srcSet,
            media: media,
            key: "".concat(photoUrl, "-").concat(minWidth)
        };
    });
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        photoUrl: photoUrl,
        preload: preload,
        lazy: lazy,
        borderRadius: borderRadius,
        sources: sources,
        objectFit: objectFit,
        fetchPriority: fetchPriority
    }, props);
};
var generatePresetPictureSet = function(props) {
    var ref = generatePresetPictureSetProps(props), photoUrl = ref.photoUrl, preload = ref.preload, lazy = ref.lazy, borderRadius = ref.borderRadius, sources = ref.sources, objectFit = ref.objectFit, fetchPriority = ref.fetchPriority, alt = ref.alt;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(Picture, {
        preload: preload,
        lazy: lazy,
        borderRadius: borderRadius,
        sources: sources,
        objectFit: objectFit,
        fetchPriority: fetchPriority,
        alt: alt
    }, photoUrl);
};


/***/ }),

/***/ 78223:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ useReturnExperienceContext; },
/* harmony export */   "Q": function() { return /* binding */ ReturnExperienceContextProvider; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _returnExperience__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82993);



var ReturnExperienceContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({
    returnExperienceData: null,
    showReturnExperience: false
});
var ReturnExperienceContextProvider = function(param) {
    var children = param.children, showReturnExperience = param.showReturnExperience;
    var returnExperienceData = (0,_returnExperience__WEBPACK_IMPORTED_MODULE_1__/* .useReturnExperience */ .lM)().returnExperienceData;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(ReturnExperienceContext.Provider, {
        value: {
            returnExperienceData: returnExperienceData,
            showReturnExperience: showReturnExperience
        },
        children: children
    });
};
var useReturnExperienceContext = function() {
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(ReturnExperienceContext);
};


/***/ }),

/***/ 88279:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$_": function() { return /* binding */ PAGE_ITEMS_LIMIT; },
/* harmony export */   "lA": function() { return /* binding */ getPaginationForData; },
/* harmony export */   "ur": function() { return /* binding */ getSkipOffset; }
/* harmony export */ });
var PAGE_ITEMS_LIMIT = 16;
var PAGINATION_CONTENT_TYPES = [
    "componentRelatedArticles",
    "componentRelatedExternalLinks",
    "lpComponentMulticard", 
];
/*
 * Returns an object with:
 * - Key: Content model ID e.g. componentRelatedArticles
 * - Value: Array of sys IDs for this content model type
 */ function createEmbeddedContentToSysIdsMap(document) {
    var ref;
    var initMap = Object.fromEntries(PAGINATION_CONTENT_TYPES.map(function(item) {
        return [
            item,
            []
        ];
    }));
    return document === null || document === void 0 ? void 0 : (ref = document.content) === null || ref === void 0 ? void 0 : ref.reduce(function(result, current) {
        var ref, ref1, ref2, ref3, ref4;
        var componentType = current === null || current === void 0 ? void 0 : (ref = current.data) === null || ref === void 0 ? void 0 : (ref1 = ref.target) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.sys) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.contentType) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.sys) === null || ref4 === void 0 ? void 0 : ref4.id;
        if ((current === null || current === void 0 ? void 0 : current.nodeType) === "embedded-entry-block" && (PAGINATION_CONTENT_TYPES === null || PAGINATION_CONTENT_TYPES === void 0 ? void 0 : PAGINATION_CONTENT_TYPES.includes(componentType))) {
            var ref5, ref6, ref7;
            var componentSysId = current === null || current === void 0 ? void 0 : (ref5 = current.data) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.target) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.sys) === null || ref7 === void 0 ? void 0 : ref7.id;
            result[componentType].push(componentSysId);
        }
        return result;
    }, initMap);
}
/*
 * Topic page currently supports pagination for embedded entry blocks only when
 * the body contains only 1 type of related content (e.g. componentRelatedArticles,
 * componentRelatedExternalLinks). For example, pagination will NOT be shown if
 * the topic page body has 2 related article entries.
 */ function getPaginationForData(props, initCurrentPage) {
    var ref, ref1;
    var pagination = {};
    var embeddedContentMap = createEmbeddedContentToSysIdsMap(props.fields.body) || {};
    (ref = Object.keys(embeddedContentMap)) === null || ref === void 0 ? void 0 : ref.forEach(function(key) {
        var ref;
        var contentType = key;
        if (((ref = embeddedContentMap[contentType]) === null || ref === void 0 ? void 0 : ref.length) !== 1) {
            // Filter out any content types that don't have only 1 instance of it
            delete embeddedContentMap[contentType];
        }
    });
    var loaderDataId; // We use the loader data ID to get the total number of items for this content type
    if (((ref1 = Object.keys(embeddedContentMap)) === null || ref1 === void 0 ? void 0 : ref1.length) === 1) {
        var contentType = Object.keys(embeddedContentMap)[0];
        loaderDataId = embeddedContentMap[contentType][0];
        if (props.idToLoaderData[loaderDataId]) {
            var ref2;
            var total = ((ref2 = props.idToLoaderData[loaderDataId]) === null || ref2 === void 0 ? void 0 : ref2.total) || 0;
            pagination = getPaginationState(total, initCurrentPage);
        }
    }
    return pagination;
}
function getPaginationState(totalItems, initCurrentPage) {
    var lastPage = Math.ceil(totalItems / PAGE_ITEMS_LIMIT);
    var currentPage = initCurrentPage && initCurrentPage > 0 && initCurrentPage <= lastPage ? initCurrentPage : 1;
    return {
        showPagination: totalItems > PAGE_ITEMS_LIMIT,
        currentPage: currentPage,
        lastPage: lastPage,
        previousPage: currentPage > 1 ? currentPage - 1 : 0,
        nextPage: currentPage < lastPage ? currentPage + 1 : lastPage
    };
}
function getSkipOffset(pageIndex) {
    var skipMultiplier = pageIndex === 1 ? 0 : pageIndex - 1;
    var skip = skipMultiplier * PAGE_ITEMS_LIMIT;
    return skip;
}


/***/ }),

/***/ 82993:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ ExperienceType; },
/* harmony export */   "lM": function() { return /* binding */ useReturnExperience; }
/* harmony export */ });
/* unused harmony export getReturnExperienceData */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(97582);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36808);
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(js_cookie__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _components_api__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(61661);





var fetchSellerReturnExperience = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function() {
        var sellerInputUUID, response, returnExperienceData;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    sellerInputUUID = js_cookie__WEBPACK_IMPORTED_MODULE_1___default().get("sellerInputUUID") || localStorage.getItem("sellerInputUUID");
                    if (!sellerInputUUID) {
                        return [
                            2
                        ];
                    }
                    localStorage.setItem("sellerInputUUID", sellerInputUUID);
                    return [
                        4,
                        _components_api__WEBPACK_IMPORTED_MODULE_2__/* .fetchSellerReturnExperience */ .cv(sellerInputUUID)
                    ];
                case 1:
                    response = _state.sent();
                    if (!response || !response.data) {
                        return [
                            2
                        ];
                    }
                    returnExperienceData = getReturnExperienceData(response.data, sellerInputUUID);
                    if (returnExperienceData.experienceType === null) {
                        return [
                            2
                        ];
                    }
                    return [
                        2,
                        {
                            returnExperienceData: returnExperienceData
                        }
                    ];
            }
        });
    });
    return function fetchSellerReturnExperience() {
        return _ref.apply(this, arguments);
    };
}();
var buildAddress = function(street, unitType, unitNumber, city, state, postalCode) {
    var address = "";
    if (street && unitNumber) {
        address = "".concat(street, " ").concat(unitType, " ").concat(unitNumber, ",");
    } else if (street) {
        address = "".concat(street);
    }
    if (city) {
        address += ", ".concat(city, ",");
    }
    if (state) {
        address += " ".concat(state);
    }
    if (postalCode) {
        address += " ".concat(postalCode);
    }
    return address;
};
var ExperienceType;
(function(ExperienceType) {
    ExperienceType[ExperienceType["offer_expired"] = 0] = "offer_expired";
    ExperienceType[ExperienceType["incomplete_flow"] = 1] = "incomplete_flow";
    ExperienceType[ExperienceType["offer_expiring"] = 2] = "offer_expiring";
    ExperienceType[ExperienceType["offer_decreased"] = 3] = "offer_decreased";
    ExperienceType[ExperienceType["offer_increased"] = 4] = "offer_increased";
    ExperienceType[ExperienceType["active_offer"] = 5] = "active_offer";
    ExperienceType[ExperienceType["direct_mailer"] = 6] = "direct_mailer";
})(ExperienceType || (ExperienceType = {}));
var OFFER_EXPIRY_DAYS_CUTOFF = 4;
var getReturnExperienceData = function(data, sellerInputUUID) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16;
    if (!((ref = data.sellDirect) === null || ref === void 0 ? void 0 : ref.getLead) && !((ref1 = data.reception) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.getSellerInput) === null || ref2 === void 0 ? void 0 : ref2.sellerInput.address)) {
        return {
            experienceType: null
        };
    }
    var answers = (ref3 = data.reception.getSellerInput) === null || ref3 === void 0 ? void 0 : ref3.sellerInput.answers;
    var productOfferings = (ref4 = data.reception.getSellerInput) === null || ref4 === void 0 ? void 0 : ref4.sellerInput.productOfferings;
    var sellDirectProductOffering = productOfferings === null || productOfferings === void 0 ? void 0 : productOfferings.find(function(po) {
        return po.product === "OPENDOOR_DIRECT";
    });
    var sellDirectDenied = sellDirectProductOffering === null || sellDirectProductOffering === void 0 ? void 0 : sellDirectProductOffering.deniedAt;
    // If the lead is denied for sell direct then there is no return experience for them.
    if (sellDirectDenied) {
        return {
            experienceType: null
        };
    }
    var sellerInputAddress = (ref5 = data.reception.getSellerInput) === null || ref5 === void 0 ? void 0 : ref5.sellerInput.address;
    var addressFull = buildAddress(sellerInputAddress.street, sellerInputAddress.unitType, sellerInputAddress.unitNumber, sellerInputAddress.city, sellerInputAddress.state, sellerInputAddress.postalCode);
    // Without an email the lead could not have qualified and thus we want to show the incomplete experience at this stage
    if (!answers.email) {
        var ref17, ref18;
        return {
            sellerInputUUID: sellerInputUUID,
            address: (ref17 = data.reception.getSellerInput) === null || ref17 === void 0 ? void 0 : ref17.sellerInput.address.street,
            addressFull: addressFull,
            experienceType: ExperienceType.incomplete_flow,
            sellerFlowLastCompletedSlug: (ref18 = data.reception.getSellerInput) === null || ref18 === void 0 ? void 0 : ref18.sellerInput.sellerFlowLastCompletedSlug
        };
    }
    // Check if the lead was qualified in web
    var hasSellDirectExperience = (ref6 = data.sellDirect.getLead) === null || ref6 === void 0 ? void 0 : ref6.lead.isQualified;
    if (!hasSellDirectExperience) {
        return {
            experienceType: null
        };
    }
    // user has a sell direct offer
    var lead = (ref7 = data.sellDirect.getLead) === null || ref7 === void 0 ? void 0 : ref7.lead;
    var address = (ref8 = lead.address) === null || ref8 === void 0 ? void 0 : ref8.street;
    var addressToken = (ref9 = lead.address) === null || ref9 === void 0 ? void 0 : ref9.uuid;
    var customerUUID = (ref10 = lead.customerV2) === null || ref10 === void 0 ? void 0 : ref10.uuid;
    var firstName = (ref11 = lead.customerV2) === null || ref11 === void 0 ? void 0 : ref11.firstName;
    var offerRequestSource = (ref12 = lead.latestOffer) === null || ref12 === void 0 ? void 0 : ref12.offerRequestSource;
    var currentOfferHeadlinePriceCents = (ref13 = lead.latestOffer) === null || ref13 === void 0 ? void 0 : ref13.headlinePriceCents;
    var previousOfferHeadlinePriceCents = (ref14 = lead.previousOffer) === null || ref14 === void 0 ? void 0 : ref14.headlinePriceCents;
    var offerState = (ref15 = lead.latestOffer) === null || ref15 === void 0 ? void 0 : ref15.state;
    var offerExpiresAt = (ref16 = lead.latestOffer) === null || ref16 === void 0 ? void 0 : ref16.preliminaryOfferExpirationDate;
    var isQualifiedLead = lead.isQualified;
    var offerExpiresInDays = undefined;
    if (offerExpiresAt) {
        var currentTime = new Date().getTime();
        var expirationTime = Date.parse(offerExpiresAt);
        // convert the milliseconds time difference into days and round up to nearest number of days
        offerExpiresInDays = Math.ceil((expirationTime - currentTime) / (1000 * 3600 * 24));
    }
    var experienceType = null;
    if (offerState == "EXPIRED" && isQualifiedLead) {
        // let's only set the experience type to be "offer_expired" when we know that this lead is eligible for offer refresh (qualified for opendoor direct)
        experienceType = ExperienceType.offer_expired;
    } else if (offerState == "SENT" && offerExpiresInDays && offerExpiresInDays > 0 && offerExpiresInDays <= OFFER_EXPIRY_DAYS_CUTOFF) {
        experienceType = ExperienceType.offer_expiring;
    } else if (offerState == "SENT" && currentOfferHeadlinePriceCents && previousOfferHeadlinePriceCents && currentOfferHeadlinePriceCents - previousOfferHeadlinePriceCents >= 1000) {
        experienceType = ExperienceType.offer_increased;
    } else if (offerState == "SENT" && currentOfferHeadlinePriceCents && previousOfferHeadlinePriceCents && currentOfferHeadlinePriceCents < previousOfferHeadlinePriceCents) {
        experienceType = ExperienceType.offer_decreased;
    } else if (offerState == "SENT") {
        experienceType = ExperienceType.active_offer;
    }
    return {
        sellerInputUUID: sellerInputUUID,
        address: address,
        addressFull: addressFull,
        addressToken: addressToken,
        customerUUID: customerUUID,
        firstName: firstName,
        offerRequestSource: offerRequestSource,
        currentOfferHeadlinePriceCents: currentOfferHeadlinePriceCents,
        previousOfferHeadlinePriceCents: previousOfferHeadlinePriceCents,
        offerExpiresInDays: offerExpiresInDays,
        experienceType: experienceType
    };
};
// Custom hook to handle fetching return experience logic
var useReturnExperience = function() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)({
        experienceType: null
    }), returnExperienceData = ref[0], setReturnExperienceData = ref[1];
    var returnExperienceShown = returnExperienceData.experienceType !== null;
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        function start() {
            return _start.apply(this, arguments);
        }
        function _start() {
            _start = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function() {
                var result;
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                fetchSellerReturnExperience()
                            ];
                        case 1:
                            result = _state.sent();
                            if (!result) {
                                return [
                                    2
                                ];
                            }
                            setReturnExperienceData(result.returnExperienceData);
                            return [
                                2
                            ];
                    }
                });
            });
            return _start.apply(this, arguments);
        }
        start();
    }, []);
    return {
        returnExperienceData: returnExperienceData,
        returnExperienceShown: returnExperienceShown
    };
};


/***/ }),

/***/ 69109:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"heroImageWrapper":"HeroV2_heroImageWrapper___mRK8","heroLeftGradient":"HeroV2_heroLeftGradient__keay8","heroTopGradient":"HeroV2_heroTopGradient__WhS_j","treatmentImageWrapper":"HeroV2_treatmentImageWrapper__qjH34"};

/***/ }),

/***/ 84327:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"reveal":"StickyCTAUtility_reveal__dnjbT","hide":"StickyCTAUtility_hide__m_YNZ","container":"StickyCTAUtility_container__QsIih"};

/***/ }),

/***/ 88218:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"lpButton":"Buttons_lpButton__keCak"};

/***/ }),

/***/ 89785:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"markerPulse":"Marker_markerPulse__CKEK_","marker-pulse":"Marker_marker-pulse__h9kgv","markerFadeIn":"Marker_markerFadeIn__2mAxD","marker-fade-in":"Marker_marker-fade-in__MUDJR"};

/***/ }),

/***/ 57824:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"slider":"CardCarouselV2_slider__0eSSc"};

/***/ }),

/***/ 82994:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"list":"MulticardList_list__JOGOw"};

/***/ }),

/***/ 50247:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 24654:
/***/ (function() {

/* (ignored) */

/***/ })

}]);